export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never;
};
export type Incremental<T> =
  T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  /** A scalar type that represents an RGB color as hex code. */
  ColorCode: { input: any; output: any };
  /**
   * The `DateTime` scalar type represents a date and time in the UTC
   * timezone. The DateTime appears in a JSON response as an ISO8601 formatted
   * string, including UTC timezone ("Z"). The parsed date and time string will
   * be converted to UTC if there is an offset.
   */
  DateTime: { input: any; output: any };
  /**
   * The `Decimal` scalar type represents signed double-precision fractional
   * values parsed by the `Decimal` library. The Decimal appears in a JSON
   * response as a string to preserve precision.
   */
  Decimal: { input: any; output: any };
  /** A money type. */
  Money: { input: any; output: any };
};

/** Details for a file attachment such as an image, video or document. */
export type Attachment = {
  /** Flag that indicates that this attachment is the hero image. There can only be one hero image in a set of attachments */
  isHeroImage?: Maybe<Scalars['Boolean']['output']>;
  /** The attachment name that may be optionally specified as a caption. */
  name?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the attachment is stored in Goliath or externally. */
  remote?: Maybe<Scalars['Boolean']['output']>;
  /** List of different media sources to use instead of the main url */
  sources?: Maybe<Array<Maybe<MediaSource>>>;
  /** The thumbnail image URL if one is available. */
  thumbImageUrl?: Maybe<Scalars['String']['output']>;
  /** The type of the attachment. */
  type?: Maybe<AttachmentType>;
  /** The URL to the attached file. */
  url?: Maybe<Scalars['String']['output']>;
};

/** Details for a file attachment such as an image, video or document. */
export type AttachmentSourcesArgs = {
  maxHeight?: InputMaybe<Scalars['Int']['input']>;
  maxWidth?: InputMaybe<Scalars['Int']['input']>;
  mimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  minHeight?: InputMaybe<Scalars['Int']['input']>;
  minWidth?: InputMaybe<Scalars['Int']['input']>;
};

/** An enumeration containing available attachment types. */
export enum AttachmentType {
  /** Indicates the attachment is a user manual. */
  Document = 'DOCUMENT',
  /** Indicates the attachment is an image. */
  Image = 'IMAGE',
  /** Indicates the attachment is a video. */
  Video = 'VIDEO',
}

/** An object containing brand details. */
export type Brand = {
  __typename?: 'Brand';
  /** The brand logo. */
  logo?: Maybe<Attachment>;
  /** The name of the brand. */
  name?: Maybe<Scalars['String']['output']>;
  /** The popularity of the brand. */
  popularity?: Maybe<Scalars['Int']['output']>;
  /** The slug of the brand. */
  slug?: Maybe<Scalars['String']['output']>;
};

/** An object containing details for a bundle product. */
export type BundleProduct = Product & {
  __typename?: 'BundleProduct';
  /** Flag which sets awlays_displayed property */
  alwaysDisplayed?: Maybe<Scalars['Boolean']['output']>;
  /** A unique article number for the product. This is not neccessarily the same as the EAN. It is an internal identifier that is used to identify a product or bundle. */
  articleNumber?: Maybe<Scalars['String']['output']>;
  /** Details about the availability of the product. */
  availability?: Maybe<ProductAvailability>;
  /** Determines whether the product consists of multiple items. */
  bundle?: Maybe<Scalars['Boolean']['output']>;
  /** A list of article numbers of contained items. */
  bundledArticleNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** A list of bundled standard products. */
  bundledProducts?: Maybe<Array<Maybe<StandardProduct>>>;
  /**
   * The approximate time that is needed for the product to get shipped to
   * the customer.
   * @deprecated Please use the delivery lead time from the availability field instead.
   *
   */
  deliveryLeadTime?: Maybe<Scalars['String']['output']>;
  /** A detailed product description. May contain HTML content that is used to enrich the product with search engine optimized information. */
  description?: Maybe<Scalars['String']['output']>;
  /** A list of documents attached to the offer. */
  documents?: Maybe<Array<Maybe<Attachment>>>;
  /** A list of all EANs of contained items. */
  eans?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  family?: Maybe<ProductFamily>;
  /** A list of legal texts. */
  legalTexts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** A list of media objects attached to the product. */
  media?: Maybe<Array<Maybe<Attachment>>>;
  /** Gets the name of the product. */
  name?: Maybe<Scalars['String']['output']>;
  /** An identifier for the enabler that the product originated from. */
  origin?: Maybe<Origin>;
  /** A shorter list of product USPs. */
  shortUsp?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The product slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /**
   * The number of units available in stock.
   * @deprecated Please use the stock from the availability field instead.
   */
  stock?: Maybe<ProductStock>;
  /** A list of product summary texts. */
  summaryTexts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Tags for the product with additional details. */
  tagDetails?: Maybe<Array<Maybe<Tag>>>;
  /** Tags for the product. */
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The primary image for this product. */
  teaserImage?: Maybe<Attachment>;
  /** A list of product USPs. */
  usps?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** An object containing details for a bundle product. */
export type BundleProductAvailabilityArgs = {
  live?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An object containing details for a bundle product. */
export type BundleProductStockArgs = {
  live?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An object containing details for a bundle product family. */
export type BundleProductFamily = ProductFamily & {
  __typename?: 'BundleProductFamily';
  /** A list of categories that the product family belongs to. */
  categories?: Maybe<Array<Maybe<ProductCategory>>>;
  /** An unique identifier for the product family. */
  familyNumber?: Maybe<Scalars['String']['output']>;
  /** Gets the name of the product family. */
  name?: Maybe<Scalars['String']['output']>;
  /** The popularity of the product family. */
  popularity?: Maybe<Scalars['Int']['output']>;
  /** Most precise categories that are available for the product family. */
  preciseCategories?: Maybe<Array<Maybe<ProductCategory>>>;
  /** The primary category that the product family belongs to. */
  primaryCategory?: Maybe<ProductCategory>;
  /** Root categories that the product family belongs to. */
  rootCategories?: Maybe<Array<Maybe<ProductCategory>>>;
  /** The slug of the product family. */
  slug?: Maybe<Scalars['String']['output']>;
};

/** An object containing details for a bundle product family. */
export type BundleProductFamilyPrimaryCategoryArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/**
 * An object that contains offer details. This particular type is used in offer
 * lists when multiple offers are collapsed to a single one by their product
 * family. This allows to add additional fields to the offer that are only
 * relevant when they are grouped.
 */
export type CollapsibleOffer = Offer & {
  __typename?: 'CollapsibleOffer';
  /** A list of offers that are accessories for the product. */
  accessories?: Maybe<Array<Maybe<DefaultOffer>>>;
  /** Indicates whether the offer is discounted. */
  discounted?: Maybe<Scalars['Boolean']['output']>;
  /** A list of documents attached to the offer. */
  documents?: Maybe<Array<Maybe<Attachment>>>;
  /** The date and time the offer has been inserted at. */
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Indicates whether the offer is listed. */
  list?: Maybe<Scalars['Boolean']['output']>;
  /** The maximum amount that this offer can be bought per order. */
  maxOrderableAmount?: Maybe<Scalars['Int']['output']>;
  /** A list of media objects attached to the offer. */
  media?: Maybe<Array<Maybe<Attachment>>>;
  name: Scalars['String']['output'];
  /** The default onetime price for the offer if one exists. */
  onetimePrice?: Maybe<Price>;
  /** Gets the minimum and maximum prices of all products in the product family. */
  onetimePriceRange?: Maybe<PriceRange>;
  /** The position of the offer on offer lists. */
  position?: Maybe<Scalars['Int']['output']>;
  /** An additional information about the pricing policy */
  priceExtraInformation?: Maybe<Scalars['String']['output']>;
  /** A list of prices for the offer. */
  prices?: Maybe<Array<Maybe<Price>>>;
  /** The product or bundle. */
  product?: Maybe<Product>;
  /** A list of related offers with alternative products. */
  productAlternatives?: Maybe<Array<Maybe<ProductAlternativeItemGroup>>>;
  /** A list of offers that are recommended for the product. */
  recommendations?: Maybe<Array<Maybe<DefaultOffer>>>;
  /** A list of offer summary texts. */
  summaryTexts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The primary image for this offer. */
  teaserImage?: Maybe<Attachment>;
  /** The date and time the offer has been updated at. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** A list of unique selling propositions for the offer. */
  usps?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * The date and time the offer is valid from. When empty it is considered
   * infinite.
   */
  validFrom?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The date and time the offer is valid until. When empty it is considered
   * infinite.
   */
  validUntil?: Maybe<Scalars['DateTime']['output']>;
  /** Gets the number of variants that this offer has. */
  variantsCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * An object that contains offer details. This particular type is used in offer
 * lists when multiple offers are collapsed to a single one by their product
 * family. This allows to add additional fields to the offer that are only
 * relevant when they are grouped.
 */
export type CollapsibleOfferAccessoriesArgs = {
  filter?: InputMaybe<OfferFilterParams>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * An object that contains offer details. This particular type is used in offer
 * lists when multiple offers are collapsed to a single one by their product
 * family. This allows to add additional fields to the offer that are only
 * relevant when they are grouped.
 */
export type CollapsibleOfferProductAlternativesArgs = {
  excludeActive?: InputMaybe<Scalars['Boolean']['input']>;
  strict?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * An object that contains offer details. This particular type is used in offer
 * lists when multiple offers are collapsed to a single one by their product
 * family. This allows to add additional fields to the offer that are only
 * relevant when they are grouped.
 */
export type CollapsibleOfferRecommendationsArgs = {
  filter?: InputMaybe<OfferFilterParams>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** A type representing a color. */
export type Color = {
  __typename?: 'Color';
  /** The color hex code. */
  code?: Maybe<Scalars['ColorCode']['output']>;
  /** Indicates that the color represents multiple colors. */
  colorful?: Maybe<Scalars['Boolean']['output']>;
  /** The name of the color. */
  name?: Maybe<Scalars['String']['output']>;
};

/** A type representing a the common charger product attributes. */
export type CommonCharger = {
  __typename?: 'CommonCharger';
  /** True when the product is sold with a charger included. */
  included?: Maybe<Scalars['Boolean']['output']>;
  /** The maximum wattage of the charger */
  maxWattage?: Maybe<Scalars['Decimal']['output']>;
  /** The minimum wattage of the charger */
  minWattage?: Maybe<Scalars['Decimal']['output']>;
  /** True when the product CAN use a charger. Examples for true are smartphones, false for display protections */
  possible?: Maybe<Scalars['Boolean']['output']>;
  /** True when the charger support the USB PowerDelivery protocol. */
  usbPd?: Maybe<Scalars['Boolean']['output']>;
};

/** Enumeration of compatible brand field names that support sorting. */
export enum CompatibleBrandSortField {
  /** The name field. */
  Name = 'NAME',
  /** The popularity field. */
  Popularity = 'POPULARITY',
}

/** Field and direction that are used to sort a compatible brands collection. */
export type CompatibleBrandSortParams = {
  /** The direction to sort by. */
  direction?: InputMaybe<SortDirection>;
  /** The field to sort by. */
  field?: InputMaybe<CompatibleBrandSortField>;
};

/** Enumeration of compatible product family field names that support sorting. */
export enum CompatibleProductFamilySortField {
  /** The name field. */
  Name = 'NAME',
  /** The popularity field. */
  Popularity = 'POPULARITY',
}

/**
 * Field and direction that are used to sort a compatible product families
 * collection.
 */
export type CompatibleProductFamilySortParams = {
  /** The direction to sort by. */
  direction?: InputMaybe<SortDirection>;
  /** The field to sort by. */
  field?: InputMaybe<CompatibleProductFamilySortField>;
};

/** An object that contains offer details. */
export type DefaultOffer = Offer & {
  __typename?: 'DefaultOffer';
  /** A list of offers that are accessories for the product. */
  accessories?: Maybe<Array<Maybe<DefaultOffer>>>;
  /** Indicates whether the offer is discounted. */
  discounted?: Maybe<Scalars['Boolean']['output']>;
  /** A list of documents attached to the offer. */
  documents?: Maybe<Array<Maybe<Attachment>>>;
  /** The date and time the offer has been inserted at. */
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Indicates whether the offer is listed. */
  list?: Maybe<Scalars['Boolean']['output']>;
  /** The maximum amount that this offer can be bought per order. */
  maxOrderableAmount?: Maybe<Scalars['Int']['output']>;
  /** A list of media objects attached to the offer. */
  media?: Maybe<Array<Maybe<Attachment>>>;
  name: Scalars['String']['output'];
  /** The default onetime price for the offer if one exists. */
  onetimePrice?: Maybe<Price>;
  /** The position of the offer on offer lists. */
  position?: Maybe<Scalars['Int']['output']>;
  /** An additional information about the pricing policy */
  priceExtraInformation?: Maybe<Scalars['String']['output']>;
  /** A list of prices for the offer. */
  prices?: Maybe<Array<Maybe<Price>>>;
  /** The product or bundle. */
  product?: Maybe<Product>;
  /** A list of related offers with alternative products. */
  productAlternatives?: Maybe<Array<Maybe<ProductAlternativeItemGroup>>>;
  /** A list of offers that are recommended for the product. */
  recommendations?: Maybe<Array<Maybe<DefaultOffer>>>;
  /** A list of offer summary texts. */
  summaryTexts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The primary image for this offer. */
  teaserImage?: Maybe<Attachment>;
  /** The date and time the offer has been updated at. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** A list of unique selling propositions for the offer. */
  usps?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * The date and time the offer is valid from. When empty it is considered
   * infinite.
   */
  validFrom?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The date and time the offer is valid until. When empty it is considered
   * infinite.
   */
  validUntil?: Maybe<Scalars['DateTime']['output']>;
  /** Gets the number of variants that this offer has. */
  variantsCount?: Maybe<Scalars['Int']['output']>;
};

/** An object that contains offer details. */
export type DefaultOfferAccessoriesArgs = {
  filter?: InputMaybe<OfferFilterParams>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** An object that contains offer details. */
export type DefaultOfferProductAlternativesArgs = {
  excludeActive?: InputMaybe<Scalars['Boolean']['input']>;
  strict?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An object that contains offer details. */
export type DefaultOfferRecommendationsArgs = {
  filter?: InputMaybe<OfferFilterParams>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** A type representing an estimated delivery lead time. */
export type DeliveryLeadTime = {
  __typename?: 'DeliveryLeadTime';
  /** The max delivery lead time. */
  max?: Maybe<Scalars['Int']['output']>;
  /** The min delivery lead time. */
  min?: Maybe<Scalars['Int']['output']>;
  /** The delivery lead time as text. */
  text?: Maybe<Scalars['String']['output']>;
  /** The duration unit. */
  unit?: Maybe<DurationUnit>;
};

/** An enum type for dimension units. */
export enum DimensionUnit {
  /** Centimeters (cm) */
  Cm = 'CM',
  /** Inches (in) */
  In = 'IN',
  /** Millimeters (mm) */
  Mm = 'MM',
}

/** A type representing width, height and depth of an item. */
export type Dimensions = {
  __typename?: 'Dimensions';
  /** The item depth. */
  depth?: Maybe<Scalars['Float']['output']>;
  /** The item height. */
  height?: Maybe<Scalars['Float']['output']>;
  /** The dimension unit. */
  unit?: Maybe<DimensionUnit>;
  /** The item width. */
  width?: Maybe<Scalars['Float']['output']>;
};

/** An enum type for duration units. */
export enum DurationUnit {
  /** Days */
  Days = 'DAYS',
  /** Weeks */
  Weeks = 'WEEKS',
}

/** A type containing energy efficiency information. */
export type EnergyEfficiency = {
  __typename?: 'EnergyEfficiency';
  /** The energy efficiency class. */
  class?: Maybe<EnergyEfficiencyClass>;
  /** The energy document. */
  document?: Maybe<Attachment>;
  /** The energy label image. */
  labelImage?: Maybe<Attachment>;
};

/** An enum type that contains all EU energy efficiency classes. */
export enum EnergyEfficiencyClass {
  /** The A energy label. */
  A = 'A',
  /** The A++ energy label. */
  ADoublePlus = 'A_DOUBLE_PLUS',
  /** The A+ energy label. */
  APlus = 'A_PLUS',
  /** The A+++ energy label. */
  ATriplePlus = 'A_TRIPLE_PLUS',
  /** The B energy label. */
  B = 'B',
  /** The C energy label. */
  C = 'C',
  /** The D energy label. */
  D = 'D',
  /** The E energy label. */
  E = 'E',
  /** The F energy label. */
  F = 'F',
  /** The G energy label. */
  G = 'G',
}

/** A type representing the external links of a product. */
export type ExternalLinks = {
  __typename?: 'ExternalLinks';
  /** The link to the OneShop page that bundles the product with a contract */
  oneShopUrl?: Maybe<Scalars['String']['output']>;
};

/** Describes a filter for product families */
export type FamilyFilterParams = {
  /** Filter by brand name or slug */
  brand?: InputMaybe<Scalars['String']['input']>;
  /** Filter by the family name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Filter by the **exact** slug of the family */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** A type representing width, height and depth of an item. */
export type Feature = {
  __typename?: 'Feature';
  /** The feature name. */
  name?: Maybe<Scalars['String']['output']>;
  /** The feature value. */
  value?: Maybe<Scalars['String']['output']>;
};

export type FeatureKeyAndName = {
  __typename?: 'FeatureKeyAndName';
  /** key of a feature */
  key?: Maybe<Scalars['String']['output']>;
  /** The different values of the feature inside the product family. */
  values?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** Aggregations over kompa products */
export type KompaAggregations = {
  __typename?: 'KompaAggregations';
  brands?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** The object for the different categories */
export type KompaCategories = {
  __typename?: 'KompaCategories';
  /** Zwischenstecker */
  adapters?: Maybe<KompaProductAdapters>;
  /** Haushaltsgeräte */
  appliances?: Maybe<KompaProductAppliances>;
  /** Kameras */
  cameras?: Maybe<KompaProductCameras>;
  /** Heizungs- und Klimasteuerung */
  climateDevices?: Maybe<KompaProductClimateDevices>;
  /** Türschlösser */
  doorLocks?: Maybe<KompaProductDoorLocks>;
  /** Melder & Sensoren: Tür-/Fensterkontakte */
  doorWindowSensors?: Maybe<KompaProductDoorWindowSensors>;
  /** Erweiterungen */
  extensions?: Maybe<KompaProductExtensions>;
  /** Erweiterungen: Funksticks, Hersteller-Gateways und Bridges */
  gatewayBridges?: Maybe<KompaProductGatewayBridges>;
  /** Integrierte Systeme */
  integratedSystems?: Maybe<KompaProductIntegratedSystems>;
  /** Interntet Router */
  internetRouters?: Maybe<KompaProductInternetRouters>;
  /** Beleuchtung */
  lightnings?: Maybe<KompaProductLightnings>;
  /** Media Receiver */
  mediaReceivers?: Maybe<KompaProductMediaReceivers>;
  /** Melder & Sensoren: Bewegungsmelder */
  motionSensors?: Maybe<KompaProductMotionSensors>;
  /** Auf- und Unterputzgeräte */
  mountedDevices?: Maybe<KompaProductMountedDevices>;
  /** Outdoor */
  outdoor?: Maybe<KompaProductOutdoor>;
  /** Funkprotokolle */
  protocols?: Maybe<KompaProductProtocols>;
  /** Fernbedienungen */
  remoteControls?: Maybe<KompaProductRemoteControls>;
  /** Rollläden, Jalousien und Tore */
  shutterAndGates?: Maybe<KompaProductShutterAndGates>;
  /** Sirenen */
  sirens?: Maybe<KompaProductSirens>;
  /** Rauchmelder */
  smokeSensors?: Maybe<KompaProductSmokeSensors>;
  /** Lautsprecher */
  speakers?: Maybe<KompaProductSpeakers>;
  /** Schalter und Taster */
  switches?: Maybe<KompaProductSwitches>;
  /** Melder & Sensoren: Weitere */
  variousSensors?: Maybe<KompaProductVariousSensors>;
  /** Wassersensoren */
  waterSensors?: Maybe<KompaProductWaterSensors>;
  /** Wettersensoren */
  weatherSensors?: Maybe<KompaProductWeatherSensors>;
};

/** An interface for a kompa product. */
export type KompaProduct = {
  __typename?: 'KompaProduct';
  /** Produktbild(er) */
  attachments?: Maybe<Array<Maybe<Attachment>>>;
  /** Marke */
  brand?: Maybe<Scalars['String']['output']>;
  /** Kategorien */
  categories?: Maybe<KompaCategories>;
  /** Kompatible Apps */
  compatibleAppVersions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Kompatible Zentralen */
  compatibleBaseStations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Anbindung an Herstellersystem erforderlich */
  connectionRequired?: Maybe<Scalars['Boolean']['output']>;
  /** Anbindung an Herstellersystem erforderlich (Text) */
  connectionRequiredLabel?: Maybe<Scalars['String']['output']>;
  /** Article Numbers */
  eanList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Erweiterung nötig* */
  extension?: Maybe<Scalars['String']['output']>;
  /** Modellnummer des Herstellers */
  manufacturerPartNumber?: Maybe<Scalars['String']['output']>;
  /** Produktname */
  name?: Maybe<Scalars['String']['output']>;
  /** Priorität */
  priority?: Maybe<Scalars['String']['output']>;
  /** Product family (if available) */
  productFamily?: Maybe<ProductFamily>;
  /** SKUs */
  skuList?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** The object for adapters for a kompa product */
export type KompaProductAdapters = {
  __typename?: 'KompaProductAdapters';
  /** Mit Zuleitungskabel */
  cable?: Maybe<Scalars['Boolean']['output']>;
  /** Mit Verbrauchs-messung */
  consumptionMeasuring?: Maybe<Scalars['Boolean']['output']>;
  /** Mit Dimmfunktion */
  dimFunction?: Maybe<Scalars['Boolean']['output']>;
  /** Unterputz */
  flushMounted?: Maybe<Scalars['Boolean']['output']>;
  /** Innenbereich */
  indoor?: Maybe<Scalars['Boolean']['output']>;
  /** Außenbereich */
  outdoor?: Maybe<Scalars['Boolean']['output']>;
  /** Erhöht die Funk-Reichweite */
  repeater?: Maybe<Scalars['Boolean']['output']>;
  /** Anzahl smarte Steckplätze */
  smartSocketCount?: Maybe<Scalars['Int']['output']>;
  /** Aufputz */
  wallMounted?: Maybe<Scalars['Boolean']['output']>;
};

/** The input object for adapters for a kompa product */
export type KompaProductAdaptersParams = {
  /** Mit Zuleitungskabel */
  cable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mit Verbrauchsmessung */
  consumptionMeasuring?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mit Dimmfunktion */
  dimFunction?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unterputz */
  flushMounted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Innenbereich */
  indoor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Außenbereich */
  outdoor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Erhöht die Funk-Reichweite */
  repeater?: InputMaybe<Scalars['Boolean']['input']>;
  /** Anzahl smarte Steckplätze */
  smartSocketCount?: InputMaybe<Scalars['Int']['input']>;
  /** Aufputz */
  wallMounted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KompaProductAppliances = {
  __typename?: 'KompaProductAppliances';
  /** Kaffeevollautomaten */
  coffeeMaker?: Maybe<Scalars['Boolean']['output']>;
  /** Kochfelder */
  cooktop?: Maybe<Scalars['Boolean']['output']>;
  /** Geschirrspüler */
  dishwasher?: Maybe<Scalars['Boolean']['output']>;
  /** Dunstabzugshauben */
  exhaustHood?: Maybe<Scalars['Boolean']['output']>;
  /** Kühl- und Gefrierschränke */
  fridgeFreezer?: Maybe<Scalars['Boolean']['output']>;
  /** Backöfen und Dampfgarer */
  ovenSteamer?: Maybe<Scalars['Boolean']['output']>;
  /** Saugroboter */
  vacuumRobot?: Maybe<Scalars['Boolean']['output']>;
  /** Waschmaschinen und Trockner */
  washerDryer?: Maybe<Scalars['Boolean']['output']>;
  /** Weinschränke */
  whineCabinet?: Maybe<Scalars['Boolean']['output']>;
};

/** The input object for appliances for a kompa product */
export type KompaProductAppliancesParams = {
  /** Kaffeevollautomaten */
  coffeeMaker?: InputMaybe<Scalars['Boolean']['input']>;
  /** Kochfelder */
  cooktop?: InputMaybe<Scalars['Boolean']['input']>;
  /** Geschirrspüler */
  dishwasher?: InputMaybe<Scalars['Boolean']['input']>;
  /** Dunstabzugshauben */
  exhaustHood?: InputMaybe<Scalars['Boolean']['input']>;
  /** Kühl- und Gefrierschränke */
  fridgeFreezer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Backöfen und Dampfgarer */
  ovenSteamer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Saugroboter */
  vacuumRobot?: InputMaybe<Scalars['Boolean']['input']>;
  /** Waschmaschinen und Trockner */
  washerDryer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Weinschränke */
  whineCabinet?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KompaProductCameras = {
  __typename?: 'KompaProductCameras';
  /** Speicherung in Hersteller-Cloud */
  cloudData?: Maybe<Scalars['Boolean']['output']>;
  /** Innenbereich */
  indoor?: Maybe<Scalars['Boolean']['output']>;
  /** Speicherung in MagentaCLOUD */
  magentaCloudData?: Maybe<Scalars['Boolean']['output']>;
  /** Mikrofon */
  microphone?: Maybe<Scalars['Boolean']['output']>;
  /** Außenbereich */
  outdoor?: Maybe<Scalars['Boolean']['output']>;
  /** Erkennung menschlicher Bewegungen */
  personRecognition?: Maybe<Scalars['Boolean']['output']>;
  /** MicroSD Karte für Zwischenspeicherung benötigt */
  sdBuffered?: Maybe<Scalars['Boolean']['output']>;
  /** Speicherung auf MicroSD Karte */
  sdMemoryCard?: Maybe<Scalars['Boolean']['output']>;
  /** Nur Streaming */
  streamingOnly?: Maybe<Scalars['Boolean']['output']>;
};

/** The input object for cameras for a kompa product */
export type KompaProductCamerasParams = {
  /** Speicherung in Hersteller-Cloud */
  cloudData?: InputMaybe<Scalars['Boolean']['input']>;
  /** Innenbereich */
  indoor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Speicherung in MagentaCLOUD */
  magentaCloudData?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mikrofon */
  microphone?: InputMaybe<Scalars['Boolean']['input']>;
  /** Außenbereich */
  outdoor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Erkennung menschlicher Bewegungen */
  personRecognition?: InputMaybe<Scalars['Boolean']['input']>;
  /** SD Karte zur Zwischenspeicherung benötigt */
  sdBuffered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Speicherung auf MicroSD Karte */
  sdMemoryCard?: InputMaybe<Scalars['Boolean']['input']>;
  /** Nur Streaming */
  streamingOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KompaProductClimateDevices = {
  __typename?: 'KompaProductClimateDevices';
  /** Batteriebetrieb */
  batteryPowered?: Maybe<Scalars['Boolean']['output']>;
  /** Für Heizkörper */
  forHeater?: Maybe<Scalars['Boolean']['output']>;
  /** Für Fußbodenheizung */
  forUnderfloorHeater?: Maybe<Scalars['Boolean']['output']>;
  /** Mit Offset* */
  offset?: Maybe<Scalars['Boolean']['output']>;
  /** Stromanschluss */
  powerCord?: Maybe<Scalars['Boolean']['output']>;
};

/** The input object for climate_devices for a kompa product */
export type KompaProductClimateDevicesParams = {
  /** Batteriebetrieb */
  batteryPowered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Für Heizkörper */
  forHeater?: InputMaybe<Scalars['Boolean']['input']>;
  /** Für Fußbodenheizung */
  forUnderfloorHeater?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mit Offset* */
  offset?: InputMaybe<Scalars['Boolean']['input']>;
  /** Stromanschluss */
  powerCord?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KompaProductDoorLocks = {
  __typename?: 'KompaProductDoorLocks';
  /** Batteriebetrieb */
  batteryPowered?: Maybe<Scalars['Boolean']['output']>;
  /** Indoor */
  indoor?: Maybe<Scalars['Boolean']['output']>;
  /** Outdoor */
  outdoor?: Maybe<Scalars['Boolean']['output']>;
  /** Stromanschluss */
  powerCord?: Maybe<Scalars['Boolean']['output']>;
  /** ID of the product */
  productId?: Maybe<Scalars['String']['output']>;
};

/** The input object for door_locks for a kompa product */
export type KompaProductDoorLocksParams = {
  /** Batteriebetrieb */
  batteryPowered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Innenbereich */
  indoor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Außenbereich */
  outdoor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Stromanschluss */
  powerCord?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KompaProductDoorWindowSensors = {
  __typename?: 'KompaProductDoorWindowSensors';
  /** Verdeckter Einbau */
  hiddenInstallation?: Maybe<Scalars['Boolean']['output']>;
  /** Magnetisch */
  magnetic?: Maybe<Scalars['Boolean']['output']>;
  /** mehrere Farben erhältlich */
  multipleColorsAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** Optisch */
  optical?: Maybe<Scalars['Boolean']['output']>;
  /** Sabotageschutz* */
  tamperProtection?: Maybe<Scalars['Boolean']['output']>;
};

/** The input object for door_window_sensors for a kompa product */
export type KompaProductDoorWindowSensorsParams = {
  /** Verdeckter Einbau */
  hiddenInstallation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Magnetisch */
  magnetic?: InputMaybe<Scalars['Boolean']['input']>;
  /** mehrere Farben erhältlich */
  multipleColorsAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optisch */
  optical?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sabotageschutz* */
  tamperProtection?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KompaProductExtensions = {
  __typename?: 'KompaProductExtensions';
  /** Für Geräte anderer Hersteller nutzbar */
  brandCrossCompatible?: Maybe<Scalars['Boolean']['output']>;
  /** Mit Zuleitungskabel */
  cable?: Maybe<Scalars['Boolean']['output']>;
  /** Mit eigener Stromversorgung */
  powerSupply?: Maybe<Scalars['Boolean']['output']>;
  /** ID of the product */
  productId?: Maybe<Scalars['String']['output']>;
  /** Stromversorgung über USB */
  usbPowered?: Maybe<Scalars['Boolean']['output']>;
};

/** The input object for extions for a kompa product */
export type KompaProductExtensionsParams = {
  /** Für Geräte anderer Hersteller nutzbar */
  brandCrossCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mit Zuleitungskabel */
  cable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mit eigener Stromversorgung */
  powerSupply?: InputMaybe<Scalars['Boolean']['input']>;
  /** Stromversorgung über USB */
  usbPowered?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Parameters that are used to filter a product collection. */
export type KompaProductFilterParams = {
  /** Zwischenstecker */
  adapters?: InputMaybe<KompaProductAdaptersParams>;
  /** Haushaltsgeräte */
  appliances?: InputMaybe<KompaProductAppliancesParams>;
  /** Brands nach denen gefiltert werden soll */
  brands?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Kameras */
  cameras?: InputMaybe<KompaProductCamerasParams>;
  /** Kategorien nach denen gefiltert werden soll */
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Heizungs- und Klimasteuerung */
  climateDevices?: InputMaybe<KompaProductClimateDevicesParams>;
  /** Kompatible Aps */
  compatibleAppVersions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Kompatible Zentralen */
  compatibleBaseStations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Türschlösser */
  doorLocks?: InputMaybe<KompaProductDoorLocksParams>;
  /** Melder & Sensoren: Tür-/Fensterkontakte */
  doorWindowSensors?: InputMaybe<KompaProductDoorWindowSensorsParams>;
  /** Kompatible Aps */
  eanLis?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Kompa filter. */
  extension?: InputMaybe<Scalars['String']['input']>;
  /** Erweiterungen */
  extensions?: InputMaybe<KompaProductExtensionsParams>;
  /** Erweiterungen: Funksticks, Hersteller-Gateways und Bridges */
  gatewayBridges?: InputMaybe<KompaProductGatewayBridgesParams>;
  /** Integrierte Systeme */
  integratedSystems?: InputMaybe<KompaProductIntegratedSystemsParams>;
  /** Internet Router */
  internetRouters?: InputMaybe<KompaProductInternetRoutersParams>;
  /** Beleuchtung */
  lightnings?: InputMaybe<KompaProductLightningsParams>;
  /** Media Receiver */
  mediaReceivers?: InputMaybe<KompaProductMediaReceiversParams>;
  /** Melder & Sensoren: Bewegungsmelder */
  motionSensors?: InputMaybe<KompaProductMotionSensorsParams>;
  /** Auf- und Unterputzgeräte */
  mountedDevices?: InputMaybe<KompaProductMountedDevicesParams>;
  /** Außenbereich */
  outdoor?: InputMaybe<KompaProductOutdoorParams>;
  /** Funkprotokolle */
  protocols?: InputMaybe<KompaProductProtocolsParams>;
  /** Fernbedienungen */
  remoteControls?: InputMaybe<KompaProductRemoteControlsParams>;
  /** Rollläden, Jalousien und Tore */
  shutterAndGates?: InputMaybe<KompaProductShutterAndGatesParams>;
  /** Sirenen */
  sirens?: InputMaybe<KompaProductSirensParams>;
  /** Rauchmelder */
  smokeSensors?: InputMaybe<KompaProductSmokeSensorsParams>;
  /** Field and direction that are used to sort kompa products. */
  sort?: InputMaybe<KompaProductSortParams>;
  /** Lautsprecher */
  speakers?: InputMaybe<KompaProductSpeakersParams>;
  /** Taster & Schalter */
  switches?: InputMaybe<KompaProductSwitchesParams>;
  /** Melder & Sensoren: Weitere */
  variousSensors?: InputMaybe<KompaProductVariousSensorsParams>;
  /** Wassersensoren */
  waterSensors?: InputMaybe<KompaProductWaterSensorsParams>;
  /** Wettersensoren */
  weatherSensors?: InputMaybe<KompaProductWeatherSensorsParams>;
};

export type KompaProductGatewayBridges = {
  __typename?: 'KompaProductGatewayBridges';
  /** Für Geräte anderer Hersteller nutzbar */
  brandCrassCompatible?: Maybe<Scalars['Boolean']['output']>;
  /** Mit Zuleitungskabel */
  cable?: Maybe<Scalars['Boolean']['output']>;
  /** Mit eigener Stromversorgung */
  distinctPower?: Maybe<Scalars['Boolean']['output']>;
  /** Stromversorgung über USB */
  usbPower?: Maybe<Scalars['Boolean']['output']>;
};

/** The input object for gateway_bridges for a kompa product */
export type KompaProductGatewayBridgesParams = {
  /** Für Geräte anderer Hersteller nutzbar */
  brandCrassCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mit Zuleitungskabel */
  cable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mit eigener Stromversorgung */
  distinctPower?: InputMaybe<Scalars['Boolean']['input']>;
  /** Stromversorgung über USB */
  usbPower?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KompaProductIntegratedSystems = {
  __typename?: 'KompaProductIntegratedSystems';
  /** Batteriebetrieb */
  batteryPowered?: Maybe<Scalars['Boolean']['output']>;
  /** Innenbereich */
  indoor?: Maybe<Scalars['Boolean']['output']>;
  /** Außenbereich */
  outdoor?: Maybe<Scalars['Boolean']['output']>;
  /** Stromanschluss */
  powerCord?: Maybe<Scalars['Boolean']['output']>;
  /** Mit Fernbedienung */
  remoteControl?: Maybe<Scalars['Boolean']['output']>;
};

/** The input object for integrated_systems for a kompa product */
export type KompaProductIntegratedSystemsParams = {
  /** Batteriebetrieb */
  batteryPowered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Innenbereich */
  indoor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Außenbereich */
  outdoor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Stromanschluss */
  powerCord?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mit Fernbedienung */
  remoteControl?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KompaProductInternetRouters = {
  __typename?: 'KompaProductInternetRouters';
  /** App-gestützte Einrichtung */
  appSetup?: Maybe<Scalars['Boolean']['output']>;
  /** 5 GHz */
  band5?: Maybe<Scalars['Boolean']['output']>;
  /** 2.4 GHz */
  band24?: Maybe<Scalars['Boolean']['output']>;
  /** Mit Display */
  display?: Maybe<Scalars['Boolean']['output']>;
  /** Unterstützt Gäste-WLAN */
  guestWifi?: Maybe<Scalars['Boolean']['output']>;
  /** Anzahl LAN-Anschlüsse */
  lanPorts?: Maybe<Scalars['Int']['output']>;
  /** Untrstützt Mesh WLAN */
  meshSupport?: Maybe<Scalars['Boolean']['output']>;
  /** Als SmartHome Zentrale nutzbar */
  smartHub?: Maybe<Scalars['Boolean']['output']>;
  /** Anzahl USB-Steckplätze */
  usbPorts?: Maybe<Scalars['Int']['output']>;
  /** WPS-Verbindungsmöglichkeit */
  wpsSupport?: Maybe<Scalars['Boolean']['output']>;
};

export type KompaProductInternetRoutersParams = {
  /** App-gestützte Einrichtung */
  appSetup?: InputMaybe<Scalars['Boolean']['input']>;
  /** 5 GHz */
  band5?: InputMaybe<Scalars['Boolean']['input']>;
  /** 2.4 GHz */
  band24?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mit Display */
  display?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unterstützt Gäste-WLAN */
  guestWifi?: InputMaybe<Scalars['Boolean']['input']>;
  /** Untrstützt Mesh WLAN */
  meshSupport?: InputMaybe<Scalars['Boolean']['input']>;
  /** Als SmartHome Zentrale nutzbar */
  smartHub?: InputMaybe<Scalars['Boolean']['input']>;
  /** WPS-Verbindungsmöglichkeit */
  wpsSupport?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KompaProductLightnings = {
  __typename?: 'KompaProductLightnings';
  /** Mit Farblicht */
  coloredLight?: Maybe<Scalars['Boolean']['output']>;
  /** dimmbar */
  dimmable?: Maybe<Scalars['Boolean']['output']>;
  /** Innenbereich */
  indoor?: Maybe<Scalars['Boolean']['output']>;
  /** Ohne Fassung / LED nicht austauschbar */
  noSocket?: Maybe<Scalars['Boolean']['output']>;
  /** Außenbereich */
  outdoor?: Maybe<Scalars['Boolean']['output']>;
  /** Fassung E14 */
  socketE14?: Maybe<Scalars['Boolean']['output']>;
  /** Fassung E26 - US */
  socketE26?: Maybe<Scalars['Boolean']['output']>;
  /** Fassung E27 */
  socketE27?: Maybe<Scalars['Boolean']['output']>;
  /** Fassung GU10 */
  socketGu10?: Maybe<Scalars['Boolean']['output']>;
  /** Fassung GU5.3 */
  socketGu53?: Maybe<Scalars['Boolean']['output']>;
};

/** The input object for lightnings for a kompa product */
export type KompaProductLightningsParams = {
  /** Mit Farblicht */
  coloredLight?: InputMaybe<Scalars['Boolean']['input']>;
  /** dimmbar */
  dimmable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Innenbereich */
  indoor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ohne Fassung / LED nicht austauschbar */
  noSocket?: InputMaybe<Scalars['Boolean']['input']>;
  /** Außenbereich */
  outdoor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Fassung E14 */
  socketE14?: InputMaybe<Scalars['Boolean']['input']>;
  /** Fassung E26 - US */
  socketE26?: InputMaybe<Scalars['Boolean']['input']>;
  /** Fassung E27 */
  socketE27?: InputMaybe<Scalars['Boolean']['input']>;
  /** Fassung GU10 */
  socketGu10?: InputMaybe<Scalars['Boolean']['input']>;
  /** Fassung GU5.3 */
  socketGu53?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KompaProductMediaReceivers = {
  __typename?: 'KompaProductMediaReceivers';
  /** Anschlussart */
  connection?: Maybe<Scalars['String']['output']>;
  /** Integrierter Festplattenrekorder */
  integratedHdd?: Maybe<Scalars['String']['output']>;
  /** Unterstützt Mesh WLAN */
  mashWifiSupport?: Maybe<Scalars['Boolean']['output']>;
  /** Separat nutzbares Internetradio */
  seperateIpRadio?: Maybe<Scalars['Boolean']['output']>;
  /** Wechsel-Festplatte */
  swappableHdd?: Maybe<Scalars['Boolean']['output']>;
  /** Unterstützt Ultra-HD TV */
  uhdtv?: Maybe<Scalars['Boolean']['output']>;
  /** Unterstützt Sprachsteuerung */
  voiceCommands?: Maybe<Scalars['Boolean']['output']>;
};

/** The input object for media receivers for a kompa product */
export type KompaProductMediaReceiversParams = {
  /** Unterstützt Mesh WLAN */
  mashWifiSupport?: InputMaybe<Scalars['Boolean']['input']>;
  /** Separat nutzbares Internetradio */
  seperateIpRadio?: InputMaybe<Scalars['Boolean']['input']>;
  /** Wechsel-Festplatte */
  swappableHdd?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unterstützt Ultra-HD TV */
  uhdtv?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unterstützt Sprachsteuerung */
  voiceCommands?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KompaProductMotionSensors = {
  __typename?: 'KompaProductMotionSensors';
  /** Innenbereich */
  indoor?: Maybe<Scalars['Boolean']['output']>;
  /** Mit Helligkeits-/Lichtsensor */
  lightsensor?: Maybe<Scalars['Boolean']['output']>;
  /** Außenbereich */
  outdoor?: Maybe<Scalars['Boolean']['output']>;
  /** Störungssicher bei Haustieren */
  petCompatible?: Maybe<Scalars['Boolean']['output']>;
  /** Einstellbare Empfindlichkeit */
  sensitivityAdjustment?: Maybe<Scalars['Boolean']['output']>;
  /** Sabotageschutz* */
  tamperProtection?: Maybe<Scalars['Boolean']['output']>;
};

/** The input object for motion_sensors for a kompa product */
export type KompaProductMotionSensorsParams = {
  /** Innenbereich */
  indoor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mit Helligkeits-/Lichtsensor */
  lightsensor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Außenbereich */
  outdoor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Störungssicher bei Haustieren */
  petCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Einstellbare Empfindlichkeit */
  sensitivityAdjustment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Spionageschutz */
  tamperProtection?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KompaProductMountedDevices = {
  __typename?: 'KompaProductMountedDevices';
  /** Mit Verbrauchsmessung */
  consumptionMeasuring?: Maybe<Scalars['Boolean']['output']>;
  /** Mit Dimmfunktion */
  dimming?: Maybe<Scalars['Boolean']['output']>;
  /** Unterputz */
  inWall?: Maybe<Scalars['Boolean']['output']>;
  /** Für Markenschalter geeignet */
  markenschalterCompatible?: Maybe<Scalars['Boolean']['output']>;
  /** Aufputz */
  onWall?: Maybe<Scalars['Boolean']['output']>;
};

/** The input object for mounted_devices for a kompa product */
export type KompaProductMountedDevicesParams = {
  /** Mit Verbrauchsmessung */
  consumptionMeasuring?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mit Dimmfunktion */
  dimming?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unterputz */
  inWall?: InputMaybe<Scalars['Boolean']['input']>;
  /** Für Markenschalter geeignet */
  markenschalterCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Aufputz */
  onWall?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KompaProductOutdoor = {
  __typename?: 'KompaProductOutdoor';
  /** Batteriebetrieben */
  batteryPowered?: Maybe<Scalars['Boolean']['output']>;
  /** Mit Helligkeits-/Lichtsensor */
  lightsensor?: Maybe<Scalars['Boolean']['output']>;
  /** Outdoor */
  outdoor?: Maybe<Scalars['Boolean']['output']>;
  /** Stromanschluss */
  powerCord?: Maybe<Scalars['Boolean']['output']>;
  /** ID of the product */
  productId?: Maybe<Scalars['String']['output']>;
};

/** The input object for outdoor for a kompa product */
export type KompaProductOutdoorParams = {
  /** Batteriebetrieb */
  batteryPowered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mit Helligkeits-/Lichtsensor */
  lightsensor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Außenbereich */
  outdoor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Stromanschluss */
  powerCord?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KompaProductProtocols = {
  __typename?: 'KompaProductProtocols';
  /** DECT ULE */
  dect?: Maybe<Scalars['Boolean']['output']>;
  /** HomeMatic / BidCoS */
  homeMaticBidcos?: Maybe<Scalars['Boolean']['output']>;
  /** Homematic IP */
  homeMaticIp?: Maybe<Scalars['Boolean']['output']>;
  /** Homematic IP (Text) */
  homeMaticIpLabel?: Maybe<Scalars['String']['output']>;
  /** IP / WLAN / SIM */
  ipWifi?: Maybe<Scalars['Boolean']['output']>;
  /** LAN */
  lan?: Maybe<Scalars['Boolean']['output']>;
  /** Schellenberg */
  schellenberg?: Maybe<Scalars['Boolean']['output']>;
  /** Schellenberg (Text) */
  schellenbergLabel?: Maybe<Scalars['String']['output']>;
  /** ZigBee */
  zigbee?: Maybe<Scalars['Boolean']['output']>;
  /** ZigBee (Text) */
  zigbeeLabel?: Maybe<Scalars['String']['output']>;
};

/** The input object for protocols for a kompa product */
export type KompaProductProtocolsParams = {
  /** DECT ULE */
  dect?: InputMaybe<Scalars['Boolean']['input']>;
  /** HomeMatic / BidCoS */
  homeMaticBidcos?: InputMaybe<Scalars['Boolean']['input']>;
  /** Homematic IP */
  homeMaticIp?: InputMaybe<Scalars['Boolean']['input']>;
  /** Homematic IP (Text) */
  homeMaticIpLabel?: InputMaybe<Scalars['String']['input']>;
  /** IP / WLAN / SIM */
  ipWifi?: InputMaybe<Scalars['Boolean']['input']>;
  /** LAN */
  lan?: InputMaybe<Scalars['Boolean']['input']>;
  /** Schellenberg */
  schellenberg?: InputMaybe<Scalars['Boolean']['input']>;
  /** Schellenberg (Text) */
  schellenbergLabel?: InputMaybe<Scalars['String']['input']>;
  /** ZigBee */
  zigbee?: InputMaybe<Scalars['Boolean']['input']>;
  /** ZigBee (Text) */
  zigbeeLabel?: InputMaybe<Scalars['String']['input']>;
};

export type KompaProductRemoteControls = {
  __typename?: 'KompaProductRemoteControls';
  /** Anzahl belegbare Tasten */
  buttonCount?: Maybe<Scalars['Int']['output']>;
  /** Mehrfachbelegung je Taste */
  multiFunctionButtons?: Maybe<Scalars['Boolean']['output']>;
};

/** The input object for remote_controls for a kompa product */
export type KompaProductRemoteControlsParams = {
  /** Anzahl belegbare Tasten */
  buttonCount?: InputMaybe<Scalars['Int']['input']>;
  /** Mehrfachbelegung je Taste */
  multiFunctionButtons?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KompaProductShutterAndGates = {
  __typename?: 'KompaProductShutterAndGates';
  /** Batteriebetrieb */
  batteryPowered?: Maybe<Scalars['Boolean']['output']>;
  /** Unterputz */
  flushMounted?: Maybe<Scalars['Boolean']['output']>;
  /** Innenbereich */
  indoor?: Maybe<Scalars['Boolean']['output']>;
  /** Für Markenschalter geeignet */
  markenschalterCompatible?: Maybe<Scalars['Boolean']['output']>;
  /** Außenbereich */
  outdoor?: Maybe<Scalars['Boolean']['output']>;
  /** Mit Fernbedienung */
  remoteControlled?: Maybe<Scalars['Boolean']['output']>;
  /** Mit Lamellensteuerung */
  slatControl?: Maybe<Scalars['Boolean']['output']>;
  /** Aufputz */
  wallMounted?: Maybe<Scalars['Boolean']['output']>;
};

/** The input object for shutter_and_gates for a kompa product */
export type KompaProductShutterAndGatesParams = {
  /** Batteriebetrieb */
  batteryPowered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unterputz */
  flushMounted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Innenbereich */
  indoor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Für Markenschalter geeignet */
  markenschalterCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Außenbereich */
  outdoor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mit Fernbedienung */
  remoteControlled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mit Lamellensteuerung */
  slatControl?: InputMaybe<Scalars['Boolean']['input']>;
  /** Aufputz */
  wallMounted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KompaProductSirens = {
  __typename?: 'KompaProductSirens';
  /** Batteriebetrieben */
  batteryPowered?: Maybe<Scalars['Boolean']['output']>;
  /** Innenbereich */
  indoor?: Maybe<Scalars['Boolean']['output']>;
  /** Außenbereich */
  outdoor?: Maybe<Scalars['Boolean']['output']>;
  /** Stromanschluss */
  powerCord?: Maybe<Scalars['Boolean']['output']>;
  /** ID of the product */
  productId?: Maybe<Scalars['String']['output']>;
  /** Spionageschutz* */
  tamperProtection?: Maybe<Scalars['Boolean']['output']>;
};

/** The input object for sirens for a kompa product */
export type KompaProductSirensParams = {
  /** Batteriebetrieb */
  batteryPowered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Innenbereich */
  indoor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Außenbereich */
  outdoor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Stromanschluss */
  powerCord?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sabotageschutz */
  tamperProtection?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KompaProductSmokeSensors = {
  __typename?: 'KompaProductSmokeSensors';
  /** Batteriebetrieben */
  batteryPowered?: Maybe<Scalars['Boolean']['output']>;
  /** Innenbereich */
  indoor?: Maybe<Scalars['Boolean']['output']>;
  /** Außenbereich */
  outdoor?: Maybe<Scalars['Boolean']['output']>;
  /** Stromanschluss */
  powerCord?: Maybe<Scalars['Boolean']['output']>;
  /** ID of the product */
  productId?: Maybe<Scalars['String']['output']>;
  /** Reichweitenerhöhung */
  reachEnhencer?: Maybe<Scalars['Boolean']['output']>;
};

/** The input object for smoke_sensors for a kompa product */
export type KompaProductSmokeSensorsParams = {
  /** Batteriebetrieb */
  batteryPowered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Innenbereich */
  indoor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Außenbereich */
  outdoor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Stromanschluss */
  powerCord?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reichweitenerhöhung */
  reachEnhencer?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Field and direction that are used to sort kompa products. */
export type KompaProductSort = {
  __typename?: 'KompaProductSort';
  /** The direction to sort by. */
  direction?: Maybe<SortDirection>;
  /** The field to sort by. */
  field?: Maybe<KompaProductSortField>;
};

/** Enumeration of kompa product field names that support sorting. */
export enum KompaProductSortField {
  /** The product brand. */
  Brand = 'BRAND',
  /** The priority field. */
  Priority = 'PRIORITY',
}

/** Parameters that are used to sort kompa products. */
export type KompaProductSortParams = {
  /** The direction to sort by. */
  direction?: InputMaybe<SortDirection>;
  /** The field to sort by. */
  field?: InputMaybe<KompaProductSortField>;
};

export type KompaProductSpeakers = {
  __typename?: 'KompaProductSpeakers';
  /** Batteriebetrieb */
  batteryPowered?: Maybe<Scalars['Boolean']['output']>;
  /** Mit Zuleitungskabel */
  cable?: Maybe<Scalars['Boolean']['output']>;
  /** Integriertes Mikrofon */
  integratedMicrophone?: Maybe<Scalars['Boolean']['output']>;
  /** Unterstützt Gruppenkontrolle in MSH */
  mshGroupControl?: Maybe<Scalars['Boolean']['output']>;
  /** Unterstützt Playlists in MSH */
  mshPlaylist?: Maybe<Scalars['Boolean']['output']>;
  /** Unterstützt Sprachsteuerung in MSH */
  mshSpeechControl?: Maybe<Scalars['Boolean']['output']>;
  /** Als SmartHome Lautsprecher verwendbar* */
  smarthomeSpeaker?: Maybe<Scalars['Boolean']['output']>;
};

/** The input object for speakers for a kompa product */
export type KompaProductSpeakersParams = {
  /** Batteriebetrieb */
  batteryPowered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mit Zuleitungskabel */
  cable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Integriertes Mikrofon */
  integratedMicrophone?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unterstützt Gruppenkontrolle in MSH */
  mshGroupControl?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unterstützt Playlists in MSH */
  mshPlaylist?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unterstützt Sprachsteuerung in MSH */
  mshSpeechControl?: InputMaybe<Scalars['Boolean']['input']>;
  /** Als SmartHome Lautsprecher verwendbar* */
  smarthomeSpeaker?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KompaProductSwitches = {
  __typename?: 'KompaProductSwitches';
  /** Anzahl belegbare Tasten */
  buttonCount?: Maybe<Scalars['Int']['output']>;
  /** Mit Verbrauchsmessung */
  consumptionMeasuring?: Maybe<Scalars['Boolean']['output']>;
  /** Dimmbar */
  dimmable?: Maybe<Scalars['Boolean']['output']>;
  /** Unterputz */
  inWall?: Maybe<Scalars['Boolean']['output']>;
  /** Mit Markenschaltern kompatibel */
  markenschalterCompatible?: Maybe<Scalars['Boolean']['output']>;
  /** Mobil/Beweglich */
  mobil?: Maybe<Scalars['Boolean']['output']>;
  /** Mehrzweckbuttons */
  multiFunctionButtons?: Maybe<Scalars['Boolean']['output']>;
  /** Aufputz */
  onWall?: Maybe<Scalars['Boolean']['output']>;
  /** Außenbereich */
  outdoor?: Maybe<Scalars['Boolean']['output']>;
  /** ID of the product */
  productId?: Maybe<Scalars['String']['output']>;
};

/** The input object for extions for a kompa product */
export type KompaProductSwitchesParams = {
  /** Anzahl belegbarer Tasten */
  buttonCount?: InputMaybe<Scalars['Int']['input']>;
  /** Mit Verbrauchsmessung */
  consumptionMeasuring?: InputMaybe<Scalars['Boolean']['input']>;
  /** Dimmbar */
  dimmable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unterputz */
  inWall?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mit Markenschaltern kompatibel */
  markenschalterCompatible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mobil/Beweglich */
  mobil?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mehrzweckbuttons */
  multiFunctionButtons?: InputMaybe<Scalars['Boolean']['input']>;
  /** Aufputz */
  onWall?: InputMaybe<Scalars['Boolean']['input']>;
  /** Außenbereich */
  outdoor?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KompaProductVariousSensors = {
  __typename?: 'KompaProductVariousSensors';
  /** Batteriebetrieb */
  batteryPowered?: Maybe<Scalars['Boolean']['output']>;
  /** Innenbereich */
  indoor?: Maybe<Scalars['Boolean']['output']>;
  /** Außenbereich */
  outdoor?: Maybe<Scalars['Boolean']['output']>;
  /** Stromanschluss */
  powerCord?: Maybe<Scalars['Boolean']['output']>;
  /** Erhöht die Funk-Reichweite */
  repeater?: Maybe<Scalars['Boolean']['output']>;
  /** Sabotageschutz* */
  tamperProtection?: Maybe<Scalars['Boolean']['output']>;
};

/** The input object for various_sensors for a kompa product */
export type KompaProductVariousSensorsParams = {
  /** Batteriebetrieb */
  batteryPowered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Innenbereich */
  indoor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Außenbereich */
  outdoor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Stromanschluss */
  powerCord?: InputMaybe<Scalars['Boolean']['input']>;
  /** Erhöht die Funk-Reichweite */
  repeater?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sabotageschutz* */
  tamperProtection?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KompaProductWaterSensors = {
  __typename?: 'KompaProductWaterSensors';
  /** Batteriebetrieben */
  batteryPowered?: Maybe<Scalars['Boolean']['output']>;
  /** Innenbereich */
  indoor?: Maybe<Scalars['Boolean']['output']>;
  /** Außenbereich */
  outdoor?: Maybe<Scalars['Boolean']['output']>;
  /** Stromkabel */
  powerCord?: Maybe<Scalars['Boolean']['output']>;
  /** ID of the product */
  productId?: Maybe<Scalars['String']['output']>;
};

/** The input object for water_sensors for a kompa product */
export type KompaProductWaterSensorsParams = {
  /** Batteriebetrieb */
  batteryPowered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Innenbereich */
  indoor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Außenbereich */
  outdoor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Stromanschluss */
  powerCord?: InputMaybe<Scalars['Boolean']['input']>;
};

export type KompaProductWeatherSensors = {
  __typename?: 'KompaProductWeatherSensors';
  /** Batteriebetrieben */
  batteryPowered?: Maybe<Scalars['Boolean']['output']>;
  /** Innenbereich */
  indoor?: Maybe<Scalars['Boolean']['output']>;
  /** Mit Helligkeits-/Lichtsensor */
  lightsensor?: Maybe<Scalars['Boolean']['output']>;
  /** Außenbereich */
  outdoor?: Maybe<Scalars['Boolean']['output']>;
  /** Stromkabel */
  powerCord?: Maybe<Scalars['Boolean']['output']>;
  /** ID of the product */
  productId?: Maybe<Scalars['String']['output']>;
};

/** The input object for weather_sensors for a kompa product */
export type KompaProductWeatherSensorsParams = {
  /** Batteriebetrieb */
  batteryPowered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Innenbereich */
  indoor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mit Helligkeits-/Lichtsensor */
  lightsensor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Außenbereich */
  outdoor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Stromanschluss */
  powerCord?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Multiple products, paginated and sorted. */
export type KompaProducts = Paginated & {
  __typename?: 'KompaProducts';
  /** Aggregated values from all entries matching the search */
  aggregations?: Maybe<KompaAggregations>;
  /** A list of kompa products. */
  entries?: Maybe<Array<Maybe<KompaProduct>>>;
  pagination?: Maybe<Pagination>;
  /** Field and direction that are used to sort kompa products. */
  sort?: Maybe<KompaProductSort>;
};

/** An attachment that is stored in the Goliath attachment store. */
export type LocalAttachment = Attachment & {
  __typename?: 'LocalAttachment';
  /** The MD5 checksum of the file. */
  checksum?: Maybe<Scalars['String']['output']>;
  /** The attachment content type. */
  contentType?: Maybe<Scalars['String']['output']>;
  /** The file size of the attachment. */
  fileSize?: Maybe<MemorySize>;
  /** Flag that indicates that this attachment is the hero image. There can only be one hero image in a set of attachments */
  isHeroImage?: Maybe<Scalars['Boolean']['output']>;
  /** The unique media ID of the attachment. Used to construct the URLs of the attachment on the cliend side. */
  mediaId?: Maybe<Scalars['String']['output']>;
  /** The attachment name that may be optionally specified as a caption. */
  name?: Maybe<Scalars['String']['output']>;
  /** The path to the attached file. */
  path?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the attachment is stored in Goliath or externally. */
  remote?: Maybe<Scalars['Boolean']['output']>;
  /** List of different media sources to use instead of the main url */
  sources?: Maybe<Array<Maybe<MediaSource>>>;
  /** The thumbnail image path if one is available. */
  thumbImagePath?: Maybe<Scalars['String']['output']>;
  /** The thumbnail image URL if one is available. */
  thumbImageUrl?: Maybe<Scalars['String']['output']>;
  /** The type of the attachment. */
  type?: Maybe<AttachmentType>;
  /** The URL to the attached file. */
  url?: Maybe<Scalars['String']['output']>;
};

/** An attachment that is stored in the Goliath attachment store. */
export type LocalAttachmentSourcesArgs = {
  maxHeight?: InputMaybe<Scalars['Int']['input']>;
  maxWidth?: InputMaybe<Scalars['Int']['input']>;
  mimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  minHeight?: InputMaybe<Scalars['Int']['input']>;
  minWidth?: InputMaybe<Scalars['Int']['input']>;
};

/** Details for a file attachment such as an image, video or document. */
export type MediaSource = {
  __typename?: 'MediaSource';
  /** The URL to the attached file. */
  meta?: Maybe<MediaSourceMeta>;
  /** The MIME type of */
  mime?: Maybe<Scalars['String']['output']>;
  /** The relative path to the attached file. */
  path?: Maybe<Scalars['String']['output']>;
  /** The URL to the attached file. */
  url?: Maybe<Scalars['String']['output']>;
};

/** Meta information about the media source */
export type MediaSourceMeta = {
  __typename?: 'MediaSourceMeta';
  /** The height of the source in px */
  height?: Maybe<Scalars['Int']['output']>;
  /** The width of the source in px */
  width?: Maybe<Scalars['Int']['output']>;
};

/** A type representing value and unit of memory size. */
export type MemorySize = {
  __typename?: 'MemorySize';
  /** The value in Bytes. */
  bytes?: Maybe<Scalars['Int']['output']>;
  /** The unit. */
  unit?: Maybe<MemoryUnit>;
  /** The value of the size. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** An input type for memory sizes. */
export type MemorySizeParams = {
  /** The unit. */
  unit: MemoryUnit;
  /** The value of the size. */
  value: Scalars['Float']['input'];
};

/** Input object that can be used to filter by memory sizes in a specific range. */
export type MemorySizeRangeParams = {
  /** The maximum memory size. */
  max?: InputMaybe<MemorySizeParams>;
  /** The minimum memory size. */
  min?: InputMaybe<MemorySizeParams>;
};

/** An enum type for memory units. */
export enum MemoryUnit {
  /** Bytes */
  B = 'B',
  /** Gigabytes (GB) */
  Gb = 'GB',
  /** Kilobytes (kB) */
  Kb = 'KB',
  /** Megabytes (MB) */
  Mb = 'MB',
  /** Terabytes (TB) */
  Tb = 'TB',
}

export type Mutation = {
  __typename?: 'Mutation';
  /** Decrements the provider-specific stock for the given product. */
  decrementProductStock?: Maybe<ProductAvailability>;
};

export type MutationDecrementProductStockArgs = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  articleNumber: Scalars['ID']['input'];
  provider: ProductProviderKey;
};

/** An interface that describes offer details. */
export type Offer = {
  /** A list of offers that are accessories for the product. */
  accessories?: Maybe<Array<Maybe<DefaultOffer>>>;
  /** Indicates whether the offer is discounted. */
  discounted?: Maybe<Scalars['Boolean']['output']>;
  /** A list of documents attached to the offer. */
  documents?: Maybe<Array<Maybe<Attachment>>>;
  /** The date and time the offer has been inserted at. */
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Indicates whether the offer is listed. */
  list?: Maybe<Scalars['Boolean']['output']>;
  /** The maximum amount that this offer can be bought per order. */
  maxOrderableAmount?: Maybe<Scalars['Int']['output']>;
  /** A list of media objects attached to the offer. */
  media?: Maybe<Array<Maybe<Attachment>>>;
  name: Scalars['String']['output'];
  /** The default onetime price for the offer if one exists. */
  onetimePrice?: Maybe<Price>;
  /** The position of the offer on offer lists. */
  position?: Maybe<Scalars['Int']['output']>;
  /** An additional information about the pricing policy */
  priceExtraInformation?: Maybe<Scalars['String']['output']>;
  /** A list of prices for the offer. */
  prices?: Maybe<Array<Maybe<Price>>>;
  /** The product or bundle. */
  product?: Maybe<Product>;
  /** A list of related offers with alternative products. */
  productAlternatives?: Maybe<Array<Maybe<ProductAlternativeItemGroup>>>;
  /** A list of offers that are recommended for the product. */
  recommendations?: Maybe<Array<Maybe<DefaultOffer>>>;
  /** A list of offer summary texts. */
  summaryTexts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The primary image for this offer. */
  teaserImage?: Maybe<Attachment>;
  /** The date and time the offer has been updated at. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** A list of unique selling propositions for the offer. */
  usps?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * The date and time the offer is valid from. When empty it is considered
   * infinite.
   */
  validFrom?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The date and time the offer is valid until. When empty it is considered
   * infinite.
   */
  validUntil?: Maybe<Scalars['DateTime']['output']>;
  /** Gets the number of variants that this offer has. */
  variantsCount?: Maybe<Scalars['Int']['output']>;
};

/** An interface that describes offer details. */
export type OfferAccessoriesArgs = {
  filter?: InputMaybe<OfferFilterParams>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** An interface that describes offer details. */
export type OfferProductAlternativesArgs = {
  excludeActive?: InputMaybe<Scalars['Boolean']['input']>;
  strict?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An interface that describes offer details. */
export type OfferRecommendationsArgs = {
  filter?: InputMaybe<OfferFilterParams>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** Interface for all kinds of aggregation types. */
export type OfferAggregation = {
  /** The number of entries that are associated with the record. Regards the grouped flag from the particular query. */
  entriesCount?: Maybe<Scalars['Int']['output']>;
  /** The number of offers that are associated with the record. */
  offersCount?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the particular aggregation value has been among the selected filters. */
  selected?: Maybe<Scalars['Boolean']['output']>;
};

/** An object that contains information about aggregated offer counts. */
export type OfferAggregations = {
  __typename?: 'OfferAggregations';
  /**
   * Aggregation containing all available brands and associated offer counts
   * based on the current filter settings.
   */
  brands?: Maybe<Array<Maybe<OfferBrandAggregation>>>;
  /**
   * Aggregation containing offer counts for available colorless, monochromatic
   * and colorful products based on the current filter settings.
   */
  chromaticities?: Maybe<OfferChromaticityAggregationGroup>;
  /**
   * Aggregation containing all available colors and associated offer counts
   * based on the current filter settings.
   */
  colors?: Maybe<Array<Maybe<OfferColorAggregation>>>;
  /**
   * Aggregation containing all available compatible brands and associated
   * offer counts based on the current filter settings.
   */
  compatibleBrands?: Maybe<Array<Maybe<OfferCompatibleBrandAggregation>>>;
  /**
   * Aggregation containing all available compatible product families and
   * associated offer counts based on the current filter settings.
   */
  compatibleProductFamilies?: Maybe<Array<Maybe<OfferCompatibleProductFamilyAggregation>>>;
  /**
   * Aggregation containing available discounted and undiscounted offer counts
   * based on the current filter settings.
   */
  discounts?: Maybe<OfferDiscountsAggregationGroup>;
  /**
   * Aggregation containing the minimum and maximum onetime prices
   * based on the current filter settings. Returns price values in cents.
   */
  price?: Maybe<PriceValueRange>;
  /**
   * Aggregation containing all available product categories and associated
   * offer counts based on the current filter settings.
   */
  productCategories?: Maybe<Array<Maybe<OfferProductCategoryAggregation>>>;
  /**
   * Aggregation containing all available product tags and associated offers
   * counts based on the current filter settings.
   */
  productTags?: Maybe<Array<Maybe<OfferProductTagAggregation>>>;
  /**
   * Aggregation containing all available storage sizes from the product and
   * the associated offer counts based on the current filter settings.
   */
  storageSizes?: Maybe<Array<Maybe<OfferMemorySizeAggregation>>>;
};

/** An object that contains information about aggregated offer counts. */
export type OfferAggregationsBrandsArgs = {
  minOffersCount?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** An object that contains information about aggregated offer counts. */
export type OfferAggregationsColorsArgs = {
  minOffersCount?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** An object that contains information about aggregated offer counts. */
export type OfferAggregationsCompatibleBrandsArgs = {
  minOffersCount?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<CompatibleBrandSortParams>;
};

/** An object that contains information about aggregated offer counts. */
export type OfferAggregationsCompatibleProductFamiliesArgs = {
  minOffersCount?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<CompatibleProductFamilySortParams>;
};

/** An object that contains information about aggregated offer counts. */
export type OfferAggregationsProductCategoriesArgs = {
  filter?: InputMaybe<ProductCategoryFilterParams>;
  minOffersCount?: InputMaybe<Scalars['Int']['input']>;
};

/** An object that contains information about aggregated offer counts. */
export type OfferAggregationsProductTagsArgs = {
  minOffersCount?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** An object that contains information about aggregated offer counts. */
export type OfferAggregationsStorageSizesArgs = {
  minOffersCount?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** Object containing information about an aggregated brand. */
export type OfferBrandAggregation = OfferAggregation & {
  __typename?: 'OfferBrandAggregation';
  /** The brand. */
  brand?: Maybe<Brand>;
  /** The number of entries that are associated with the record. Regards the grouped flag from the particular query. */
  entriesCount?: Maybe<Scalars['Int']['output']>;
  /** The number of offers that are associated with the record. */
  offersCount?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the particular aggregation value has been among the selected filters. */
  selected?: Maybe<Scalars['Boolean']['output']>;
};

/** Object containing information about an discount aggregation. */
export type OfferChromaticityAggregation = OfferAggregation & {
  __typename?: 'OfferChromaticityAggregation';
  /** The number of entries that are associated with the record. Regards the grouped flag from the particular query. */
  entriesCount?: Maybe<Scalars['Int']['output']>;
  /** The number of offers that are associated with the record. */
  offersCount?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the particular aggregation value has been among the selected filters. */
  selected?: Maybe<Scalars['Boolean']['output']>;
};

/** Object representing a group of discount aggregations. */
export type OfferChromaticityAggregationGroup = {
  __typename?: 'OfferChromaticityAggregationGroup';
  /** Aggregation for offers with colorful products. */
  colorful?: Maybe<OfferChromaticityAggregation>;
  /** Aggregation for offers with colorless products. */
  colorless?: Maybe<OfferChromaticityAggregation>;
  /** Aggregation for offers with monochromatic products. */
  monochromatic?: Maybe<OfferChromaticityAggregation>;
};

/** Object containing information about an aggregated color. */
export type OfferColorAggregation = OfferAggregation & {
  __typename?: 'OfferColorAggregation';
  /** The color. */
  color?: Maybe<PaletteColor>;
  /**
   * The color code.
   * @deprecated Please use the color field instead.
   */
  colorCode?: Maybe<Scalars['ColorCode']['output']>;
  /** The number of entries that are associated with the record. Regards the grouped flag from the particular query. */
  entriesCount?: Maybe<Scalars['Int']['output']>;
  /** The number of offers that are associated with the record. */
  offersCount?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the particular aggregation value has been among the selected filters. */
  selected?: Maybe<Scalars['Boolean']['output']>;
};

/** Object containing information about an aggregated compatible brand. */
export type OfferCompatibleBrandAggregation = OfferAggregation & {
  __typename?: 'OfferCompatibleBrandAggregation';
  /** The compatible brand. */
  brand?: Maybe<Brand>;
  /** The number of entries that are associated with the record. Regards the grouped flag from the particular query. */
  entriesCount?: Maybe<Scalars['Int']['output']>;
  /** The number of offers that are associated with the record. */
  offersCount?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the particular aggregation value has been among the selected filters. */
  selected?: Maybe<Scalars['Boolean']['output']>;
};

/** Object containing information about an aggregated compatible product family. */
export type OfferCompatibleProductFamilyAggregation = OfferAggregation & {
  __typename?: 'OfferCompatibleProductFamilyAggregation';
  /** The number of entries that are associated with the record. Regards the grouped flag from the particular query. */
  entriesCount?: Maybe<Scalars['Int']['output']>;
  /** The number of offers that are associated with the record. */
  offersCount?: Maybe<Scalars['Int']['output']>;
  /** The compatible product family. */
  productFamily?: Maybe<StandardProductFamily>;
  /** Indicates whether the particular aggregation value has been among the selected filters. */
  selected?: Maybe<Scalars['Boolean']['output']>;
};

/** Object containing information about an discount aggregation. */
export type OfferDiscountsAggregation = OfferAggregation & {
  __typename?: 'OfferDiscountsAggregation';
  /** The number of entries that are associated with the record. Regards the grouped flag from the particular query. */
  entriesCount?: Maybe<Scalars['Int']['output']>;
  /** The number of offers that are associated with the record. */
  offersCount?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the particular aggregation value has been among the selected filters. */
  selected?: Maybe<Scalars['Boolean']['output']>;
};

/** Object representing a group of discount aggregations. */
export type OfferDiscountsAggregationGroup = {
  __typename?: 'OfferDiscountsAggregationGroup';
  /** Aggregation for discounted offers. */
  discounted?: Maybe<OfferDiscountsAggregation>;
  /** Aggregation for undiscounted offers. */
  undiscounted?: Maybe<OfferDiscountsAggregation>;
};

/** Parameters that can be used to filter an offer collection by. */
export type OfferFilterParams = {
  /** Filters the offers by the given list of product tag slugs. The offer must have at least on matching product tag slug per group over all groups. */
  anyInGroupOfProductTagSlugs?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  /** A list of article numbers to filter offers by. */
  articleNumbers?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filters the offers by not inlcuding offers with these article numbers */
  blacklistArticleNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filters the offers by the brand slugs of the associated product. */
  brandSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filters the offers by the chromaticities of their products. */
  chromaticities?: InputMaybe<Array<ProductChromaticity>>;
  /** Filters the offers by the given color codes. */
  colorCodes?: InputMaybe<Array<Scalars['ColorCode']['input']>>;
  /** Filters the offers by the color slugs of the associated product. */
  colorSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filters the offers by the given compatible brand slugs. */
  compatibleBrandSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filters the offers by the given compatible product family slugs. */
  compatibleProductFamilySlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filters the result set by discounted offers if set to true. Gets only undiscounted offers when false. */
  discounted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters the result set by available or unavailable offers includes always displayed products */
  hasAlwaysDisplayed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters the offers by the kompa product attributes of its family. */
  kompaProduct?: InputMaybe<KompaProductFilterParams>;
  /** Determines whether only offers visible on list pages should be retrieved. */
  listed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters the offers by the given product tag slugs. The offer must have at least one of them. */
  oneOfProductTagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filters the offers by the onetime price. */
  onetimePrice?: InputMaybe<PriceFilterParams>;
  /** Filters the result set by available or unavailable offers. */
  productAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filters offers by product category paths. */
  productCategoryPaths?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filters the offers by the given product providers. */
  productProviders?: InputMaybe<Array<ProductProviderKey>>;
  /** Filters the offers by the given product tag slugs. The offer must have all of them. */
  productTagSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filters the offers by the given product tags. */
  productTags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filters the offers by the min and max storage size. */
  storageSizeRange?: InputMaybe<MemorySizeRangeParams>;
  /** Filters the offers by the given storage sizes. */
  storageSizes?: InputMaybe<Array<MemorySizeParams>>;
};

/** Object containing information about an aggregated memory size. */
export type OfferMemorySizeAggregation = OfferAggregation & {
  __typename?: 'OfferMemorySizeAggregation';
  /** The number of entries that are associated with the record. Regards the grouped flag from the particular query. */
  entriesCount?: Maybe<Scalars['Int']['output']>;
  /** The number of offers that are associated with the record. */
  offersCount?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the particular aggregation value has been among the selected filters. */
  selected?: Maybe<Scalars['Boolean']['output']>;
  /** The memory size. */
  size?: Maybe<MemorySize>;
};

/** Object containing information about an aggregated product category. */
export type OfferProductCategoryAggregation = OfferAggregation & {
  __typename?: 'OfferProductCategoryAggregation';
  /** A list of nested product category aggregations. */
  children?: Maybe<Array<Maybe<OfferProductCategoryAggregation>>>;
  /** The number of entries that are associated with the record. Regards the grouped flag from the particular query. */
  entriesCount?: Maybe<Scalars['Int']['output']>;
  /** The number of offers that are associated with the record. */
  offersCount?: Maybe<Scalars['Int']['output']>;
  /** The product category. */
  productCategory?: Maybe<ProductCategory>;
  /** Indicates whether the particular aggregation value has been among the selected filters. */
  selected?: Maybe<Scalars['Boolean']['output']>;
};

/** Object containing information about an aggregated product tag. */
export type OfferProductTagAggregation = OfferAggregation & {
  __typename?: 'OfferProductTagAggregation';
  /** The number of entries that are associated with the record. Regards the grouped flag from the particular query. */
  entriesCount?: Maybe<Scalars['Int']['output']>;
  /** The number of offers that are associated with the record. */
  offersCount?: Maybe<Scalars['Int']['output']>;
  /** Indicates whether the particular aggregation value has been among the selected filters. */
  selected?: Maybe<Scalars['Boolean']['output']>;
  /** The product tag. */
  tag?: Maybe<Tag>;
};

/** Parameters that can be used to search an offers collection by */
export type OfferSearchParams = {
  fields: Array<InputMaybe<Scalars['String']['input']>>;
  filters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notFilters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  orFilters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Information about how the list of published offers is sorted. */
export type OfferSort = {
  __typename?: 'OfferSort';
  /** The sort direction. */
  direction?: Maybe<SortDirection>;
  /** The field to sort by. */
  field?: Maybe<OfferSortField>;
};

/** The fields that published offers can be sorted by. */
export enum OfferSortField {
  /** The insertion time field. */
  InsertedAt = 'INSERTED_AT',
  /** The offer name, composed of product name. */
  Name = 'NAME',
  /** The onetime price. */
  OnetimePrice = 'ONETIME_PRICE',
  /** The manually defined position field. */
  Recommendation = 'RECOMMENDATION',
  /** The relevance as automatically determined by the search engine. */
  Relevance = 'RELEVANCE',
}

/** Parameters to specify how to sort the list of published offers. */
export type OfferSortParams = {
  /** The sort direction (ascending or descending). */
  direction: SortDirection;
  /** The field to sort by. */
  field: OfferSortField;
};

/**
 * Contains a collection of multiple paginated and sorted offers and some meta
 * data.
 */
export type Offers = {
  __typename?: 'Offers';
  /**
   * Details about filter aggregations, offer details about how many documents
   * match to certain criteria.
   */
  aggregations?: Maybe<OfferAggregations>;
  /** A list of offers. */
  entries?: Maybe<Array<Maybe<CollapsibleOffer>>>;
  /** Pagination details for the chunk of offers. */
  pagination?: Maybe<Pagination>;
  /** Specifies which field and direction the result set is sorted by. */
  sort?: Maybe<OfferSort>;
  /**
   * A list of terms that can be used as alternative or suggested search query.
   * When a term is unknown, the particular list item contains a suggestion
   * for a proper replacement.
   */
  suggestedSearchTerms?: Maybe<Array<Maybe<SearchTermSuggestion>>>;
  /**
   * The total number of offers, never grouped by the product family of the
   * offer.
   */
  variantsCount?: Maybe<Scalars['Int']['output']>;
};

/** An enum type for import origins. */
export enum Origin {
  /** Brodos AG */
  Brodos = 'BRODOS',
  /** Telekom Phoenix Shop Database */
  Pxsdb = 'PXSDB',
}

/** An interface that is implemented by paginated collection types. */
export type Paginated = {
  /** Holds page information for a collection that has split into multiple pages. */
  pagination?: Maybe<Pagination>;
};

/** A reflection type to retrieve details about a paginated collection. */
export type Pagination = {
  __typename?: 'Pagination';
  /** The page number. */
  page?: Maybe<Scalars['Int']['output']>;
  /** The number of entries to maximally display on a single page. */
  size?: Maybe<Scalars['Int']['output']>;
  /** The total number of entries. */
  totalCount?: Maybe<Scalars['Int']['output']>;
  /** The total number of pages. */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

/** An input type to define the page and page size of a collection. */
export type PaginationParams = {
  /** The page number. */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** The number of entries to maximally display on a single page. */
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** A type representing a color from the tenant color palette. */
export type PaletteColor = {
  __typename?: 'PaletteColor';
  /** The color hex code. */
  code?: Maybe<Scalars['ColorCode']['output']>;
  /** The name of the color. */
  name?: Maybe<Scalars['String']['output']>;
  /** The color slug. */
  slug?: Maybe<Scalars['String']['output']>;
};

/** The payment frequency of a price. */
export enum PaymentFrequency {
  /** A price that is due for payment every month. */
  Monthly = 'MONTHLY',
  /** A price that is paid once. */
  Onetime = 'ONETIME',
}

/** An object containing price details. */
export type Price = {
  __typename?: 'Price';
  /** The price value in the smallest subunit for the particular currency. */
  amount?: Maybe<Scalars['Int']['output']>;
  /** The ISO 4217 currency code for the price. */
  currency?: Maybe<Scalars['String']['output']>;
  /** The payment frequency of a price. */
  paymentFrequency?: Maybe<PaymentFrequency>;
  /** The type of a price. */
  type?: Maybe<PriceType>;
  /** The price value. */
  value?: Maybe<Scalars['Money']['output']>;
};

/** Input object that can be used to filter by prices in a specific range. */
export type PriceFilterParams = {
  /** The maximum price. */
  max?: InputMaybe<Scalars['Money']['input']>;
  /** The minimum price. */
  min?: InputMaybe<Scalars['Money']['input']>;
};

/** An object containing a minimum and maximum price. */
export type PriceRange = {
  __typename?: 'PriceRange';
  /** Indicates whether minimum and maximum prices are equal. */
  equal?: Maybe<Scalars['Boolean']['output']>;
  /** The maximum price. */
  max?: Maybe<Price>;
  /** The minimum price. */
  min?: Maybe<Price>;
};

/** The type of a price. */
export enum PriceType {
  /** A normal price. */
  Default = 'DEFAULT',
  /** A was-price which is usually the retail price as recommended by the seller or manufacturer. */
  Was = 'WAS',
}

/**
 * An object containing minimum and maximum price values for aggregations.
 * The values represent the price in cents (e.g., 500 for 5 EUR, 10050 for 100 EUR and 50 cents).
 */
export type PriceValueRange = {
  __typename?: 'PriceValueRange';
  /** Indicates whether minimum and maximum prices are equal. */
  equal?: Maybe<Scalars['Boolean']['output']>;
  /** The maximum price value in cents. */
  max?: Maybe<Scalars['Int']['output']>;
  /** The minimum price value in cents. */
  min?: Maybe<Scalars['Int']['output']>;
};

/** An interface that is used by standard and bundle products. */
export type Product = {
  /** Flag which sets awlays_displayed property */
  alwaysDisplayed?: Maybe<Scalars['Boolean']['output']>;
  /** A unique article number for the product. This is not neccessarily the same as the EAN. It is an internal identifier that is used to identify a product or bundle. */
  articleNumber?: Maybe<Scalars['String']['output']>;
  /** Details about the availability of the product. */
  availability?: Maybe<ProductAvailability>;
  /** Determines whether the product consists of multiple items. */
  bundle?: Maybe<Scalars['Boolean']['output']>;
  /** A list of article numbers of contained items. */
  bundledArticleNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * The approximate time that is needed for the product to get shipped to
   * the customer.
   * @deprecated Please use the delivery lead time from the availability field instead.
   *
   */
  deliveryLeadTime?: Maybe<Scalars['String']['output']>;
  /** A detailed product description. May contain HTML content that is used to enrich the product with search engine optimized information. */
  description?: Maybe<Scalars['String']['output']>;
  /** A list of documents attached to the offer. */
  documents?: Maybe<Array<Maybe<Attachment>>>;
  /** A list of all EANs of contained items. */
  eans?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  family?: Maybe<ProductFamily>;
  /** A list of legal texts. */
  legalTexts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** A list of media objects attached to the product. */
  media?: Maybe<Array<Maybe<Attachment>>>;
  /** Gets the name of the product. */
  name?: Maybe<Scalars['String']['output']>;
  /** An identifier for the enabler that the product originated from. */
  origin?: Maybe<Origin>;
  /** A shorter list of product USPs. */
  shortUsp?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The product slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /**
   * The number of units available in stock.
   * @deprecated Please use the stock from the availability field instead.
   */
  stock?: Maybe<ProductStock>;
  /** A list of product summary texts. */
  summaryTexts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Tags for the product with additional details. */
  tagDetails?: Maybe<Array<Maybe<Tag>>>;
  /** Tags for the product. */
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The primary image for this product. */
  teaserImage?: Maybe<Attachment>;
  /** A list of product USPs. */
  usps?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

/** An interface that is used by standard and bundle products. */
export type ProductAvailabilityArgs = {
  live?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An interface that is used by standard and bundle products. */
export type ProductStockArgs = {
  live?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * An alternative offer that contains a product differing from the original
 * product.
 */
export type ProductAlternative = {
  __typename?: 'ProductAlternative';
  /** Determines whether the alternative offer is the same offer as the original one. */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Determines whether the alternative offer exactly matches the criteria that are needed to be considered a real alternative. Is false if it does not match. */
  exactMatch?: Maybe<Scalars['Boolean']['output']>;
  /** The offer that has been found as alternative. */
  offer?: Maybe<ScopedOffer>;
};

/**
 * A list of alternative offers grouped by the product families of contained
 * products.
 */
export type ProductAlternativeItemGroup = {
  __typename?: 'ProductAlternativeItemGroup';
  /** The name of the product family that the alternatives are determined for. */
  family?: Maybe<StandardProductFamily>;
  /** The position in the list. */
  position?: Maybe<Scalars['Int']['output']>;
  /** A list of alternative product offers grouped by the particular selector properties. */
  properties?: Maybe<Array<Maybe<ProductAlternativeSelectorGroup>>>;
};

/**
 * A list of alternative offers grouped by the selectors of a specific product
 * family.
 */
export type ProductAlternativeSelectorGroup = {
  __typename?: 'ProductAlternativeSelectorGroup';
  /** A list of alternative product offers. */
  alternatives?: Maybe<Array<Maybe<ProductAlternative>>>;
  /** The selector property. */
  key?: Maybe<ProductSelectorField>;
};

/** An object containing product availability details. */
export type ProductAvailability = {
  __typename?: 'ProductAvailability';
  /** Determines whether the product is available at the enabler. */
  available?: Maybe<Scalars['Boolean']['output']>;
  /** The estimated delivery lead time for the product. */
  deliveryLeadTime?: Maybe<DeliveryLeadTime>;
  /** The product provider. */
  provider?: Maybe<ProductProviderKey>;
  /** The units available in stock. */
  stock?: Maybe<Scalars['Int']['output']>;
};

/**
 * An object containing product availability details and the associated article
 * number.
 */
export type ProductAvailabilityDetail = {
  __typename?: 'ProductAvailabilityDetail';
  /** The article number. */
  articleNumber?: Maybe<Scalars['ID']['output']>;
  /** The availability data. */
  availability?: Maybe<ProductAvailability>;
  /** Gets an offer for the particular product. */
  offer?: Maybe<DefaultOffer>;
  /** Determines whether an offer for the particular product is available. */
  productExists?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Contains a collection of multiple sorted product categories and some meta
 * data.
 */
export type ProductCategories = {
  __typename?: 'ProductCategories';
  /** A list of product categories. */
  entries?: Maybe<Array<Maybe<ProductCategoryAggregation>>>;
  /** Pagination details for the chunk of product categories. */
  pagination?: Maybe<Pagination>;
  /** Specifies which field and direction the result setis sorted by. */
  sort?: Maybe<ProductCategorySort>;
};

/** The category a product family belongs to. */
export type ProductCategory = {
  __typename?: 'ProductCategory';
  /** The product category ancestors. */
  ancestors?: Maybe<Array<Maybe<ProductCategory>>>;
  /** The category number. */
  categoryNumber?: Maybe<Scalars['String']['output']>;
  /** The depth of the category in the hierarchy. */
  depth?: Maybe<Scalars['Int']['output']>;
  /** The name of the product category. */
  name?: Maybe<Scalars['String']['output']>;
  /** The parent product category. */
  parent?: Maybe<ProductCategory>;
  /** The full path of the product category. */
  path?: Maybe<Scalars['String']['output']>;
  /** The slug of the product category. */
  slug?: Maybe<Scalars['String']['output']>;
};

/** Object containing information about an aggregated product category. */
export type ProductCategoryAggregation = {
  __typename?: 'ProductCategoryAggregation';
  /** A list of nested product category aggregations. */
  children?: Maybe<Array<Maybe<ProductCategoryAggregation>>>;
  /** The number of offers that are associated with the record. */
  offersCount?: Maybe<Scalars['Int']['output']>;
  /** The product category. */
  productCategory?: Maybe<ProductCategory>;
};

/** Parameters to filter the collection of categories by. */
export type ProductCategoryFilterParams = {
  /** The parent path to filter by. */
  parentPath?: InputMaybe<Scalars['String']['input']>;
  /** Filters product categories by those that contain available products. */
  withAvailableProducts?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Information about how the list of published product categories is sorted. */
export type ProductCategorySort = {
  __typename?: 'ProductCategorySort';
  /** The sort direction (ascending or descending). */
  direction?: Maybe<SortDirection>;
  /** The field to sort by. */
  field?: Maybe<ProductCategorySortField>;
};

/** The fields that categories can be sorted by. */
export enum ProductCategorySortField {
  /** The product category name. */
  Name = 'NAME',
}

/** Parameters to specify how to sort the list of categories. */
export type ProductCategorySortParams = {
  /** The sort direction (ascending or descending). */
  direction: SortDirection;
  /** The field to sort by. */
  field: ProductCategorySortField;
};

/** An enum representing the chromaticity of a product. */
export enum ProductChromaticity {
  /** The product has multiple colors. */
  Colorful = 'COLORFUL',
  /** The product has no colors. */
  Colorless = 'COLORLESS',
  /** The product has a single color. */
  Monochromatic = 'MONOCHROMATIC',
}

/**
 * A type that describes the grouped PXSDB Features for the products
 * in a product_family.
 */
export type ProductFamiliesPxsdbFeatures = {
  __typename?: 'ProductFamiliesPxsdbFeatures';
  /** A list of PXSDB features for the product _family. */
  entries?: Maybe<Array<Maybe<SlugAndFeatures>>>;
};

/** An interface that is used by standard and bundle product families. */
export type ProductFamily = {
  /** A list of categories that the product family belongs to. */
  categories?: Maybe<Array<Maybe<ProductCategory>>>;
  /** An unique identifier for the product family. */
  familyNumber?: Maybe<Scalars['String']['output']>;
  /** Gets the name of the product family. */
  name?: Maybe<Scalars['String']['output']>;
  /** The popularity of the product family. */
  popularity?: Maybe<Scalars['Int']['output']>;
  /** Most precise categories that are available for the product family. */
  preciseCategories?: Maybe<Array<Maybe<ProductCategory>>>;
  /** The primary category that the product family belongs to. */
  primaryCategory?: Maybe<ProductCategory>;
  /** Root categories that the product family belongs to. */
  rootCategories?: Maybe<Array<Maybe<ProductCategory>>>;
  /** The slug of the product family. */
  slug?: Maybe<Scalars['String']['output']>;
};

/** An interface that is used by standard and bundle product families. */
export type ProductFamilyPrimaryCategoryArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** An object representing a compatibility. */
export type ProductFamilyCompatibility = {
  __typename?: 'ProductFamilyCompatibility';
  /** The product family that the source family is compatible to. */
  family?: Maybe<StandardProductFamily>;
  /** An offer that uses the compatible product family. */
  offer?: Maybe<Offer>;
  /** A list of alternative requirements for the compatibility. */
  requirementAlternatives?: Maybe<Array<Maybe<ProductFamilyCompatibilityRequirementAlternative>>>;
};

/** An object representing a requirement for a compatibility. */
export type ProductFamilyCompatibilityRequirement = {
  __typename?: 'ProductFamilyCompatibilityRequirement';
  /** The product family required to fulfill the compatibility. */
  family?: Maybe<StandardProductFamily>;
  /** An offer for the required product family. */
  offer?: Maybe<Offer>;
};

/** An object representing an alternative requirement. */
export type ProductFamilyCompatibilityRequirementAlternative = {
  __typename?: 'ProductFamilyCompatibilityRequirementAlternative';
  /** The number of the requirement group in the collection. */
  group?: Maybe<Scalars['Int']['output']>;
  /** A list of compatibility requirements. */
  requirements?: Maybe<Array<Maybe<ProductFamilyCompatibilityRequirement>>>;
};

/** An actual product family */
export type ProductFamilyItem = {
  __typename?: 'ProductFamilyItem';
  /** The name of the brand */
  brandName?: Maybe<Scalars['String']['output']>;
  /** The slug of the brand */
  brandSlug?: Maybe<Scalars['String']['output']>;
  /** A list of slugs of families that are known to be compatible */
  compatibleFamilySlugs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The family number. The family number itself will become obselete in the future but remains listed for families that still have it. */
  familyNumber?: Maybe<Scalars['String']['output']>;
  /** The name of the family */
  name: Scalars['String']['output'];
  /** The slug of the family */
  slug: Scalars['String']['output'];
};

/** An interface for publicly available product families */
export type ProductFamilyItems = Paginated & {
  __typename?: 'ProductFamilyItems';
  entries?: Maybe<Array<Maybe<ProductFamilyItem>>>;
  pagination?: Maybe<Pagination>;
};

/** An enum type for product providers. */
export enum ProductProviderKey {
  /** Brodos AG */
  Brodos = 'BRODOS',
  /** Telekom Deutschland GmbH */
  Telekom = 'TELEKOM',
}

/** An enumeration that contains fields which can be used as selector. */
export enum ProductSelectorField {
  /** The color field. */
  Color = 'COLOR',
  /** The memory field. */
  Memory = 'MEMORY',
  /** The size field. */
  Size = 'SIZE',
  /** The storage field. */
  Storage = 'STORAGE',
}

/** An object containing product stock details. */
export type ProductStock = {
  __typename?: 'ProductStock';
  /** The units available in stock. */
  amount?: Maybe<Scalars['Int']['output']>;
  /** Determines whether the product is available at the enabler. */
  available?: Maybe<Scalars['Boolean']['output']>;
  /** The product provider. */
  origin?: Maybe<ProductProviderKey>;
  /** The product provider. */
  provider?: Maybe<ProductProviderKey>;
};

/** An object containing product stock details and the associated article number. */
export type ProductStockWithArticleNumber = {
  __typename?: 'ProductStockWithArticleNumber';
  /** The article number. */
  articleNumber?: Maybe<Scalars['ID']['output']>;
  /** The stock data. */
  stock?: Maybe<ProductStock>;
};

/** A type that describes a product recommendation. */
export type PxsdbFeature = {
  __typename?: 'PxsdbFeature';
  /** The key of the feature, eg PMOB_0000 or ZMORF. */
  key?: Maybe<Scalars['String']['output']>;
  /** A human readable name matching the key. */
  name?: Maybe<Scalars['String']['output']>;
  /** The value of the feature. */
  value?: Maybe<Scalars['String']['output']>;
  /** A human readable label for the value, if provided by the source. */
  valueLabel?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  kompaProducts?: Maybe<KompaProducts>;
  /** Gets a single published offer using an article number. */
  offer?: Maybe<DefaultOffer>;
  /** Gets a single published offer using a product slug. */
  offerBySlugs?: Maybe<DefaultOffer>;
  /**
   * Gets a list of offers that are published for the authenticated tenant. The
   * result set can be searched, filtered, paginated and sorted on.
   */
  offers?: Maybe<Offers>;
  /**
   * Gets the availability data for multiple products using a list of article
   * numbers.
   */
  productAvailabilities?: Maybe<Array<Maybe<ProductAvailabilityDetail>>>;
  /** Gets the availability data for multiple products using an article number. */
  productAvailability?: Maybe<ProductAvailabilityDetail>;
  /**
   * Gets a list of product categories that are available for the authenticated
   * tenant. The result can be sorted on.
   */
  productCategories?: Maybe<ProductCategories>;
  productFamilies?: Maybe<ProductFamilyItems>;
  productFamiliesPxsdbFeatures?: Maybe<ProductFamiliesPxsdbFeatures>;
  /**
   * Gets the stock data for multiple products using anarticle number.
   * @deprecated Please use `productAvailability` query instead.
   */
  productStock?: Maybe<ProductStock>;
  /**
   * Gets the stock data for multiple products using a list of article numbers.
   * @deprecated Please use `productAvailabilities` query instead.
   */
  productStocks?: Maybe<Array<Maybe<ProductStockWithArticleNumber>>>;
};

export type QueryKompaProductsArgs = {
  filter?: InputMaybe<KompaProductFilterParams>;
  pagination?: InputMaybe<PaginationParams>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<KompaProductSortParams>;
};

export type QueryOfferArgs = {
  articleNumber?: InputMaybe<Scalars['ID']['input']>;
  validAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryOfferBySlugsArgs = {
  productSlug?: InputMaybe<Scalars['String']['input']>;
  validAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryOffersArgs = {
  complexSearch?: InputMaybe<OfferSearchParams>;
  filter?: InputMaybe<OfferFilterParams>;
  grouped?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationParams>;
  search?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<OfferSortParams>;
  validAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryProductAvailabilitiesArgs = {
  articleNumbers: Array<Scalars['ID']['input']>;
  live?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryProductAvailabilityArgs = {
  articleNumber: Scalars['ID']['input'];
  live?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryProductCategoriesArgs = {
  filter?: InputMaybe<ProductCategoryFilterParams>;
  pagination?: InputMaybe<PaginationParams>;
  sort?: InputMaybe<ProductCategorySortParams>;
  validAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type QueryProductFamiliesArgs = {
  filter?: InputMaybe<FamilyFilterParams>;
  pagination?: InputMaybe<PaginationParams>;
};

export type QueryProductFamiliesPxsdbFeaturesArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryProductStockArgs = {
  articleNumber: Scalars['ID']['input'];
  live?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryProductStocksArgs = {
  articleNumbers: Array<Scalars['ID']['input']>;
  live?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An attachment that is stored on a remote server. */
export type RemoteAttachment = Attachment & {
  __typename?: 'RemoteAttachment';
  /** Flag that indicates that this attachment is the hero image. There can only be one hero image in a set of attachments */
  isHeroImage?: Maybe<Scalars['Boolean']['output']>;
  /** The attachment name that may be optionally specified as a caption. */
  name?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the attachment is stored in Goliath or externally. */
  remote?: Maybe<Scalars['Boolean']['output']>;
  /** List of different media sources to use instead of the main url */
  sources?: Maybe<Array<Maybe<MediaSource>>>;
  /** The thumbnail image URL if one is available. */
  thumbImageUrl?: Maybe<Scalars['String']['output']>;
  /** The type of the attachment. */
  type?: Maybe<AttachmentType>;
  /** The URL to the attached file. */
  url?: Maybe<Scalars['String']['output']>;
};

/** An attachment that is stored on a remote server. */
export type RemoteAttachmentSourcesArgs = {
  maxHeight?: InputMaybe<Scalars['Int']['input']>;
  maxWidth?: InputMaybe<Scalars['Int']['input']>;
  mimes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  minHeight?: InputMaybe<Scalars['Int']['input']>;
  minWidth?: InputMaybe<Scalars['Int']['input']>;
};

/** An enum type that contains all EU repairability classes. */
export enum RepairabilityClass {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
  F = 'F',
  G = 'G',
}

/**
 * An object that contains offer details. This particular type is used in
 * product alternatives to provide an additional field that allows retrieving
 * a scoped product that can be used to retrieve variant details in the
 * alternatives list.
 */
export type ScopedOffer = Offer & {
  __typename?: 'ScopedOffer';
  /** A list of offers that are accessories for the product. */
  accessories?: Maybe<Array<Maybe<DefaultOffer>>>;
  /** Indicates whether the offer is discounted. */
  discounted?: Maybe<Scalars['Boolean']['output']>;
  /** A list of documents attached to the offer. */
  documents?: Maybe<Array<Maybe<Attachment>>>;
  /** The date and time the offer has been inserted at. */
  insertedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Indicates whether the offer is listed. */
  list?: Maybe<Scalars['Boolean']['output']>;
  /** The maximum amount that this offer can be bought per order. */
  maxOrderableAmount?: Maybe<Scalars['Int']['output']>;
  /** A list of media objects attached to the offer. */
  media?: Maybe<Array<Maybe<Attachment>>>;
  name: Scalars['String']['output'];
  /** The default onetime price for the offer if one exists. */
  onetimePrice?: Maybe<Price>;
  /** The position of the offer on offer lists. */
  position?: Maybe<Scalars['Int']['output']>;
  /** An additional information about the pricing policy */
  priceExtraInformation?: Maybe<Scalars['String']['output']>;
  /** A list of prices for the offer. */
  prices?: Maybe<Array<Maybe<Price>>>;
  /** The product or bundle. */
  product?: Maybe<Product>;
  /** A list of related offers with alternative products. */
  productAlternatives?: Maybe<Array<Maybe<ProductAlternativeItemGroup>>>;
  /** A list of offers that are recommended for the product. */
  recommendations?: Maybe<Array<Maybe<DefaultOffer>>>;
  /** The scoped product always contains a standard product that can be used to retrieve variant details in the alternatives list. */
  scopedProduct?: Maybe<StandardProduct>;
  /** A list of offer summary texts. */
  summaryTexts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The primary image for this offer. */
  teaserImage?: Maybe<Attachment>;
  /** The date and time the offer has been updated at. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** A list of unique selling propositions for the offer. */
  usps?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * The date and time the offer is valid from. When empty it is considered
   * infinite.
   */
  validFrom?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The date and time the offer is valid until. When empty it is considered
   * infinite.
   */
  validUntil?: Maybe<Scalars['DateTime']['output']>;
  /** Gets the number of variants that this offer has. */
  variantsCount?: Maybe<Scalars['Int']['output']>;
};

/**
 * An object that contains offer details. This particular type is used in
 * product alternatives to provide an additional field that allows retrieving
 * a scoped product that can be used to retrieve variant details in the
 * alternatives list.
 */
export type ScopedOfferAccessoriesArgs = {
  filter?: InputMaybe<OfferFilterParams>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * An object that contains offer details. This particular type is used in
 * product alternatives to provide an additional field that allows retrieving
 * a scoped product that can be used to retrieve variant details in the
 * alternatives list.
 */
export type ScopedOfferProductAlternativesArgs = {
  excludeActive?: InputMaybe<Scalars['Boolean']['input']>;
  strict?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * An object that contains offer details. This particular type is used in
 * product alternatives to provide an additional field that allows retrieving
 * a scoped product that can be used to retrieve variant details in the
 * alternatives list.
 */
export type ScopedOfferRecommendationsArgs = {
  filter?: InputMaybe<OfferFilterParams>;
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** An object containing details for a search term suggestion. */
export type SearchTermSuggestion = {
  __typename?: 'SearchTermSuggestion';
  /** The original term. */
  originalTerm?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the term has been replaced. */
  replaced?: Maybe<Scalars['Boolean']['output']>;
  /** The original or suggested term. */
  term?: Maybe<Scalars['String']['output']>;
};

/** List of features common to all products in the product_family */
export type SlugAndFeatures = {
  __typename?: 'SlugAndFeatures';
  features?: Maybe<Array<Maybe<FeatureKeyAndName>>>;
  /** The slug of a product familes. */
  slug?: Maybe<Scalars['String']['output']>;
};

/** An enumeration that controls the direction of sorting. */
export enum SortDirection {
  /** Sorts a field in ascending order. */
  Asc = 'ASC',
  /** Sorts a field in descending order. */
  Desc = 'DESC',
}

/** An object containing details for a standard product. */
export type StandardProduct = Product & {
  __typename?: 'StandardProduct';
  /** Flag which sets awlays_displayed property */
  alwaysDisplayed?: Maybe<Scalars['Boolean']['output']>;
  /** A unique article number for the product. This is not neccessarily the same as the EAN. It is an internal identifier that is used to identify a product or bundle. */
  articleNumber?: Maybe<Scalars['String']['output']>;
  /** Details about the availability of the product. */
  availability?: Maybe<ProductAvailability>;
  /** The brand of the product. */
  brand?: Maybe<Brand>;
  /** Determines whether the product consists of multiple items. */
  bundle?: Maybe<Scalars['Boolean']['output']>;
  /** A list of article numbers of contained items. */
  bundledArticleNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The color of the product. May be used as variant selector. */
  color?: Maybe<Color>;
  /** Information about the charger for this product */
  commonCharger?: Maybe<CommonCharger>;
  /** A list of items that are part of the delivery. */
  deliveredItems?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * The approximate time that is needed for the product to get shipped to
   * the customer.
   * @deprecated Please use the delivery lead time from the availability field instead.
   *
   */
  deliveryLeadTime?: Maybe<Scalars['String']['output']>;
  /** A detailed product description. May contain HTML content that is used to enrich the product with search engine optimized information. */
  description?: Maybe<Scalars['String']['output']>;
  /** The width, height and depth of the product. */
  dimensions?: Maybe<Dimensions>;
  /** A list of documents attached to the offer. */
  documents?: Maybe<Array<Maybe<Attachment>>>;
  /** The EAN (European Article Number) of the product. Basically, this field may contain all standardized types of GTIN identifiers. */
  ean?: Maybe<Scalars['String']['output']>;
  /** A list of all EANs of contained items. */
  eans?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The energy effficiency of the product. */
  energyEfficiency?: Maybe<EnergyEfficiency>;
  /** External links of the product */
  externalLinks?: Maybe<ExternalLinks>;
  family?: Maybe<ProductFamily>;
  /** A list of features as list of feature names and values. */
  features?: Maybe<Array<Maybe<Feature>>>;
  /** A list of legal texts. */
  legalTexts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** A list of media objects attached to the product. */
  media?: Maybe<Array<Maybe<Attachment>>>;
  /** The memory size of the product. Is only relevant specific devices. May be used as variant selector. */
  memory?: Maybe<MemorySize>;
  /** The name of the product model. */
  model?: Maybe<Scalars['String']['output']>;
  /** Gets the name of the product. */
  name?: Maybe<Scalars['String']['output']>;
  /** An identifier for the enabler that the product originated from. */
  origin?: Maybe<Origin>;
  /** List of product features as provided by PXSDB */
  pxsdbFeatures?: Maybe<Array<Maybe<PxsdbFeature>>>;
  /** An URL to security information about the product. Can be null if the product don't have one */
  securityInformationUrl?: Maybe<Scalars['String']['output']>;
  /** A shorter list of product USPs. */
  shortUsp?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The size of the product. The content varies with the type of the particular product. May be used as variant selector. */
  size?: Maybe<Scalars['String']['output']>;
  /** The product slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /**
   * The number of units available in stock.
   * @deprecated Please use the stock from the availability field instead.
   */
  stock?: Maybe<ProductStock>;
  /** The storage size of the product. Is only relevant specific devices. May be used as variant selector. */
  storage?: Maybe<MemorySize>;
  /** A list of product summary texts. */
  summaryTexts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Tags for the product with additional details. */
  tagDetails?: Maybe<Array<Maybe<Tag>>>;
  /** Tags for the product. */
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The primary image for this product. */
  teaserImage?: Maybe<Attachment>;
  /** A list of product USPs. */
  usps?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The name of the product variant. Does not contain the brand or model name. */
  variantName?: Maybe<Scalars['String']['output']>;
  /** The weight of the product. */
  weight?: Maybe<Weight>;
};

/** An object containing details for a standard product. */
export type StandardProductAvailabilityArgs = {
  live?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An object containing details for a standard product. */
export type StandardProductStockArgs = {
  live?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An object containing details for a standard product family. */
export type StandardProductFamily = ProductFamily & {
  __typename?: 'StandardProductFamily';
  /** The brand for the product family. */
  brand?: Maybe<Brand>;
  /** A list of categories that the product family belongs to. */
  categories?: Maybe<Array<Maybe<ProductCategory>>>;
  /** A list of product compatibilities. */
  compatibilities?: Maybe<Array<Maybe<ProductFamilyCompatibility>>>;
  /** A list of compatible product families. */
  compatibleFamilies?: Maybe<Array<Maybe<StandardProductFamily>>>;
  /** An unique identifier for the product family. */
  familyNumber?: Maybe<Scalars['String']['output']>;
  /** The international contact information for the manufacturer */
  manufacturerContact?: Maybe<Scalars['String']['output']>;
  /** The contact information for the manufacturer inside the European Union */
  manufacturerContactEu?: Maybe<Scalars['String']['output']>;
  /** The name of the product family omitting the prepended brand name. */
  model?: Maybe<Scalars['String']['output']>;
  /** Gets the name of the product family. */
  name?: Maybe<Scalars['String']['output']>;
  /** The popularity of the product family. */
  popularity?: Maybe<Scalars['Int']['output']>;
  /** Most precise categories that are available for the product family. */
  preciseCategories?: Maybe<Array<Maybe<ProductCategory>>>;
  /** The primary category that the product family belongs to. */
  primaryCategory?: Maybe<ProductCategory>;
  /** Root categories that the product family belongs to. */
  rootCategories?: Maybe<Array<Maybe<ProductCategory>>>;
  /** A list of selection property names. These properties are used to correctly group variants for the associated products. */
  selectors?: Maybe<Array<Maybe<ProductSelectorField>>>;
  /** The slug of the product family. */
  slug?: Maybe<Scalars['String']['output']>;
  /** Warranty information required by EU law. Null when none of the values is known for the product family. */
  warranty?: Maybe<Warranty>;
};

/** An object containing details for a standard product family. */
export type StandardProductFamilyPrimaryCategoryArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** A tag is a string that is used to describe a resource. */
export type Tag = {
  __typename?: 'Tag';
  /** Name of the tag. */
  name?: Maybe<Scalars['String']['output']>;
  /** URL-friendly name of the tag. */
  slug?: Maybe<Scalars['String']['output']>;
};

/** A type representing the warranty attributes of a product family. */
export type Warranty = {
  __typename?: 'Warranty';
  /** The additional commercial guarantee granted by the manufacturer, in years. Serialized as a string to preserve precision. */
  additionalCommercialGuarantee?: Maybe<Scalars['Decimal']['output']>;
  /** The repairability class of the product family. */
  repairabilityClass?: Maybe<RepairabilityClass>;
  /** The guaranteed software update period, usually in years (e.g. "8"). A string, since the source may deliver an end date instead. */
  softwareUpdates?: Maybe<Scalars['String']['output']>;
};

/** A type representing the weight value and unit. */
export type Weight = {
  __typename?: 'Weight';
  /** The weight unit. */
  unit?: Maybe<WeightUnit>;
  /** The weight value. */
  value?: Maybe<Scalars['Float']['output']>;
};

/** An enum type for weight units. */
export enum WeightUnit {
  /** Grams (g) */
  G = 'G',
  /** Kilograms (kg) */
  Kg = 'KG',
}

type AttachmentFields_LocalAttachment_Fragment = {
  __typename?: 'LocalAttachment';
  path?: string | null;
  type?: AttachmentType | null;
  name?: string | null;
  remote?: boolean | null;
};

type AttachmentFields_RemoteAttachment_Fragment = {
  __typename?: 'RemoteAttachment';
  url?: string | null;
  type?: AttachmentType | null;
  name?: string | null;
  remote?: boolean | null;
};

export type AttachmentFieldsFragment =
  AttachmentFields_LocalAttachment_Fragment | AttachmentFields_RemoteAttachment_Fragment;

type DatafeedFields_CollapsibleOffer_Fragment = {
  __typename?: 'CollapsibleOffer';
  usps?: Array<string | null> | null;
  product?:
    | {
        __typename?: 'BundleProduct';
        articleNumber?: string | null;
        eans?: Array<string | null> | null;
        bundle?: boolean | null;
        name?: string | null;
        slug?: string | null;
        description?: string | null;
        legalTexts?: Array<string | null> | null;
        deliveryLeadTime?: string | null;
        availability?: { __typename?: 'ProductAvailability'; stock?: number | null } | null;
        family?:
          | {
              __typename?: 'BundleProductFamily';
              name?: string | null;
              slug?: string | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
            }
          | {
              __typename?: 'StandardProductFamily';
              name?: string | null;
              slug?: string | null;
              brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
            }
          | null;
      }
    | {
        __typename?: 'StandardProduct';
        articleNumber?: string | null;
        eans?: Array<string | null> | null;
        bundle?: boolean | null;
        name?: string | null;
        slug?: string | null;
        description?: string | null;
        legalTexts?: Array<string | null> | null;
        deliveryLeadTime?: string | null;
        color?: { __typename?: 'Color'; name?: string | null } | null;
        availability?: { __typename?: 'ProductAvailability'; stock?: number | null } | null;
        family?:
          | {
              __typename?: 'BundleProductFamily';
              name?: string | null;
              slug?: string | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
            }
          | {
              __typename?: 'StandardProductFamily';
              name?: string | null;
              slug?: string | null;
              brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
            }
          | null;
        energyEfficiency?: {
          __typename?: 'EnergyEfficiency';
          class?: EnergyEfficiencyClass | null;
          labelImage?:
            | {
                __typename?: 'LocalAttachment';
                mediaId?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | {
                __typename?: 'RemoteAttachment';
                url?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | null;
          document?:
            | {
                __typename?: 'LocalAttachment';
                path?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | {
                __typename?: 'RemoteAttachment';
                url?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | null;
        } | null;
      }
    | null;
  teaserImage?:
    | {
        __typename?: 'LocalAttachment';
        sources?: Array<{
          __typename?: 'MediaSource';
          path?: string | null;
          mime?: string | null;
        } | null> | null;
      }
    | {
        __typename?: 'RemoteAttachment';
        sources?: Array<{
          __typename?: 'MediaSource';
          path?: string | null;
          mime?: string | null;
        } | null> | null;
      }
    | null;
  onetimePrice?: {
    __typename?: 'Price';
    amount?: number | null;
    currency?: string | null;
    paymentFrequency?: PaymentFrequency | null;
    type?: PriceType | null;
    value?: any | null;
  } | null;
  prices?: Array<{
    __typename?: 'Price';
    amount?: number | null;
    currency?: string | null;
    paymentFrequency?: PaymentFrequency | null;
    type?: PriceType | null;
    value?: any | null;
  } | null> | null;
};

type DatafeedFields_DefaultOffer_Fragment = {
  __typename?: 'DefaultOffer';
  usps?: Array<string | null> | null;
  product?:
    | {
        __typename?: 'BundleProduct';
        articleNumber?: string | null;
        eans?: Array<string | null> | null;
        bundle?: boolean | null;
        name?: string | null;
        slug?: string | null;
        description?: string | null;
        legalTexts?: Array<string | null> | null;
        deliveryLeadTime?: string | null;
        availability?: { __typename?: 'ProductAvailability'; stock?: number | null } | null;
        family?:
          | {
              __typename?: 'BundleProductFamily';
              name?: string | null;
              slug?: string | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
            }
          | {
              __typename?: 'StandardProductFamily';
              name?: string | null;
              slug?: string | null;
              brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
            }
          | null;
      }
    | {
        __typename?: 'StandardProduct';
        articleNumber?: string | null;
        eans?: Array<string | null> | null;
        bundle?: boolean | null;
        name?: string | null;
        slug?: string | null;
        description?: string | null;
        legalTexts?: Array<string | null> | null;
        deliveryLeadTime?: string | null;
        color?: { __typename?: 'Color'; name?: string | null } | null;
        availability?: { __typename?: 'ProductAvailability'; stock?: number | null } | null;
        family?:
          | {
              __typename?: 'BundleProductFamily';
              name?: string | null;
              slug?: string | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
            }
          | {
              __typename?: 'StandardProductFamily';
              name?: string | null;
              slug?: string | null;
              brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
            }
          | null;
        energyEfficiency?: {
          __typename?: 'EnergyEfficiency';
          class?: EnergyEfficiencyClass | null;
          labelImage?:
            | {
                __typename?: 'LocalAttachment';
                mediaId?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | {
                __typename?: 'RemoteAttachment';
                url?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | null;
          document?:
            | {
                __typename?: 'LocalAttachment';
                path?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | {
                __typename?: 'RemoteAttachment';
                url?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | null;
        } | null;
      }
    | null;
  teaserImage?:
    | {
        __typename?: 'LocalAttachment';
        sources?: Array<{
          __typename?: 'MediaSource';
          path?: string | null;
          mime?: string | null;
        } | null> | null;
      }
    | {
        __typename?: 'RemoteAttachment';
        sources?: Array<{
          __typename?: 'MediaSource';
          path?: string | null;
          mime?: string | null;
        } | null> | null;
      }
    | null;
  onetimePrice?: {
    __typename?: 'Price';
    amount?: number | null;
    currency?: string | null;
    paymentFrequency?: PaymentFrequency | null;
    type?: PriceType | null;
    value?: any | null;
  } | null;
  prices?: Array<{
    __typename?: 'Price';
    amount?: number | null;
    currency?: string | null;
    paymentFrequency?: PaymentFrequency | null;
    type?: PriceType | null;
    value?: any | null;
  } | null> | null;
};

type DatafeedFields_ScopedOffer_Fragment = {
  __typename?: 'ScopedOffer';
  usps?: Array<string | null> | null;
  product?:
    | {
        __typename?: 'BundleProduct';
        articleNumber?: string | null;
        eans?: Array<string | null> | null;
        bundle?: boolean | null;
        name?: string | null;
        slug?: string | null;
        description?: string | null;
        legalTexts?: Array<string | null> | null;
        deliveryLeadTime?: string | null;
        availability?: { __typename?: 'ProductAvailability'; stock?: number | null } | null;
        family?:
          | {
              __typename?: 'BundleProductFamily';
              name?: string | null;
              slug?: string | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
            }
          | {
              __typename?: 'StandardProductFamily';
              name?: string | null;
              slug?: string | null;
              brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
            }
          | null;
      }
    | {
        __typename?: 'StandardProduct';
        articleNumber?: string | null;
        eans?: Array<string | null> | null;
        bundle?: boolean | null;
        name?: string | null;
        slug?: string | null;
        description?: string | null;
        legalTexts?: Array<string | null> | null;
        deliveryLeadTime?: string | null;
        color?: { __typename?: 'Color'; name?: string | null } | null;
        availability?: { __typename?: 'ProductAvailability'; stock?: number | null } | null;
        family?:
          | {
              __typename?: 'BundleProductFamily';
              name?: string | null;
              slug?: string | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
            }
          | {
              __typename?: 'StandardProductFamily';
              name?: string | null;
              slug?: string | null;
              brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
            }
          | null;
        energyEfficiency?: {
          __typename?: 'EnergyEfficiency';
          class?: EnergyEfficiencyClass | null;
          labelImage?:
            | {
                __typename?: 'LocalAttachment';
                mediaId?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | {
                __typename?: 'RemoteAttachment';
                url?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | null;
          document?:
            | {
                __typename?: 'LocalAttachment';
                path?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | {
                __typename?: 'RemoteAttachment';
                url?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | null;
        } | null;
      }
    | null;
  teaserImage?:
    | {
        __typename?: 'LocalAttachment';
        sources?: Array<{
          __typename?: 'MediaSource';
          path?: string | null;
          mime?: string | null;
        } | null> | null;
      }
    | {
        __typename?: 'RemoteAttachment';
        sources?: Array<{
          __typename?: 'MediaSource';
          path?: string | null;
          mime?: string | null;
        } | null> | null;
      }
    | null;
  onetimePrice?: {
    __typename?: 'Price';
    amount?: number | null;
    currency?: string | null;
    paymentFrequency?: PaymentFrequency | null;
    type?: PriceType | null;
    value?: any | null;
  } | null;
  prices?: Array<{
    __typename?: 'Price';
    amount?: number | null;
    currency?: string | null;
    paymentFrequency?: PaymentFrequency | null;
    type?: PriceType | null;
    value?: any | null;
  } | null> | null;
};

export type DatafeedFieldsFragment =
  | DatafeedFields_CollapsibleOffer_Fragment
  | DatafeedFields_DefaultOffer_Fragment
  | DatafeedFields_ScopedOffer_Fragment;

export type EnergyEfficiencyFragment = {
  __typename?: 'StandardProduct';
  energyEfficiency?: {
    __typename?: 'EnergyEfficiency';
    class?: EnergyEfficiencyClass | null;
    labelImage?:
      | {
          __typename?: 'LocalAttachment';
          mediaId?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | {
          __typename?: 'RemoteAttachment';
          url?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | null;
    document?:
      | {
          __typename?: 'LocalAttachment';
          path?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | {
          __typename?: 'RemoteAttachment';
          url?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | null;
  } | null;
};

type ImageFields_LocalAttachment_Fragment = {
  __typename?: 'LocalAttachment';
  mediaId?: string | null;
  type?: AttachmentType | null;
  name?: string | null;
  remote?: boolean | null;
};

type ImageFields_RemoteAttachment_Fragment = {
  __typename?: 'RemoteAttachment';
  url?: string | null;
  type?: AttachmentType | null;
  name?: string | null;
  remote?: boolean | null;
};

export type ImageFieldsFragment =
  ImageFields_LocalAttachment_Fragment | ImageFields_RemoteAttachment_Fragment;

type OfferData_CollapsibleOffer_Fragment = {
  __typename?: 'CollapsibleOffer';
  maxOrderableAmount?: number | null;
  updatedAt?: any | null;
  usps?: Array<string | null> | null;
  summaryTexts?: Array<string | null> | null;
  documents?: Array<
    | {
        __typename?: 'LocalAttachment';
        path?: string | null;
        type?: AttachmentType | null;
        name?: string | null;
        remote?: boolean | null;
      }
    | {
        __typename?: 'RemoteAttachment';
        url?: string | null;
        type?: AttachmentType | null;
        name?: string | null;
        remote?: boolean | null;
      }
    | null
  > | null;
  media?: Array<
    | {
        __typename?: 'LocalAttachment';
        mediaId?: string | null;
        type?: AttachmentType | null;
        name?: string | null;
        remote?: boolean | null;
      }
    | {
        __typename?: 'RemoteAttachment';
        url?: string | null;
        type?: AttachmentType | null;
        name?: string | null;
        remote?: boolean | null;
      }
    | null
  > | null;
  teaserImage?:
    | {
        __typename?: 'LocalAttachment';
        mediaId?: string | null;
        type?: AttachmentType | null;
        name?: string | null;
        remote?: boolean | null;
      }
    | {
        __typename?: 'RemoteAttachment';
        url?: string | null;
        type?: AttachmentType | null;
        name?: string | null;
        remote?: boolean | null;
      }
    | null;
  prices?: Array<{
    __typename?: 'Price';
    amount?: number | null;
    currency?: string | null;
    paymentFrequency?: PaymentFrequency | null;
    type?: PriceType | null;
    value?: any | null;
  } | null> | null;
  accessories?: Array<{
    __typename?: 'DefaultOffer';
    maxOrderableAmount?: number | null;
    updatedAt?: any | null;
    product?:
      | {
          __typename?: 'BundleProduct';
          articleNumber?: string | null;
          bundle?: boolean | null;
          name?: string | null;
          slug?: string | null;
          tags?: Array<string | null> | null;
          origin?: Origin | null;
          alwaysDisplayed?: boolean | null;
          deliveryLeadTime?: string | null;
          bundledProducts?: Array<{
            __typename?: 'StandardProduct';
            name?: string | null;
            tags?: Array<string | null> | null;
            family?:
              | { __typename?: 'BundleProductFamily'; name?: string | null }
              | {
                  __typename?: 'StandardProductFamily';
                  name?: string | null;
                  brand?: {
                    __typename?: 'Brand';
                    name?: string | null;
                    slug?: string | null;
                  } | null;
                }
              | null;
            teaserImage?:
              | {
                  __typename?: 'LocalAttachment';
                  mediaId?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
            energyEfficiency?: {
              __typename?: 'EnergyEfficiency';
              class?: EnergyEfficiencyClass | null;
              labelImage?:
                | {
                    __typename?: 'LocalAttachment';
                    mediaId?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
              document?:
                | {
                    __typename?: 'LocalAttachment';
                    path?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
            } | null;
          } | null> | null;
          availability?: {
            __typename?: 'ProductAvailability';
            stock?: number | null;
            provider?: ProductProviderKey | null;
            deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
          } | null;
          family?:
            | {
                __typename?: 'BundleProductFamily';
                name?: string | null;
                primaryCategory?: {
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                  ancestors?: Array<{
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                  } | null> | null;
                } | null;
              }
            | {
                __typename?: 'StandardProductFamily';
                name?: string | null;
                brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
                primaryCategory?: {
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                  ancestors?: Array<{
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                  } | null> | null;
                } | null;
              }
            | null;
        }
      | {
          __typename?: 'StandardProduct';
          articleNumber?: string | null;
          bundle?: boolean | null;
          name?: string | null;
          slug?: string | null;
          tags?: Array<string | null> | null;
          origin?: Origin | null;
          alwaysDisplayed?: boolean | null;
          deliveryLeadTime?: string | null;
          externalLinks?: { __typename?: 'ExternalLinks'; oneShopUrl?: string | null } | null;
          availability?: {
            __typename?: 'ProductAvailability';
            stock?: number | null;
            provider?: ProductProviderKey | null;
            deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
          } | null;
          family?:
            | {
                __typename?: 'BundleProductFamily';
                name?: string | null;
                primaryCategory?: {
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                  ancestors?: Array<{
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                  } | null> | null;
                } | null;
              }
            | {
                __typename?: 'StandardProductFamily';
                name?: string | null;
                brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
                primaryCategory?: {
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                  ancestors?: Array<{
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                  } | null> | null;
                } | null;
              }
            | null;
          energyEfficiency?: {
            __typename?: 'EnergyEfficiency';
            class?: EnergyEfficiencyClass | null;
            labelImage?:
              | {
                  __typename?: 'LocalAttachment';
                  mediaId?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
            document?:
              | {
                  __typename?: 'LocalAttachment';
                  path?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
          } | null;
        }
      | null;
    media?: Array<
      | {
          __typename?: 'LocalAttachment';
          mediaId?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | {
          __typename?: 'RemoteAttachment';
          url?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | null
    > | null;
    teaserImage?:
      | {
          __typename?: 'LocalAttachment';
          mediaId?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | {
          __typename?: 'RemoteAttachment';
          url?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | null;
    prices?: Array<{
      __typename?: 'Price';
      amount?: number | null;
      currency?: string | null;
      paymentFrequency?: PaymentFrequency | null;
      type?: PriceType | null;
      value?: any | null;
    } | null> | null;
    productAlternatives?: Array<{
      __typename?: 'ProductAlternativeItemGroup';
      position?: number | null;
      family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
      properties?: Array<{
        __typename?: 'ProductAlternativeSelectorGroup';
        key?: ProductSelectorField | null;
        alternatives?: Array<{
          __typename?: 'ProductAlternative';
          active?: boolean | null;
          exactMatch?: boolean | null;
          offer?: {
            __typename?: 'ScopedOffer';
            prices?: Array<{
              __typename?: 'Price';
              amount?: number | null;
              paymentFrequency?: PaymentFrequency | null;
              type?: PriceType | null;
              value?: any | null;
            } | null> | null;
            scopedProduct?: {
              __typename?: 'StandardProduct';
              size?: string | null;
              variantName?: string | null;
              name?: string | null;
              color?: {
                __typename?: 'Color';
                code?: any | null;
                name?: string | null;
                colorful?: boolean | null;
              } | null;
              storage?: {
                __typename?: 'MemorySize';
                unit?: MemoryUnit | null;
                value?: number | null;
              } | null;
              memory?: {
                __typename?: 'MemorySize';
                unit?: MemoryUnit | null;
                value?: number | null;
              } | null;
              energyEfficiency?: {
                __typename?: 'EnergyEfficiency';
                class?: EnergyEfficiencyClass | null;
                labelImage?:
                  | {
                      __typename?: 'LocalAttachment';
                      mediaId?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
                document?:
                  | {
                      __typename?: 'LocalAttachment';
                      path?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
              } | null;
            } | null;
            product?:
              | {
                  __typename?: 'BundleProduct';
                  articleNumber?: string | null;
                  name?: string | null;
                  slug?: string | null;
                  availability?: {
                    __typename?: 'ProductAvailability';
                    stock?: number | null;
                    provider?: ProductProviderKey | null;
                    deliveryLeadTime?: {
                      __typename?: 'DeliveryLeadTime';
                      text?: string | null;
                    } | null;
                  } | null;
                  teaserImage?:
                    | {
                        __typename?: 'LocalAttachment';
                        mediaId?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | {
                        __typename?: 'RemoteAttachment';
                        url?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | null;
                }
              | {
                  __typename?: 'StandardProduct';
                  articleNumber?: string | null;
                  name?: string | null;
                  slug?: string | null;
                  availability?: {
                    __typename?: 'ProductAvailability';
                    stock?: number | null;
                    provider?: ProductProviderKey | null;
                    deliveryLeadTime?: {
                      __typename?: 'DeliveryLeadTime';
                      text?: string | null;
                    } | null;
                  } | null;
                  teaserImage?:
                    | {
                        __typename?: 'LocalAttachment';
                        mediaId?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | {
                        __typename?: 'RemoteAttachment';
                        url?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | null;
                }
              | null;
          } | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
  } | null> | null;
  recommendations?: Array<{
    __typename?: 'DefaultOffer';
    maxOrderableAmount?: number | null;
    updatedAt?: any | null;
    product?:
      | {
          __typename?: 'BundleProduct';
          articleNumber?: string | null;
          bundle?: boolean | null;
          name?: string | null;
          slug?: string | null;
          tags?: Array<string | null> | null;
          origin?: Origin | null;
          alwaysDisplayed?: boolean | null;
          deliveryLeadTime?: string | null;
          bundledProducts?: Array<{
            __typename?: 'StandardProduct';
            name?: string | null;
            tags?: Array<string | null> | null;
            family?:
              | { __typename?: 'BundleProductFamily'; name?: string | null }
              | {
                  __typename?: 'StandardProductFamily';
                  name?: string | null;
                  brand?: {
                    __typename?: 'Brand';
                    name?: string | null;
                    slug?: string | null;
                  } | null;
                }
              | null;
            teaserImage?:
              | {
                  __typename?: 'LocalAttachment';
                  mediaId?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
            energyEfficiency?: {
              __typename?: 'EnergyEfficiency';
              class?: EnergyEfficiencyClass | null;
              labelImage?:
                | {
                    __typename?: 'LocalAttachment';
                    mediaId?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
              document?:
                | {
                    __typename?: 'LocalAttachment';
                    path?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
            } | null;
          } | null> | null;
          availability?: {
            __typename?: 'ProductAvailability';
            stock?: number | null;
            provider?: ProductProviderKey | null;
            deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
          } | null;
          family?:
            | {
                __typename?: 'BundleProductFamily';
                name?: string | null;
                primaryCategory?: {
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                  ancestors?: Array<{
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                  } | null> | null;
                } | null;
              }
            | {
                __typename?: 'StandardProductFamily';
                name?: string | null;
                brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
                primaryCategory?: {
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                  ancestors?: Array<{
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                  } | null> | null;
                } | null;
              }
            | null;
        }
      | {
          __typename?: 'StandardProduct';
          articleNumber?: string | null;
          bundle?: boolean | null;
          name?: string | null;
          slug?: string | null;
          tags?: Array<string | null> | null;
          origin?: Origin | null;
          alwaysDisplayed?: boolean | null;
          deliveryLeadTime?: string | null;
          externalLinks?: { __typename?: 'ExternalLinks'; oneShopUrl?: string | null } | null;
          availability?: {
            __typename?: 'ProductAvailability';
            stock?: number | null;
            provider?: ProductProviderKey | null;
            deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
          } | null;
          family?:
            | {
                __typename?: 'BundleProductFamily';
                name?: string | null;
                primaryCategory?: {
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                  ancestors?: Array<{
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                  } | null> | null;
                } | null;
              }
            | {
                __typename?: 'StandardProductFamily';
                name?: string | null;
                brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
                primaryCategory?: {
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                  ancestors?: Array<{
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                  } | null> | null;
                } | null;
              }
            | null;
          energyEfficiency?: {
            __typename?: 'EnergyEfficiency';
            class?: EnergyEfficiencyClass | null;
            labelImage?:
              | {
                  __typename?: 'LocalAttachment';
                  mediaId?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
            document?:
              | {
                  __typename?: 'LocalAttachment';
                  path?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
          } | null;
        }
      | null;
    media?: Array<
      | {
          __typename?: 'LocalAttachment';
          mediaId?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | {
          __typename?: 'RemoteAttachment';
          url?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | null
    > | null;
    teaserImage?:
      | {
          __typename?: 'LocalAttachment';
          mediaId?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | {
          __typename?: 'RemoteAttachment';
          url?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | null;
    prices?: Array<{
      __typename?: 'Price';
      amount?: number | null;
      currency?: string | null;
      paymentFrequency?: PaymentFrequency | null;
      type?: PriceType | null;
      value?: any | null;
    } | null> | null;
    productAlternatives?: Array<{
      __typename?: 'ProductAlternativeItemGroup';
      position?: number | null;
      family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
      properties?: Array<{
        __typename?: 'ProductAlternativeSelectorGroup';
        key?: ProductSelectorField | null;
        alternatives?: Array<{
          __typename?: 'ProductAlternative';
          active?: boolean | null;
          exactMatch?: boolean | null;
          offer?: {
            __typename?: 'ScopedOffer';
            prices?: Array<{
              __typename?: 'Price';
              amount?: number | null;
              paymentFrequency?: PaymentFrequency | null;
              type?: PriceType | null;
              value?: any | null;
            } | null> | null;
            scopedProduct?: {
              __typename?: 'StandardProduct';
              size?: string | null;
              variantName?: string | null;
              name?: string | null;
              color?: {
                __typename?: 'Color';
                code?: any | null;
                name?: string | null;
                colorful?: boolean | null;
              } | null;
              storage?: {
                __typename?: 'MemorySize';
                unit?: MemoryUnit | null;
                value?: number | null;
              } | null;
              memory?: {
                __typename?: 'MemorySize';
                unit?: MemoryUnit | null;
                value?: number | null;
              } | null;
              energyEfficiency?: {
                __typename?: 'EnergyEfficiency';
                class?: EnergyEfficiencyClass | null;
                labelImage?:
                  | {
                      __typename?: 'LocalAttachment';
                      mediaId?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
                document?:
                  | {
                      __typename?: 'LocalAttachment';
                      path?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
              } | null;
            } | null;
            product?:
              | {
                  __typename?: 'BundleProduct';
                  articleNumber?: string | null;
                  name?: string | null;
                  slug?: string | null;
                  availability?: {
                    __typename?: 'ProductAvailability';
                    stock?: number | null;
                    provider?: ProductProviderKey | null;
                    deliveryLeadTime?: {
                      __typename?: 'DeliveryLeadTime';
                      text?: string | null;
                    } | null;
                  } | null;
                  teaserImage?:
                    | {
                        __typename?: 'LocalAttachment';
                        mediaId?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | {
                        __typename?: 'RemoteAttachment';
                        url?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | null;
                }
              | {
                  __typename?: 'StandardProduct';
                  articleNumber?: string | null;
                  name?: string | null;
                  slug?: string | null;
                  availability?: {
                    __typename?: 'ProductAvailability';
                    stock?: number | null;
                    provider?: ProductProviderKey | null;
                    deliveryLeadTime?: {
                      __typename?: 'DeliveryLeadTime';
                      text?: string | null;
                    } | null;
                  } | null;
                  teaserImage?:
                    | {
                        __typename?: 'LocalAttachment';
                        mediaId?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | {
                        __typename?: 'RemoteAttachment';
                        url?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | null;
                }
              | null;
          } | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
  } | null> | null;
  product?:
    | {
        __typename?: 'BundleProduct';
        description?: string | null;
        articleNumber?: string | null;
        eans?: Array<string | null> | null;
        bundle?: boolean | null;
        name?: string | null;
        slug?: string | null;
        legalTexts?: Array<string | null> | null;
        tags?: Array<string | null> | null;
        origin?: Origin | null;
        deliveryLeadTime?: string | null;
        alwaysDisplayed?: boolean | null;
        usps?: Array<string | null> | null;
        bundledProducts?: Array<{
          __typename?: 'StandardProduct';
          securityInformationUrl?: string | null;
          articleNumber?: string | null;
          name?: string | null;
          eans?: Array<string | null> | null;
          description?: string | null;
          slug?: string | null;
          usps?: Array<string | null> | null;
          deliveredItems?: Array<string | null> | null;
          tags?: Array<string | null> | null;
          origin?: Origin | null;
          commonCharger?: {
            __typename?: 'CommonCharger';
            included?: boolean | null;
            minWattage?: any | null;
            maxWattage?: any | null;
            possible?: boolean | null;
            usbPd?: boolean | null;
          } | null;
          teaserImage?:
            | {
                __typename?: 'LocalAttachment';
                mediaId?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | {
                __typename?: 'RemoteAttachment';
                url?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | null;
          family?:
            | { __typename?: 'BundleProductFamily'; name?: string | null; slug?: string | null }
            | {
                __typename?: 'StandardProductFamily';
                manufacturerContact?: string | null;
                manufacturerContactEu?: string | null;
                name?: string | null;
                slug?: string | null;
                compatibilities?: Array<{
                  __typename?: 'ProductFamilyCompatibility';
                  family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
                  requirementAlternatives?: Array<{
                    __typename?: 'ProductFamilyCompatibilityRequirementAlternative';
                    requirements?: Array<{
                      __typename?: 'ProductFamilyCompatibilityRequirement';
                      family?: {
                        __typename?: 'StandardProductFamily';
                        name?: string | null;
                      } | null;
                      offer?:
                        | {
                            __typename?: 'CollapsibleOffer';
                            product?:
                              | { __typename?: 'BundleProduct'; slug?: string | null }
                              | { __typename?: 'StandardProduct'; slug?: string | null }
                              | null;
                          }
                        | {
                            __typename?: 'DefaultOffer';
                            product?:
                              | { __typename?: 'BundleProduct'; slug?: string | null }
                              | { __typename?: 'StandardProduct'; slug?: string | null }
                              | null;
                          }
                        | {
                            __typename?: 'ScopedOffer';
                            product?:
                              | { __typename?: 'BundleProduct'; slug?: string | null }
                              | { __typename?: 'StandardProduct'; slug?: string | null }
                              | null;
                          }
                        | null;
                    } | null> | null;
                  } | null> | null;
                } | null> | null;
                brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
                warranty?: {
                  __typename?: 'Warranty';
                  additionalCommercialGuarantee?: any | null;
                  repairabilityClass?: RepairabilityClass | null;
                  softwareUpdates?: string | null;
                } | null;
              }
            | null;
          features?: Array<{
            __typename?: 'Feature';
            name?: string | null;
            value?: string | null;
          } | null> | null;
          media?: Array<
            | {
                __typename?: 'LocalAttachment';
                mediaId?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | {
                __typename?: 'RemoteAttachment';
                url?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | null
          > | null;
          energyEfficiency?: {
            __typename?: 'EnergyEfficiency';
            class?: EnergyEfficiencyClass | null;
            labelImage?:
              | {
                  __typename?: 'LocalAttachment';
                  mediaId?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
            document?:
              | {
                  __typename?: 'LocalAttachment';
                  path?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
          } | null;
        } | null> | null;
        availability?: {
          __typename?: 'ProductAvailability';
          stock?: number | null;
          provider?: ProductProviderKey | null;
          deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
        } | null;
        family?:
          | {
              __typename?: 'BundleProductFamily';
              name?: string | null;
              slug?: string | null;
              categories?: Array<{
                __typename?: 'ProductCategory';
                categoryNumber?: string | null;
              } | null> | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
              rootCategories?: Array<{
                __typename?: 'ProductCategory';
                slug?: string | null;
              } | null> | null;
            }
          | {
              __typename?: 'StandardProductFamily';
              manufacturerContact?: string | null;
              manufacturerContactEu?: string | null;
              name?: string | null;
              slug?: string | null;
              brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
              compatibilities?: Array<{
                __typename?: 'ProductFamilyCompatibility';
                family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
                requirementAlternatives?: Array<{
                  __typename?: 'ProductFamilyCompatibilityRequirementAlternative';
                  requirements?: Array<{
                    __typename?: 'ProductFamilyCompatibilityRequirement';
                    family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
                    offer?:
                      | {
                          __typename?: 'CollapsibleOffer';
                          product?:
                            | { __typename?: 'BundleProduct'; slug?: string | null }
                            | { __typename?: 'StandardProduct'; slug?: string | null }
                            | null;
                        }
                      | {
                          __typename?: 'DefaultOffer';
                          product?:
                            | { __typename?: 'BundleProduct'; slug?: string | null }
                            | { __typename?: 'StandardProduct'; slug?: string | null }
                            | null;
                        }
                      | {
                          __typename?: 'ScopedOffer';
                          product?:
                            | { __typename?: 'BundleProduct'; slug?: string | null }
                            | { __typename?: 'StandardProduct'; slug?: string | null }
                            | null;
                        }
                      | null;
                  } | null> | null;
                } | null> | null;
              } | null> | null;
              warranty?: {
                __typename?: 'Warranty';
                additionalCommercialGuarantee?: any | null;
                repairabilityClass?: RepairabilityClass | null;
                softwareUpdates?: string | null;
              } | null;
              categories?: Array<{
                __typename?: 'ProductCategory';
                categoryNumber?: string | null;
              } | null> | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
              rootCategories?: Array<{
                __typename?: 'ProductCategory';
                slug?: string | null;
              } | null> | null;
            }
          | null;
      }
    | {
        __typename?: 'StandardProduct';
        description?: string | null;
        deliveredItems?: Array<string | null> | null;
        deliveryLeadTime?: string | null;
        model?: string | null;
        size?: string | null;
        variantName?: string | null;
        securityInformationUrl?: string | null;
        articleNumber?: string | null;
        eans?: Array<string | null> | null;
        bundle?: boolean | null;
        name?: string | null;
        slug?: string | null;
        legalTexts?: Array<string | null> | null;
        tags?: Array<string | null> | null;
        origin?: Origin | null;
        alwaysDisplayed?: boolean | null;
        usps?: Array<string | null> | null;
        externalLinks?: { __typename?: 'ExternalLinks'; oneShopUrl?: string | null } | null;
        brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
        color?: { __typename?: 'Color'; code?: any | null; name?: string | null } | null;
        storage?: {
          __typename?: 'MemorySize';
          value?: number | null;
          unit?: MemoryUnit | null;
        } | null;
        features?: Array<{
          __typename?: 'Feature';
          name?: string | null;
          value?: string | null;
        } | null> | null;
        commonCharger?: {
          __typename?: 'CommonCharger';
          included?: boolean | null;
          minWattage?: any | null;
          maxWattage?: any | null;
          possible?: boolean | null;
          usbPd?: boolean | null;
        } | null;
        availability?: {
          __typename?: 'ProductAvailability';
          stock?: number | null;
          provider?: ProductProviderKey | null;
          deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
        } | null;
        family?:
          | {
              __typename?: 'BundleProductFamily';
              name?: string | null;
              slug?: string | null;
              categories?: Array<{
                __typename?: 'ProductCategory';
                categoryNumber?: string | null;
              } | null> | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
              rootCategories?: Array<{
                __typename?: 'ProductCategory';
                slug?: string | null;
              } | null> | null;
            }
          | {
              __typename?: 'StandardProductFamily';
              manufacturerContact?: string | null;
              manufacturerContactEu?: string | null;
              name?: string | null;
              slug?: string | null;
              brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
              compatibilities?: Array<{
                __typename?: 'ProductFamilyCompatibility';
                family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
                requirementAlternatives?: Array<{
                  __typename?: 'ProductFamilyCompatibilityRequirementAlternative';
                  requirements?: Array<{
                    __typename?: 'ProductFamilyCompatibilityRequirement';
                    family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
                    offer?:
                      | {
                          __typename?: 'CollapsibleOffer';
                          product?:
                            | { __typename?: 'BundleProduct'; slug?: string | null }
                            | { __typename?: 'StandardProduct'; slug?: string | null }
                            | null;
                        }
                      | {
                          __typename?: 'DefaultOffer';
                          product?:
                            | { __typename?: 'BundleProduct'; slug?: string | null }
                            | { __typename?: 'StandardProduct'; slug?: string | null }
                            | null;
                        }
                      | {
                          __typename?: 'ScopedOffer';
                          product?:
                            | { __typename?: 'BundleProduct'; slug?: string | null }
                            | { __typename?: 'StandardProduct'; slug?: string | null }
                            | null;
                        }
                      | null;
                  } | null> | null;
                } | null> | null;
              } | null> | null;
              warranty?: {
                __typename?: 'Warranty';
                additionalCommercialGuarantee?: any | null;
                repairabilityClass?: RepairabilityClass | null;
                softwareUpdates?: string | null;
              } | null;
              categories?: Array<{
                __typename?: 'ProductCategory';
                categoryNumber?: string | null;
              } | null> | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
              rootCategories?: Array<{
                __typename?: 'ProductCategory';
                slug?: string | null;
              } | null> | null;
            }
          | null;
        energyEfficiency?: {
          __typename?: 'EnergyEfficiency';
          class?: EnergyEfficiencyClass | null;
          labelImage?:
            | {
                __typename?: 'LocalAttachment';
                mediaId?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | {
                __typename?: 'RemoteAttachment';
                url?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | null;
          document?:
            | {
                __typename?: 'LocalAttachment';
                path?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | {
                __typename?: 'RemoteAttachment';
                url?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | null;
        } | null;
      }
    | null;
  productAlternatives?: Array<{
    __typename?: 'ProductAlternativeItemGroup';
    position?: number | null;
    family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
    properties?: Array<{
      __typename?: 'ProductAlternativeSelectorGroup';
      key?: ProductSelectorField | null;
      alternatives?: Array<{
        __typename?: 'ProductAlternative';
        active?: boolean | null;
        exactMatch?: boolean | null;
        offer?: {
          __typename?: 'ScopedOffer';
          prices?: Array<{
            __typename?: 'Price';
            amount?: number | null;
            paymentFrequency?: PaymentFrequency | null;
            type?: PriceType | null;
            value?: any | null;
          } | null> | null;
          scopedProduct?: {
            __typename?: 'StandardProduct';
            size?: string | null;
            variantName?: string | null;
            name?: string | null;
            color?: {
              __typename?: 'Color';
              code?: any | null;
              name?: string | null;
              colorful?: boolean | null;
            } | null;
            storage?: {
              __typename?: 'MemorySize';
              unit?: MemoryUnit | null;
              value?: number | null;
            } | null;
            memory?: {
              __typename?: 'MemorySize';
              unit?: MemoryUnit | null;
              value?: number | null;
            } | null;
            energyEfficiency?: {
              __typename?: 'EnergyEfficiency';
              class?: EnergyEfficiencyClass | null;
              labelImage?:
                | {
                    __typename?: 'LocalAttachment';
                    mediaId?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
              document?:
                | {
                    __typename?: 'LocalAttachment';
                    path?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
            } | null;
          } | null;
          product?:
            | {
                __typename?: 'BundleProduct';
                articleNumber?: string | null;
                name?: string | null;
                slug?: string | null;
                availability?: {
                  __typename?: 'ProductAvailability';
                  stock?: number | null;
                  provider?: ProductProviderKey | null;
                  deliveryLeadTime?: {
                    __typename?: 'DeliveryLeadTime';
                    text?: string | null;
                  } | null;
                } | null;
                teaserImage?:
                  | {
                      __typename?: 'LocalAttachment';
                      mediaId?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
              }
            | {
                __typename?: 'StandardProduct';
                articleNumber?: string | null;
                name?: string | null;
                slug?: string | null;
                availability?: {
                  __typename?: 'ProductAvailability';
                  stock?: number | null;
                  provider?: ProductProviderKey | null;
                  deliveryLeadTime?: {
                    __typename?: 'DeliveryLeadTime';
                    text?: string | null;
                  } | null;
                } | null;
                teaserImage?:
                  | {
                      __typename?: 'LocalAttachment';
                      mediaId?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
              }
            | null;
        } | null;
      } | null> | null;
    } | null> | null;
  } | null> | null;
};

type OfferData_DefaultOffer_Fragment = {
  __typename?: 'DefaultOffer';
  maxOrderableAmount?: number | null;
  updatedAt?: any | null;
  usps?: Array<string | null> | null;
  summaryTexts?: Array<string | null> | null;
  documents?: Array<
    | {
        __typename?: 'LocalAttachment';
        path?: string | null;
        type?: AttachmentType | null;
        name?: string | null;
        remote?: boolean | null;
      }
    | {
        __typename?: 'RemoteAttachment';
        url?: string | null;
        type?: AttachmentType | null;
        name?: string | null;
        remote?: boolean | null;
      }
    | null
  > | null;
  media?: Array<
    | {
        __typename?: 'LocalAttachment';
        mediaId?: string | null;
        type?: AttachmentType | null;
        name?: string | null;
        remote?: boolean | null;
      }
    | {
        __typename?: 'RemoteAttachment';
        url?: string | null;
        type?: AttachmentType | null;
        name?: string | null;
        remote?: boolean | null;
      }
    | null
  > | null;
  teaserImage?:
    | {
        __typename?: 'LocalAttachment';
        mediaId?: string | null;
        type?: AttachmentType | null;
        name?: string | null;
        remote?: boolean | null;
      }
    | {
        __typename?: 'RemoteAttachment';
        url?: string | null;
        type?: AttachmentType | null;
        name?: string | null;
        remote?: boolean | null;
      }
    | null;
  prices?: Array<{
    __typename?: 'Price';
    amount?: number | null;
    currency?: string | null;
    paymentFrequency?: PaymentFrequency | null;
    type?: PriceType | null;
    value?: any | null;
  } | null> | null;
  accessories?: Array<{
    __typename?: 'DefaultOffer';
    maxOrderableAmount?: number | null;
    updatedAt?: any | null;
    product?:
      | {
          __typename?: 'BundleProduct';
          articleNumber?: string | null;
          bundle?: boolean | null;
          name?: string | null;
          slug?: string | null;
          tags?: Array<string | null> | null;
          origin?: Origin | null;
          alwaysDisplayed?: boolean | null;
          deliveryLeadTime?: string | null;
          bundledProducts?: Array<{
            __typename?: 'StandardProduct';
            name?: string | null;
            tags?: Array<string | null> | null;
            family?:
              | { __typename?: 'BundleProductFamily'; name?: string | null }
              | {
                  __typename?: 'StandardProductFamily';
                  name?: string | null;
                  brand?: {
                    __typename?: 'Brand';
                    name?: string | null;
                    slug?: string | null;
                  } | null;
                }
              | null;
            teaserImage?:
              | {
                  __typename?: 'LocalAttachment';
                  mediaId?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
            energyEfficiency?: {
              __typename?: 'EnergyEfficiency';
              class?: EnergyEfficiencyClass | null;
              labelImage?:
                | {
                    __typename?: 'LocalAttachment';
                    mediaId?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
              document?:
                | {
                    __typename?: 'LocalAttachment';
                    path?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
            } | null;
          } | null> | null;
          availability?: {
            __typename?: 'ProductAvailability';
            stock?: number | null;
            provider?: ProductProviderKey | null;
            deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
          } | null;
          family?:
            | {
                __typename?: 'BundleProductFamily';
                name?: string | null;
                primaryCategory?: {
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                  ancestors?: Array<{
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                  } | null> | null;
                } | null;
              }
            | {
                __typename?: 'StandardProductFamily';
                name?: string | null;
                brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
                primaryCategory?: {
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                  ancestors?: Array<{
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                  } | null> | null;
                } | null;
              }
            | null;
        }
      | {
          __typename?: 'StandardProduct';
          articleNumber?: string | null;
          bundle?: boolean | null;
          name?: string | null;
          slug?: string | null;
          tags?: Array<string | null> | null;
          origin?: Origin | null;
          alwaysDisplayed?: boolean | null;
          deliveryLeadTime?: string | null;
          externalLinks?: { __typename?: 'ExternalLinks'; oneShopUrl?: string | null } | null;
          availability?: {
            __typename?: 'ProductAvailability';
            stock?: number | null;
            provider?: ProductProviderKey | null;
            deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
          } | null;
          family?:
            | {
                __typename?: 'BundleProductFamily';
                name?: string | null;
                primaryCategory?: {
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                  ancestors?: Array<{
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                  } | null> | null;
                } | null;
              }
            | {
                __typename?: 'StandardProductFamily';
                name?: string | null;
                brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
                primaryCategory?: {
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                  ancestors?: Array<{
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                  } | null> | null;
                } | null;
              }
            | null;
          energyEfficiency?: {
            __typename?: 'EnergyEfficiency';
            class?: EnergyEfficiencyClass | null;
            labelImage?:
              | {
                  __typename?: 'LocalAttachment';
                  mediaId?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
            document?:
              | {
                  __typename?: 'LocalAttachment';
                  path?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
          } | null;
        }
      | null;
    media?: Array<
      | {
          __typename?: 'LocalAttachment';
          mediaId?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | {
          __typename?: 'RemoteAttachment';
          url?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | null
    > | null;
    teaserImage?:
      | {
          __typename?: 'LocalAttachment';
          mediaId?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | {
          __typename?: 'RemoteAttachment';
          url?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | null;
    prices?: Array<{
      __typename?: 'Price';
      amount?: number | null;
      currency?: string | null;
      paymentFrequency?: PaymentFrequency | null;
      type?: PriceType | null;
      value?: any | null;
    } | null> | null;
    productAlternatives?: Array<{
      __typename?: 'ProductAlternativeItemGroup';
      position?: number | null;
      family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
      properties?: Array<{
        __typename?: 'ProductAlternativeSelectorGroup';
        key?: ProductSelectorField | null;
        alternatives?: Array<{
          __typename?: 'ProductAlternative';
          active?: boolean | null;
          exactMatch?: boolean | null;
          offer?: {
            __typename?: 'ScopedOffer';
            prices?: Array<{
              __typename?: 'Price';
              amount?: number | null;
              paymentFrequency?: PaymentFrequency | null;
              type?: PriceType | null;
              value?: any | null;
            } | null> | null;
            scopedProduct?: {
              __typename?: 'StandardProduct';
              size?: string | null;
              variantName?: string | null;
              name?: string | null;
              color?: {
                __typename?: 'Color';
                code?: any | null;
                name?: string | null;
                colorful?: boolean | null;
              } | null;
              storage?: {
                __typename?: 'MemorySize';
                unit?: MemoryUnit | null;
                value?: number | null;
              } | null;
              memory?: {
                __typename?: 'MemorySize';
                unit?: MemoryUnit | null;
                value?: number | null;
              } | null;
              energyEfficiency?: {
                __typename?: 'EnergyEfficiency';
                class?: EnergyEfficiencyClass | null;
                labelImage?:
                  | {
                      __typename?: 'LocalAttachment';
                      mediaId?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
                document?:
                  | {
                      __typename?: 'LocalAttachment';
                      path?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
              } | null;
            } | null;
            product?:
              | {
                  __typename?: 'BundleProduct';
                  articleNumber?: string | null;
                  name?: string | null;
                  slug?: string | null;
                  availability?: {
                    __typename?: 'ProductAvailability';
                    stock?: number | null;
                    provider?: ProductProviderKey | null;
                    deliveryLeadTime?: {
                      __typename?: 'DeliveryLeadTime';
                      text?: string | null;
                    } | null;
                  } | null;
                  teaserImage?:
                    | {
                        __typename?: 'LocalAttachment';
                        mediaId?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | {
                        __typename?: 'RemoteAttachment';
                        url?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | null;
                }
              | {
                  __typename?: 'StandardProduct';
                  articleNumber?: string | null;
                  name?: string | null;
                  slug?: string | null;
                  availability?: {
                    __typename?: 'ProductAvailability';
                    stock?: number | null;
                    provider?: ProductProviderKey | null;
                    deliveryLeadTime?: {
                      __typename?: 'DeliveryLeadTime';
                      text?: string | null;
                    } | null;
                  } | null;
                  teaserImage?:
                    | {
                        __typename?: 'LocalAttachment';
                        mediaId?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | {
                        __typename?: 'RemoteAttachment';
                        url?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | null;
                }
              | null;
          } | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
  } | null> | null;
  recommendations?: Array<{
    __typename?: 'DefaultOffer';
    maxOrderableAmount?: number | null;
    updatedAt?: any | null;
    product?:
      | {
          __typename?: 'BundleProduct';
          articleNumber?: string | null;
          bundle?: boolean | null;
          name?: string | null;
          slug?: string | null;
          tags?: Array<string | null> | null;
          origin?: Origin | null;
          alwaysDisplayed?: boolean | null;
          deliveryLeadTime?: string | null;
          bundledProducts?: Array<{
            __typename?: 'StandardProduct';
            name?: string | null;
            tags?: Array<string | null> | null;
            family?:
              | { __typename?: 'BundleProductFamily'; name?: string | null }
              | {
                  __typename?: 'StandardProductFamily';
                  name?: string | null;
                  brand?: {
                    __typename?: 'Brand';
                    name?: string | null;
                    slug?: string | null;
                  } | null;
                }
              | null;
            teaserImage?:
              | {
                  __typename?: 'LocalAttachment';
                  mediaId?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
            energyEfficiency?: {
              __typename?: 'EnergyEfficiency';
              class?: EnergyEfficiencyClass | null;
              labelImage?:
                | {
                    __typename?: 'LocalAttachment';
                    mediaId?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
              document?:
                | {
                    __typename?: 'LocalAttachment';
                    path?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
            } | null;
          } | null> | null;
          availability?: {
            __typename?: 'ProductAvailability';
            stock?: number | null;
            provider?: ProductProviderKey | null;
            deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
          } | null;
          family?:
            | {
                __typename?: 'BundleProductFamily';
                name?: string | null;
                primaryCategory?: {
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                  ancestors?: Array<{
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                  } | null> | null;
                } | null;
              }
            | {
                __typename?: 'StandardProductFamily';
                name?: string | null;
                brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
                primaryCategory?: {
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                  ancestors?: Array<{
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                  } | null> | null;
                } | null;
              }
            | null;
        }
      | {
          __typename?: 'StandardProduct';
          articleNumber?: string | null;
          bundle?: boolean | null;
          name?: string | null;
          slug?: string | null;
          tags?: Array<string | null> | null;
          origin?: Origin | null;
          alwaysDisplayed?: boolean | null;
          deliveryLeadTime?: string | null;
          externalLinks?: { __typename?: 'ExternalLinks'; oneShopUrl?: string | null } | null;
          availability?: {
            __typename?: 'ProductAvailability';
            stock?: number | null;
            provider?: ProductProviderKey | null;
            deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
          } | null;
          family?:
            | {
                __typename?: 'BundleProductFamily';
                name?: string | null;
                primaryCategory?: {
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                  ancestors?: Array<{
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                  } | null> | null;
                } | null;
              }
            | {
                __typename?: 'StandardProductFamily';
                name?: string | null;
                brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
                primaryCategory?: {
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                  ancestors?: Array<{
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                  } | null> | null;
                } | null;
              }
            | null;
          energyEfficiency?: {
            __typename?: 'EnergyEfficiency';
            class?: EnergyEfficiencyClass | null;
            labelImage?:
              | {
                  __typename?: 'LocalAttachment';
                  mediaId?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
            document?:
              | {
                  __typename?: 'LocalAttachment';
                  path?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
          } | null;
        }
      | null;
    media?: Array<
      | {
          __typename?: 'LocalAttachment';
          mediaId?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | {
          __typename?: 'RemoteAttachment';
          url?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | null
    > | null;
    teaserImage?:
      | {
          __typename?: 'LocalAttachment';
          mediaId?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | {
          __typename?: 'RemoteAttachment';
          url?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | null;
    prices?: Array<{
      __typename?: 'Price';
      amount?: number | null;
      currency?: string | null;
      paymentFrequency?: PaymentFrequency | null;
      type?: PriceType | null;
      value?: any | null;
    } | null> | null;
    productAlternatives?: Array<{
      __typename?: 'ProductAlternativeItemGroup';
      position?: number | null;
      family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
      properties?: Array<{
        __typename?: 'ProductAlternativeSelectorGroup';
        key?: ProductSelectorField | null;
        alternatives?: Array<{
          __typename?: 'ProductAlternative';
          active?: boolean | null;
          exactMatch?: boolean | null;
          offer?: {
            __typename?: 'ScopedOffer';
            prices?: Array<{
              __typename?: 'Price';
              amount?: number | null;
              paymentFrequency?: PaymentFrequency | null;
              type?: PriceType | null;
              value?: any | null;
            } | null> | null;
            scopedProduct?: {
              __typename?: 'StandardProduct';
              size?: string | null;
              variantName?: string | null;
              name?: string | null;
              color?: {
                __typename?: 'Color';
                code?: any | null;
                name?: string | null;
                colorful?: boolean | null;
              } | null;
              storage?: {
                __typename?: 'MemorySize';
                unit?: MemoryUnit | null;
                value?: number | null;
              } | null;
              memory?: {
                __typename?: 'MemorySize';
                unit?: MemoryUnit | null;
                value?: number | null;
              } | null;
              energyEfficiency?: {
                __typename?: 'EnergyEfficiency';
                class?: EnergyEfficiencyClass | null;
                labelImage?:
                  | {
                      __typename?: 'LocalAttachment';
                      mediaId?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
                document?:
                  | {
                      __typename?: 'LocalAttachment';
                      path?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
              } | null;
            } | null;
            product?:
              | {
                  __typename?: 'BundleProduct';
                  articleNumber?: string | null;
                  name?: string | null;
                  slug?: string | null;
                  availability?: {
                    __typename?: 'ProductAvailability';
                    stock?: number | null;
                    provider?: ProductProviderKey | null;
                    deliveryLeadTime?: {
                      __typename?: 'DeliveryLeadTime';
                      text?: string | null;
                    } | null;
                  } | null;
                  teaserImage?:
                    | {
                        __typename?: 'LocalAttachment';
                        mediaId?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | {
                        __typename?: 'RemoteAttachment';
                        url?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | null;
                }
              | {
                  __typename?: 'StandardProduct';
                  articleNumber?: string | null;
                  name?: string | null;
                  slug?: string | null;
                  availability?: {
                    __typename?: 'ProductAvailability';
                    stock?: number | null;
                    provider?: ProductProviderKey | null;
                    deliveryLeadTime?: {
                      __typename?: 'DeliveryLeadTime';
                      text?: string | null;
                    } | null;
                  } | null;
                  teaserImage?:
                    | {
                        __typename?: 'LocalAttachment';
                        mediaId?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | {
                        __typename?: 'RemoteAttachment';
                        url?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | null;
                }
              | null;
          } | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
  } | null> | null;
  product?:
    | {
        __typename?: 'BundleProduct';
        description?: string | null;
        articleNumber?: string | null;
        eans?: Array<string | null> | null;
        bundle?: boolean | null;
        name?: string | null;
        slug?: string | null;
        legalTexts?: Array<string | null> | null;
        tags?: Array<string | null> | null;
        origin?: Origin | null;
        deliveryLeadTime?: string | null;
        alwaysDisplayed?: boolean | null;
        usps?: Array<string | null> | null;
        bundledProducts?: Array<{
          __typename?: 'StandardProduct';
          securityInformationUrl?: string | null;
          articleNumber?: string | null;
          name?: string | null;
          eans?: Array<string | null> | null;
          description?: string | null;
          slug?: string | null;
          usps?: Array<string | null> | null;
          deliveredItems?: Array<string | null> | null;
          tags?: Array<string | null> | null;
          origin?: Origin | null;
          commonCharger?: {
            __typename?: 'CommonCharger';
            included?: boolean | null;
            minWattage?: any | null;
            maxWattage?: any | null;
            possible?: boolean | null;
            usbPd?: boolean | null;
          } | null;
          teaserImage?:
            | {
                __typename?: 'LocalAttachment';
                mediaId?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | {
                __typename?: 'RemoteAttachment';
                url?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | null;
          family?:
            | { __typename?: 'BundleProductFamily'; name?: string | null; slug?: string | null }
            | {
                __typename?: 'StandardProductFamily';
                manufacturerContact?: string | null;
                manufacturerContactEu?: string | null;
                name?: string | null;
                slug?: string | null;
                compatibilities?: Array<{
                  __typename?: 'ProductFamilyCompatibility';
                  family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
                  requirementAlternatives?: Array<{
                    __typename?: 'ProductFamilyCompatibilityRequirementAlternative';
                    requirements?: Array<{
                      __typename?: 'ProductFamilyCompatibilityRequirement';
                      family?: {
                        __typename?: 'StandardProductFamily';
                        name?: string | null;
                      } | null;
                      offer?:
                        | {
                            __typename?: 'CollapsibleOffer';
                            product?:
                              | { __typename?: 'BundleProduct'; slug?: string | null }
                              | { __typename?: 'StandardProduct'; slug?: string | null }
                              | null;
                          }
                        | {
                            __typename?: 'DefaultOffer';
                            product?:
                              | { __typename?: 'BundleProduct'; slug?: string | null }
                              | { __typename?: 'StandardProduct'; slug?: string | null }
                              | null;
                          }
                        | {
                            __typename?: 'ScopedOffer';
                            product?:
                              | { __typename?: 'BundleProduct'; slug?: string | null }
                              | { __typename?: 'StandardProduct'; slug?: string | null }
                              | null;
                          }
                        | null;
                    } | null> | null;
                  } | null> | null;
                } | null> | null;
                brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
                warranty?: {
                  __typename?: 'Warranty';
                  additionalCommercialGuarantee?: any | null;
                  repairabilityClass?: RepairabilityClass | null;
                  softwareUpdates?: string | null;
                } | null;
              }
            | null;
          features?: Array<{
            __typename?: 'Feature';
            name?: string | null;
            value?: string | null;
          } | null> | null;
          media?: Array<
            | {
                __typename?: 'LocalAttachment';
                mediaId?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | {
                __typename?: 'RemoteAttachment';
                url?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | null
          > | null;
          energyEfficiency?: {
            __typename?: 'EnergyEfficiency';
            class?: EnergyEfficiencyClass | null;
            labelImage?:
              | {
                  __typename?: 'LocalAttachment';
                  mediaId?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
            document?:
              | {
                  __typename?: 'LocalAttachment';
                  path?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
          } | null;
        } | null> | null;
        availability?: {
          __typename?: 'ProductAvailability';
          stock?: number | null;
          provider?: ProductProviderKey | null;
          deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
        } | null;
        family?:
          | {
              __typename?: 'BundleProductFamily';
              name?: string | null;
              slug?: string | null;
              categories?: Array<{
                __typename?: 'ProductCategory';
                categoryNumber?: string | null;
              } | null> | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
              rootCategories?: Array<{
                __typename?: 'ProductCategory';
                slug?: string | null;
              } | null> | null;
            }
          | {
              __typename?: 'StandardProductFamily';
              manufacturerContact?: string | null;
              manufacturerContactEu?: string | null;
              name?: string | null;
              slug?: string | null;
              brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
              compatibilities?: Array<{
                __typename?: 'ProductFamilyCompatibility';
                family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
                requirementAlternatives?: Array<{
                  __typename?: 'ProductFamilyCompatibilityRequirementAlternative';
                  requirements?: Array<{
                    __typename?: 'ProductFamilyCompatibilityRequirement';
                    family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
                    offer?:
                      | {
                          __typename?: 'CollapsibleOffer';
                          product?:
                            | { __typename?: 'BundleProduct'; slug?: string | null }
                            | { __typename?: 'StandardProduct'; slug?: string | null }
                            | null;
                        }
                      | {
                          __typename?: 'DefaultOffer';
                          product?:
                            | { __typename?: 'BundleProduct'; slug?: string | null }
                            | { __typename?: 'StandardProduct'; slug?: string | null }
                            | null;
                        }
                      | {
                          __typename?: 'ScopedOffer';
                          product?:
                            | { __typename?: 'BundleProduct'; slug?: string | null }
                            | { __typename?: 'StandardProduct'; slug?: string | null }
                            | null;
                        }
                      | null;
                  } | null> | null;
                } | null> | null;
              } | null> | null;
              warranty?: {
                __typename?: 'Warranty';
                additionalCommercialGuarantee?: any | null;
                repairabilityClass?: RepairabilityClass | null;
                softwareUpdates?: string | null;
              } | null;
              categories?: Array<{
                __typename?: 'ProductCategory';
                categoryNumber?: string | null;
              } | null> | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
              rootCategories?: Array<{
                __typename?: 'ProductCategory';
                slug?: string | null;
              } | null> | null;
            }
          | null;
      }
    | {
        __typename?: 'StandardProduct';
        description?: string | null;
        deliveredItems?: Array<string | null> | null;
        deliveryLeadTime?: string | null;
        model?: string | null;
        size?: string | null;
        variantName?: string | null;
        securityInformationUrl?: string | null;
        articleNumber?: string | null;
        eans?: Array<string | null> | null;
        bundle?: boolean | null;
        name?: string | null;
        slug?: string | null;
        legalTexts?: Array<string | null> | null;
        tags?: Array<string | null> | null;
        origin?: Origin | null;
        alwaysDisplayed?: boolean | null;
        usps?: Array<string | null> | null;
        externalLinks?: { __typename?: 'ExternalLinks'; oneShopUrl?: string | null } | null;
        brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
        color?: { __typename?: 'Color'; code?: any | null; name?: string | null } | null;
        storage?: {
          __typename?: 'MemorySize';
          value?: number | null;
          unit?: MemoryUnit | null;
        } | null;
        features?: Array<{
          __typename?: 'Feature';
          name?: string | null;
          value?: string | null;
        } | null> | null;
        commonCharger?: {
          __typename?: 'CommonCharger';
          included?: boolean | null;
          minWattage?: any | null;
          maxWattage?: any | null;
          possible?: boolean | null;
          usbPd?: boolean | null;
        } | null;
        availability?: {
          __typename?: 'ProductAvailability';
          stock?: number | null;
          provider?: ProductProviderKey | null;
          deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
        } | null;
        family?:
          | {
              __typename?: 'BundleProductFamily';
              name?: string | null;
              slug?: string | null;
              categories?: Array<{
                __typename?: 'ProductCategory';
                categoryNumber?: string | null;
              } | null> | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
              rootCategories?: Array<{
                __typename?: 'ProductCategory';
                slug?: string | null;
              } | null> | null;
            }
          | {
              __typename?: 'StandardProductFamily';
              manufacturerContact?: string | null;
              manufacturerContactEu?: string | null;
              name?: string | null;
              slug?: string | null;
              brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
              compatibilities?: Array<{
                __typename?: 'ProductFamilyCompatibility';
                family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
                requirementAlternatives?: Array<{
                  __typename?: 'ProductFamilyCompatibilityRequirementAlternative';
                  requirements?: Array<{
                    __typename?: 'ProductFamilyCompatibilityRequirement';
                    family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
                    offer?:
                      | {
                          __typename?: 'CollapsibleOffer';
                          product?:
                            | { __typename?: 'BundleProduct'; slug?: string | null }
                            | { __typename?: 'StandardProduct'; slug?: string | null }
                            | null;
                        }
                      | {
                          __typename?: 'DefaultOffer';
                          product?:
                            | { __typename?: 'BundleProduct'; slug?: string | null }
                            | { __typename?: 'StandardProduct'; slug?: string | null }
                            | null;
                        }
                      | {
                          __typename?: 'ScopedOffer';
                          product?:
                            | { __typename?: 'BundleProduct'; slug?: string | null }
                            | { __typename?: 'StandardProduct'; slug?: string | null }
                            | null;
                        }
                      | null;
                  } | null> | null;
                } | null> | null;
              } | null> | null;
              warranty?: {
                __typename?: 'Warranty';
                additionalCommercialGuarantee?: any | null;
                repairabilityClass?: RepairabilityClass | null;
                softwareUpdates?: string | null;
              } | null;
              categories?: Array<{
                __typename?: 'ProductCategory';
                categoryNumber?: string | null;
              } | null> | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
              rootCategories?: Array<{
                __typename?: 'ProductCategory';
                slug?: string | null;
              } | null> | null;
            }
          | null;
        energyEfficiency?: {
          __typename?: 'EnergyEfficiency';
          class?: EnergyEfficiencyClass | null;
          labelImage?:
            | {
                __typename?: 'LocalAttachment';
                mediaId?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | {
                __typename?: 'RemoteAttachment';
                url?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | null;
          document?:
            | {
                __typename?: 'LocalAttachment';
                path?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | {
                __typename?: 'RemoteAttachment';
                url?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | null;
        } | null;
      }
    | null;
  productAlternatives?: Array<{
    __typename?: 'ProductAlternativeItemGroup';
    position?: number | null;
    family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
    properties?: Array<{
      __typename?: 'ProductAlternativeSelectorGroup';
      key?: ProductSelectorField | null;
      alternatives?: Array<{
        __typename?: 'ProductAlternative';
        active?: boolean | null;
        exactMatch?: boolean | null;
        offer?: {
          __typename?: 'ScopedOffer';
          prices?: Array<{
            __typename?: 'Price';
            amount?: number | null;
            paymentFrequency?: PaymentFrequency | null;
            type?: PriceType | null;
            value?: any | null;
          } | null> | null;
          scopedProduct?: {
            __typename?: 'StandardProduct';
            size?: string | null;
            variantName?: string | null;
            name?: string | null;
            color?: {
              __typename?: 'Color';
              code?: any | null;
              name?: string | null;
              colorful?: boolean | null;
            } | null;
            storage?: {
              __typename?: 'MemorySize';
              unit?: MemoryUnit | null;
              value?: number | null;
            } | null;
            memory?: {
              __typename?: 'MemorySize';
              unit?: MemoryUnit | null;
              value?: number | null;
            } | null;
            energyEfficiency?: {
              __typename?: 'EnergyEfficiency';
              class?: EnergyEfficiencyClass | null;
              labelImage?:
                | {
                    __typename?: 'LocalAttachment';
                    mediaId?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
              document?:
                | {
                    __typename?: 'LocalAttachment';
                    path?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
            } | null;
          } | null;
          product?:
            | {
                __typename?: 'BundleProduct';
                articleNumber?: string | null;
                name?: string | null;
                slug?: string | null;
                availability?: {
                  __typename?: 'ProductAvailability';
                  stock?: number | null;
                  provider?: ProductProviderKey | null;
                  deliveryLeadTime?: {
                    __typename?: 'DeliveryLeadTime';
                    text?: string | null;
                  } | null;
                } | null;
                teaserImage?:
                  | {
                      __typename?: 'LocalAttachment';
                      mediaId?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
              }
            | {
                __typename?: 'StandardProduct';
                articleNumber?: string | null;
                name?: string | null;
                slug?: string | null;
                availability?: {
                  __typename?: 'ProductAvailability';
                  stock?: number | null;
                  provider?: ProductProviderKey | null;
                  deliveryLeadTime?: {
                    __typename?: 'DeliveryLeadTime';
                    text?: string | null;
                  } | null;
                } | null;
                teaserImage?:
                  | {
                      __typename?: 'LocalAttachment';
                      mediaId?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
              }
            | null;
        } | null;
      } | null> | null;
    } | null> | null;
  } | null> | null;
};

type OfferData_ScopedOffer_Fragment = {
  __typename?: 'ScopedOffer';
  maxOrderableAmount?: number | null;
  updatedAt?: any | null;
  usps?: Array<string | null> | null;
  summaryTexts?: Array<string | null> | null;
  documents?: Array<
    | {
        __typename?: 'LocalAttachment';
        path?: string | null;
        type?: AttachmentType | null;
        name?: string | null;
        remote?: boolean | null;
      }
    | {
        __typename?: 'RemoteAttachment';
        url?: string | null;
        type?: AttachmentType | null;
        name?: string | null;
        remote?: boolean | null;
      }
    | null
  > | null;
  media?: Array<
    | {
        __typename?: 'LocalAttachment';
        mediaId?: string | null;
        type?: AttachmentType | null;
        name?: string | null;
        remote?: boolean | null;
      }
    | {
        __typename?: 'RemoteAttachment';
        url?: string | null;
        type?: AttachmentType | null;
        name?: string | null;
        remote?: boolean | null;
      }
    | null
  > | null;
  teaserImage?:
    | {
        __typename?: 'LocalAttachment';
        mediaId?: string | null;
        type?: AttachmentType | null;
        name?: string | null;
        remote?: boolean | null;
      }
    | {
        __typename?: 'RemoteAttachment';
        url?: string | null;
        type?: AttachmentType | null;
        name?: string | null;
        remote?: boolean | null;
      }
    | null;
  prices?: Array<{
    __typename?: 'Price';
    amount?: number | null;
    currency?: string | null;
    paymentFrequency?: PaymentFrequency | null;
    type?: PriceType | null;
    value?: any | null;
  } | null> | null;
  accessories?: Array<{
    __typename?: 'DefaultOffer';
    maxOrderableAmount?: number | null;
    updatedAt?: any | null;
    product?:
      | {
          __typename?: 'BundleProduct';
          articleNumber?: string | null;
          bundle?: boolean | null;
          name?: string | null;
          slug?: string | null;
          tags?: Array<string | null> | null;
          origin?: Origin | null;
          alwaysDisplayed?: boolean | null;
          deliveryLeadTime?: string | null;
          bundledProducts?: Array<{
            __typename?: 'StandardProduct';
            name?: string | null;
            tags?: Array<string | null> | null;
            family?:
              | { __typename?: 'BundleProductFamily'; name?: string | null }
              | {
                  __typename?: 'StandardProductFamily';
                  name?: string | null;
                  brand?: {
                    __typename?: 'Brand';
                    name?: string | null;
                    slug?: string | null;
                  } | null;
                }
              | null;
            teaserImage?:
              | {
                  __typename?: 'LocalAttachment';
                  mediaId?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
            energyEfficiency?: {
              __typename?: 'EnergyEfficiency';
              class?: EnergyEfficiencyClass | null;
              labelImage?:
                | {
                    __typename?: 'LocalAttachment';
                    mediaId?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
              document?:
                | {
                    __typename?: 'LocalAttachment';
                    path?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
            } | null;
          } | null> | null;
          availability?: {
            __typename?: 'ProductAvailability';
            stock?: number | null;
            provider?: ProductProviderKey | null;
            deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
          } | null;
          family?:
            | {
                __typename?: 'BundleProductFamily';
                name?: string | null;
                primaryCategory?: {
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                  ancestors?: Array<{
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                  } | null> | null;
                } | null;
              }
            | {
                __typename?: 'StandardProductFamily';
                name?: string | null;
                brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
                primaryCategory?: {
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                  ancestors?: Array<{
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                  } | null> | null;
                } | null;
              }
            | null;
        }
      | {
          __typename?: 'StandardProduct';
          articleNumber?: string | null;
          bundle?: boolean | null;
          name?: string | null;
          slug?: string | null;
          tags?: Array<string | null> | null;
          origin?: Origin | null;
          alwaysDisplayed?: boolean | null;
          deliveryLeadTime?: string | null;
          externalLinks?: { __typename?: 'ExternalLinks'; oneShopUrl?: string | null } | null;
          availability?: {
            __typename?: 'ProductAvailability';
            stock?: number | null;
            provider?: ProductProviderKey | null;
            deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
          } | null;
          family?:
            | {
                __typename?: 'BundleProductFamily';
                name?: string | null;
                primaryCategory?: {
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                  ancestors?: Array<{
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                  } | null> | null;
                } | null;
              }
            | {
                __typename?: 'StandardProductFamily';
                name?: string | null;
                brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
                primaryCategory?: {
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                  ancestors?: Array<{
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                  } | null> | null;
                } | null;
              }
            | null;
          energyEfficiency?: {
            __typename?: 'EnergyEfficiency';
            class?: EnergyEfficiencyClass | null;
            labelImage?:
              | {
                  __typename?: 'LocalAttachment';
                  mediaId?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
            document?:
              | {
                  __typename?: 'LocalAttachment';
                  path?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
          } | null;
        }
      | null;
    media?: Array<
      | {
          __typename?: 'LocalAttachment';
          mediaId?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | {
          __typename?: 'RemoteAttachment';
          url?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | null
    > | null;
    teaserImage?:
      | {
          __typename?: 'LocalAttachment';
          mediaId?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | {
          __typename?: 'RemoteAttachment';
          url?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | null;
    prices?: Array<{
      __typename?: 'Price';
      amount?: number | null;
      currency?: string | null;
      paymentFrequency?: PaymentFrequency | null;
      type?: PriceType | null;
      value?: any | null;
    } | null> | null;
    productAlternatives?: Array<{
      __typename?: 'ProductAlternativeItemGroup';
      position?: number | null;
      family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
      properties?: Array<{
        __typename?: 'ProductAlternativeSelectorGroup';
        key?: ProductSelectorField | null;
        alternatives?: Array<{
          __typename?: 'ProductAlternative';
          active?: boolean | null;
          exactMatch?: boolean | null;
          offer?: {
            __typename?: 'ScopedOffer';
            prices?: Array<{
              __typename?: 'Price';
              amount?: number | null;
              paymentFrequency?: PaymentFrequency | null;
              type?: PriceType | null;
              value?: any | null;
            } | null> | null;
            scopedProduct?: {
              __typename?: 'StandardProduct';
              size?: string | null;
              variantName?: string | null;
              name?: string | null;
              color?: {
                __typename?: 'Color';
                code?: any | null;
                name?: string | null;
                colorful?: boolean | null;
              } | null;
              storage?: {
                __typename?: 'MemorySize';
                unit?: MemoryUnit | null;
                value?: number | null;
              } | null;
              memory?: {
                __typename?: 'MemorySize';
                unit?: MemoryUnit | null;
                value?: number | null;
              } | null;
              energyEfficiency?: {
                __typename?: 'EnergyEfficiency';
                class?: EnergyEfficiencyClass | null;
                labelImage?:
                  | {
                      __typename?: 'LocalAttachment';
                      mediaId?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
                document?:
                  | {
                      __typename?: 'LocalAttachment';
                      path?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
              } | null;
            } | null;
            product?:
              | {
                  __typename?: 'BundleProduct';
                  articleNumber?: string | null;
                  name?: string | null;
                  slug?: string | null;
                  availability?: {
                    __typename?: 'ProductAvailability';
                    stock?: number | null;
                    provider?: ProductProviderKey | null;
                    deliveryLeadTime?: {
                      __typename?: 'DeliveryLeadTime';
                      text?: string | null;
                    } | null;
                  } | null;
                  teaserImage?:
                    | {
                        __typename?: 'LocalAttachment';
                        mediaId?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | {
                        __typename?: 'RemoteAttachment';
                        url?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | null;
                }
              | {
                  __typename?: 'StandardProduct';
                  articleNumber?: string | null;
                  name?: string | null;
                  slug?: string | null;
                  availability?: {
                    __typename?: 'ProductAvailability';
                    stock?: number | null;
                    provider?: ProductProviderKey | null;
                    deliveryLeadTime?: {
                      __typename?: 'DeliveryLeadTime';
                      text?: string | null;
                    } | null;
                  } | null;
                  teaserImage?:
                    | {
                        __typename?: 'LocalAttachment';
                        mediaId?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | {
                        __typename?: 'RemoteAttachment';
                        url?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | null;
                }
              | null;
          } | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
  } | null> | null;
  recommendations?: Array<{
    __typename?: 'DefaultOffer';
    maxOrderableAmount?: number | null;
    updatedAt?: any | null;
    product?:
      | {
          __typename?: 'BundleProduct';
          articleNumber?: string | null;
          bundle?: boolean | null;
          name?: string | null;
          slug?: string | null;
          tags?: Array<string | null> | null;
          origin?: Origin | null;
          alwaysDisplayed?: boolean | null;
          deliveryLeadTime?: string | null;
          bundledProducts?: Array<{
            __typename?: 'StandardProduct';
            name?: string | null;
            tags?: Array<string | null> | null;
            family?:
              | { __typename?: 'BundleProductFamily'; name?: string | null }
              | {
                  __typename?: 'StandardProductFamily';
                  name?: string | null;
                  brand?: {
                    __typename?: 'Brand';
                    name?: string | null;
                    slug?: string | null;
                  } | null;
                }
              | null;
            teaserImage?:
              | {
                  __typename?: 'LocalAttachment';
                  mediaId?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
            energyEfficiency?: {
              __typename?: 'EnergyEfficiency';
              class?: EnergyEfficiencyClass | null;
              labelImage?:
                | {
                    __typename?: 'LocalAttachment';
                    mediaId?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
              document?:
                | {
                    __typename?: 'LocalAttachment';
                    path?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
            } | null;
          } | null> | null;
          availability?: {
            __typename?: 'ProductAvailability';
            stock?: number | null;
            provider?: ProductProviderKey | null;
            deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
          } | null;
          family?:
            | {
                __typename?: 'BundleProductFamily';
                name?: string | null;
                primaryCategory?: {
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                  ancestors?: Array<{
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                  } | null> | null;
                } | null;
              }
            | {
                __typename?: 'StandardProductFamily';
                name?: string | null;
                brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
                primaryCategory?: {
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                  ancestors?: Array<{
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                  } | null> | null;
                } | null;
              }
            | null;
        }
      | {
          __typename?: 'StandardProduct';
          articleNumber?: string | null;
          bundle?: boolean | null;
          name?: string | null;
          slug?: string | null;
          tags?: Array<string | null> | null;
          origin?: Origin | null;
          alwaysDisplayed?: boolean | null;
          deliveryLeadTime?: string | null;
          externalLinks?: { __typename?: 'ExternalLinks'; oneShopUrl?: string | null } | null;
          availability?: {
            __typename?: 'ProductAvailability';
            stock?: number | null;
            provider?: ProductProviderKey | null;
            deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
          } | null;
          family?:
            | {
                __typename?: 'BundleProductFamily';
                name?: string | null;
                primaryCategory?: {
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                  ancestors?: Array<{
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                  } | null> | null;
                } | null;
              }
            | {
                __typename?: 'StandardProductFamily';
                name?: string | null;
                brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
                primaryCategory?: {
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                  ancestors?: Array<{
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                  } | null> | null;
                } | null;
              }
            | null;
          energyEfficiency?: {
            __typename?: 'EnergyEfficiency';
            class?: EnergyEfficiencyClass | null;
            labelImage?:
              | {
                  __typename?: 'LocalAttachment';
                  mediaId?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
            document?:
              | {
                  __typename?: 'LocalAttachment';
                  path?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
          } | null;
        }
      | null;
    media?: Array<
      | {
          __typename?: 'LocalAttachment';
          mediaId?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | {
          __typename?: 'RemoteAttachment';
          url?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | null
    > | null;
    teaserImage?:
      | {
          __typename?: 'LocalAttachment';
          mediaId?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | {
          __typename?: 'RemoteAttachment';
          url?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | null;
    prices?: Array<{
      __typename?: 'Price';
      amount?: number | null;
      currency?: string | null;
      paymentFrequency?: PaymentFrequency | null;
      type?: PriceType | null;
      value?: any | null;
    } | null> | null;
    productAlternatives?: Array<{
      __typename?: 'ProductAlternativeItemGroup';
      position?: number | null;
      family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
      properties?: Array<{
        __typename?: 'ProductAlternativeSelectorGroup';
        key?: ProductSelectorField | null;
        alternatives?: Array<{
          __typename?: 'ProductAlternative';
          active?: boolean | null;
          exactMatch?: boolean | null;
          offer?: {
            __typename?: 'ScopedOffer';
            prices?: Array<{
              __typename?: 'Price';
              amount?: number | null;
              paymentFrequency?: PaymentFrequency | null;
              type?: PriceType | null;
              value?: any | null;
            } | null> | null;
            scopedProduct?: {
              __typename?: 'StandardProduct';
              size?: string | null;
              variantName?: string | null;
              name?: string | null;
              color?: {
                __typename?: 'Color';
                code?: any | null;
                name?: string | null;
                colorful?: boolean | null;
              } | null;
              storage?: {
                __typename?: 'MemorySize';
                unit?: MemoryUnit | null;
                value?: number | null;
              } | null;
              memory?: {
                __typename?: 'MemorySize';
                unit?: MemoryUnit | null;
                value?: number | null;
              } | null;
              energyEfficiency?: {
                __typename?: 'EnergyEfficiency';
                class?: EnergyEfficiencyClass | null;
                labelImage?:
                  | {
                      __typename?: 'LocalAttachment';
                      mediaId?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
                document?:
                  | {
                      __typename?: 'LocalAttachment';
                      path?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
              } | null;
            } | null;
            product?:
              | {
                  __typename?: 'BundleProduct';
                  articleNumber?: string | null;
                  name?: string | null;
                  slug?: string | null;
                  availability?: {
                    __typename?: 'ProductAvailability';
                    stock?: number | null;
                    provider?: ProductProviderKey | null;
                    deliveryLeadTime?: {
                      __typename?: 'DeliveryLeadTime';
                      text?: string | null;
                    } | null;
                  } | null;
                  teaserImage?:
                    | {
                        __typename?: 'LocalAttachment';
                        mediaId?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | {
                        __typename?: 'RemoteAttachment';
                        url?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | null;
                }
              | {
                  __typename?: 'StandardProduct';
                  articleNumber?: string | null;
                  name?: string | null;
                  slug?: string | null;
                  availability?: {
                    __typename?: 'ProductAvailability';
                    stock?: number | null;
                    provider?: ProductProviderKey | null;
                    deliveryLeadTime?: {
                      __typename?: 'DeliveryLeadTime';
                      text?: string | null;
                    } | null;
                  } | null;
                  teaserImage?:
                    | {
                        __typename?: 'LocalAttachment';
                        mediaId?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | {
                        __typename?: 'RemoteAttachment';
                        url?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | null;
                }
              | null;
          } | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
  } | null> | null;
  product?:
    | {
        __typename?: 'BundleProduct';
        description?: string | null;
        articleNumber?: string | null;
        eans?: Array<string | null> | null;
        bundle?: boolean | null;
        name?: string | null;
        slug?: string | null;
        legalTexts?: Array<string | null> | null;
        tags?: Array<string | null> | null;
        origin?: Origin | null;
        deliveryLeadTime?: string | null;
        alwaysDisplayed?: boolean | null;
        usps?: Array<string | null> | null;
        bundledProducts?: Array<{
          __typename?: 'StandardProduct';
          securityInformationUrl?: string | null;
          articleNumber?: string | null;
          name?: string | null;
          eans?: Array<string | null> | null;
          description?: string | null;
          slug?: string | null;
          usps?: Array<string | null> | null;
          deliveredItems?: Array<string | null> | null;
          tags?: Array<string | null> | null;
          origin?: Origin | null;
          commonCharger?: {
            __typename?: 'CommonCharger';
            included?: boolean | null;
            minWattage?: any | null;
            maxWattage?: any | null;
            possible?: boolean | null;
            usbPd?: boolean | null;
          } | null;
          teaserImage?:
            | {
                __typename?: 'LocalAttachment';
                mediaId?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | {
                __typename?: 'RemoteAttachment';
                url?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | null;
          family?:
            | { __typename?: 'BundleProductFamily'; name?: string | null; slug?: string | null }
            | {
                __typename?: 'StandardProductFamily';
                manufacturerContact?: string | null;
                manufacturerContactEu?: string | null;
                name?: string | null;
                slug?: string | null;
                compatibilities?: Array<{
                  __typename?: 'ProductFamilyCompatibility';
                  family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
                  requirementAlternatives?: Array<{
                    __typename?: 'ProductFamilyCompatibilityRequirementAlternative';
                    requirements?: Array<{
                      __typename?: 'ProductFamilyCompatibilityRequirement';
                      family?: {
                        __typename?: 'StandardProductFamily';
                        name?: string | null;
                      } | null;
                      offer?:
                        | {
                            __typename?: 'CollapsibleOffer';
                            product?:
                              | { __typename?: 'BundleProduct'; slug?: string | null }
                              | { __typename?: 'StandardProduct'; slug?: string | null }
                              | null;
                          }
                        | {
                            __typename?: 'DefaultOffer';
                            product?:
                              | { __typename?: 'BundleProduct'; slug?: string | null }
                              | { __typename?: 'StandardProduct'; slug?: string | null }
                              | null;
                          }
                        | {
                            __typename?: 'ScopedOffer';
                            product?:
                              | { __typename?: 'BundleProduct'; slug?: string | null }
                              | { __typename?: 'StandardProduct'; slug?: string | null }
                              | null;
                          }
                        | null;
                    } | null> | null;
                  } | null> | null;
                } | null> | null;
                brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
                warranty?: {
                  __typename?: 'Warranty';
                  additionalCommercialGuarantee?: any | null;
                  repairabilityClass?: RepairabilityClass | null;
                  softwareUpdates?: string | null;
                } | null;
              }
            | null;
          features?: Array<{
            __typename?: 'Feature';
            name?: string | null;
            value?: string | null;
          } | null> | null;
          media?: Array<
            | {
                __typename?: 'LocalAttachment';
                mediaId?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | {
                __typename?: 'RemoteAttachment';
                url?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | null
          > | null;
          energyEfficiency?: {
            __typename?: 'EnergyEfficiency';
            class?: EnergyEfficiencyClass | null;
            labelImage?:
              | {
                  __typename?: 'LocalAttachment';
                  mediaId?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
            document?:
              | {
                  __typename?: 'LocalAttachment';
                  path?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
          } | null;
        } | null> | null;
        availability?: {
          __typename?: 'ProductAvailability';
          stock?: number | null;
          provider?: ProductProviderKey | null;
          deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
        } | null;
        family?:
          | {
              __typename?: 'BundleProductFamily';
              name?: string | null;
              slug?: string | null;
              categories?: Array<{
                __typename?: 'ProductCategory';
                categoryNumber?: string | null;
              } | null> | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
              rootCategories?: Array<{
                __typename?: 'ProductCategory';
                slug?: string | null;
              } | null> | null;
            }
          | {
              __typename?: 'StandardProductFamily';
              manufacturerContact?: string | null;
              manufacturerContactEu?: string | null;
              name?: string | null;
              slug?: string | null;
              brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
              compatibilities?: Array<{
                __typename?: 'ProductFamilyCompatibility';
                family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
                requirementAlternatives?: Array<{
                  __typename?: 'ProductFamilyCompatibilityRequirementAlternative';
                  requirements?: Array<{
                    __typename?: 'ProductFamilyCompatibilityRequirement';
                    family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
                    offer?:
                      | {
                          __typename?: 'CollapsibleOffer';
                          product?:
                            | { __typename?: 'BundleProduct'; slug?: string | null }
                            | { __typename?: 'StandardProduct'; slug?: string | null }
                            | null;
                        }
                      | {
                          __typename?: 'DefaultOffer';
                          product?:
                            | { __typename?: 'BundleProduct'; slug?: string | null }
                            | { __typename?: 'StandardProduct'; slug?: string | null }
                            | null;
                        }
                      | {
                          __typename?: 'ScopedOffer';
                          product?:
                            | { __typename?: 'BundleProduct'; slug?: string | null }
                            | { __typename?: 'StandardProduct'; slug?: string | null }
                            | null;
                        }
                      | null;
                  } | null> | null;
                } | null> | null;
              } | null> | null;
              warranty?: {
                __typename?: 'Warranty';
                additionalCommercialGuarantee?: any | null;
                repairabilityClass?: RepairabilityClass | null;
                softwareUpdates?: string | null;
              } | null;
              categories?: Array<{
                __typename?: 'ProductCategory';
                categoryNumber?: string | null;
              } | null> | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
              rootCategories?: Array<{
                __typename?: 'ProductCategory';
                slug?: string | null;
              } | null> | null;
            }
          | null;
      }
    | {
        __typename?: 'StandardProduct';
        description?: string | null;
        deliveredItems?: Array<string | null> | null;
        deliveryLeadTime?: string | null;
        model?: string | null;
        size?: string | null;
        variantName?: string | null;
        securityInformationUrl?: string | null;
        articleNumber?: string | null;
        eans?: Array<string | null> | null;
        bundle?: boolean | null;
        name?: string | null;
        slug?: string | null;
        legalTexts?: Array<string | null> | null;
        tags?: Array<string | null> | null;
        origin?: Origin | null;
        alwaysDisplayed?: boolean | null;
        usps?: Array<string | null> | null;
        externalLinks?: { __typename?: 'ExternalLinks'; oneShopUrl?: string | null } | null;
        brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
        color?: { __typename?: 'Color'; code?: any | null; name?: string | null } | null;
        storage?: {
          __typename?: 'MemorySize';
          value?: number | null;
          unit?: MemoryUnit | null;
        } | null;
        features?: Array<{
          __typename?: 'Feature';
          name?: string | null;
          value?: string | null;
        } | null> | null;
        commonCharger?: {
          __typename?: 'CommonCharger';
          included?: boolean | null;
          minWattage?: any | null;
          maxWattage?: any | null;
          possible?: boolean | null;
          usbPd?: boolean | null;
        } | null;
        availability?: {
          __typename?: 'ProductAvailability';
          stock?: number | null;
          provider?: ProductProviderKey | null;
          deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
        } | null;
        family?:
          | {
              __typename?: 'BundleProductFamily';
              name?: string | null;
              slug?: string | null;
              categories?: Array<{
                __typename?: 'ProductCategory';
                categoryNumber?: string | null;
              } | null> | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
              rootCategories?: Array<{
                __typename?: 'ProductCategory';
                slug?: string | null;
              } | null> | null;
            }
          | {
              __typename?: 'StandardProductFamily';
              manufacturerContact?: string | null;
              manufacturerContactEu?: string | null;
              name?: string | null;
              slug?: string | null;
              brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
              compatibilities?: Array<{
                __typename?: 'ProductFamilyCompatibility';
                family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
                requirementAlternatives?: Array<{
                  __typename?: 'ProductFamilyCompatibilityRequirementAlternative';
                  requirements?: Array<{
                    __typename?: 'ProductFamilyCompatibilityRequirement';
                    family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
                    offer?:
                      | {
                          __typename?: 'CollapsibleOffer';
                          product?:
                            | { __typename?: 'BundleProduct'; slug?: string | null }
                            | { __typename?: 'StandardProduct'; slug?: string | null }
                            | null;
                        }
                      | {
                          __typename?: 'DefaultOffer';
                          product?:
                            | { __typename?: 'BundleProduct'; slug?: string | null }
                            | { __typename?: 'StandardProduct'; slug?: string | null }
                            | null;
                        }
                      | {
                          __typename?: 'ScopedOffer';
                          product?:
                            | { __typename?: 'BundleProduct'; slug?: string | null }
                            | { __typename?: 'StandardProduct'; slug?: string | null }
                            | null;
                        }
                      | null;
                  } | null> | null;
                } | null> | null;
              } | null> | null;
              warranty?: {
                __typename?: 'Warranty';
                additionalCommercialGuarantee?: any | null;
                repairabilityClass?: RepairabilityClass | null;
                softwareUpdates?: string | null;
              } | null;
              categories?: Array<{
                __typename?: 'ProductCategory';
                categoryNumber?: string | null;
              } | null> | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
              rootCategories?: Array<{
                __typename?: 'ProductCategory';
                slug?: string | null;
              } | null> | null;
            }
          | null;
        energyEfficiency?: {
          __typename?: 'EnergyEfficiency';
          class?: EnergyEfficiencyClass | null;
          labelImage?:
            | {
                __typename?: 'LocalAttachment';
                mediaId?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | {
                __typename?: 'RemoteAttachment';
                url?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | null;
          document?:
            | {
                __typename?: 'LocalAttachment';
                path?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | {
                __typename?: 'RemoteAttachment';
                url?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | null;
        } | null;
      }
    | null;
  productAlternatives?: Array<{
    __typename?: 'ProductAlternativeItemGroup';
    position?: number | null;
    family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
    properties?: Array<{
      __typename?: 'ProductAlternativeSelectorGroup';
      key?: ProductSelectorField | null;
      alternatives?: Array<{
        __typename?: 'ProductAlternative';
        active?: boolean | null;
        exactMatch?: boolean | null;
        offer?: {
          __typename?: 'ScopedOffer';
          prices?: Array<{
            __typename?: 'Price';
            amount?: number | null;
            paymentFrequency?: PaymentFrequency | null;
            type?: PriceType | null;
            value?: any | null;
          } | null> | null;
          scopedProduct?: {
            __typename?: 'StandardProduct';
            size?: string | null;
            variantName?: string | null;
            name?: string | null;
            color?: {
              __typename?: 'Color';
              code?: any | null;
              name?: string | null;
              colorful?: boolean | null;
            } | null;
            storage?: {
              __typename?: 'MemorySize';
              unit?: MemoryUnit | null;
              value?: number | null;
            } | null;
            memory?: {
              __typename?: 'MemorySize';
              unit?: MemoryUnit | null;
              value?: number | null;
            } | null;
            energyEfficiency?: {
              __typename?: 'EnergyEfficiency';
              class?: EnergyEfficiencyClass | null;
              labelImage?:
                | {
                    __typename?: 'LocalAttachment';
                    mediaId?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
              document?:
                | {
                    __typename?: 'LocalAttachment';
                    path?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
            } | null;
          } | null;
          product?:
            | {
                __typename?: 'BundleProduct';
                articleNumber?: string | null;
                name?: string | null;
                slug?: string | null;
                availability?: {
                  __typename?: 'ProductAvailability';
                  stock?: number | null;
                  provider?: ProductProviderKey | null;
                  deliveryLeadTime?: {
                    __typename?: 'DeliveryLeadTime';
                    text?: string | null;
                  } | null;
                } | null;
                teaserImage?:
                  | {
                      __typename?: 'LocalAttachment';
                      mediaId?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
              }
            | {
                __typename?: 'StandardProduct';
                articleNumber?: string | null;
                name?: string | null;
                slug?: string | null;
                availability?: {
                  __typename?: 'ProductAvailability';
                  stock?: number | null;
                  provider?: ProductProviderKey | null;
                  deliveryLeadTime?: {
                    __typename?: 'DeliveryLeadTime';
                    text?: string | null;
                  } | null;
                } | null;
                teaserImage?:
                  | {
                      __typename?: 'LocalAttachment';
                      mediaId?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
              }
            | null;
        } | null;
      } | null> | null;
    } | null> | null;
  } | null> | null;
};

export type OfferDataFragment =
  | OfferData_CollapsibleOffer_Fragment
  | OfferData_DefaultOffer_Fragment
  | OfferData_ScopedOffer_Fragment;

type OfferListFields_CollapsibleOffer_Fragment = {
  __typename?: 'CollapsibleOffer';
  maxOrderableAmount?: number | null;
  updatedAt?: any | null;
  product?:
    | {
        __typename?: 'BundleProduct';
        articleNumber?: string | null;
        bundle?: boolean | null;
        name?: string | null;
        slug?: string | null;
        tags?: Array<string | null> | null;
        origin?: Origin | null;
        alwaysDisplayed?: boolean | null;
        deliveryLeadTime?: string | null;
        bundledProducts?: Array<{
          __typename?: 'StandardProduct';
          name?: string | null;
          tags?: Array<string | null> | null;
          family?:
            | { __typename?: 'BundleProductFamily'; name?: string | null }
            | {
                __typename?: 'StandardProductFamily';
                name?: string | null;
                brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
              }
            | null;
          teaserImage?:
            | {
                __typename?: 'LocalAttachment';
                mediaId?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | {
                __typename?: 'RemoteAttachment';
                url?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | null;
          energyEfficiency?: {
            __typename?: 'EnergyEfficiency';
            class?: EnergyEfficiencyClass | null;
            labelImage?:
              | {
                  __typename?: 'LocalAttachment';
                  mediaId?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
            document?:
              | {
                  __typename?: 'LocalAttachment';
                  path?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
          } | null;
        } | null> | null;
        availability?: {
          __typename?: 'ProductAvailability';
          stock?: number | null;
          provider?: ProductProviderKey | null;
          deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
        } | null;
        family?:
          | {
              __typename?: 'BundleProductFamily';
              name?: string | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
            }
          | {
              __typename?: 'StandardProductFamily';
              name?: string | null;
              brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
            }
          | null;
      }
    | {
        __typename?: 'StandardProduct';
        articleNumber?: string | null;
        bundle?: boolean | null;
        name?: string | null;
        slug?: string | null;
        tags?: Array<string | null> | null;
        origin?: Origin | null;
        alwaysDisplayed?: boolean | null;
        deliveryLeadTime?: string | null;
        externalLinks?: { __typename?: 'ExternalLinks'; oneShopUrl?: string | null } | null;
        availability?: {
          __typename?: 'ProductAvailability';
          stock?: number | null;
          provider?: ProductProviderKey | null;
          deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
        } | null;
        family?:
          | {
              __typename?: 'BundleProductFamily';
              name?: string | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
            }
          | {
              __typename?: 'StandardProductFamily';
              name?: string | null;
              brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
            }
          | null;
        energyEfficiency?: {
          __typename?: 'EnergyEfficiency';
          class?: EnergyEfficiencyClass | null;
          labelImage?:
            | {
                __typename?: 'LocalAttachment';
                mediaId?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | {
                __typename?: 'RemoteAttachment';
                url?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | null;
          document?:
            | {
                __typename?: 'LocalAttachment';
                path?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | {
                __typename?: 'RemoteAttachment';
                url?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | null;
        } | null;
      }
    | null;
  media?: Array<
    | {
        __typename?: 'LocalAttachment';
        mediaId?: string | null;
        type?: AttachmentType | null;
        name?: string | null;
        remote?: boolean | null;
      }
    | {
        __typename?: 'RemoteAttachment';
        url?: string | null;
        type?: AttachmentType | null;
        name?: string | null;
        remote?: boolean | null;
      }
    | null
  > | null;
  teaserImage?:
    | {
        __typename?: 'LocalAttachment';
        mediaId?: string | null;
        type?: AttachmentType | null;
        name?: string | null;
        remote?: boolean | null;
      }
    | {
        __typename?: 'RemoteAttachment';
        url?: string | null;
        type?: AttachmentType | null;
        name?: string | null;
        remote?: boolean | null;
      }
    | null;
  prices?: Array<{
    __typename?: 'Price';
    amount?: number | null;
    currency?: string | null;
    paymentFrequency?: PaymentFrequency | null;
    type?: PriceType | null;
    value?: any | null;
  } | null> | null;
  productAlternatives?: Array<{
    __typename?: 'ProductAlternativeItemGroup';
    position?: number | null;
    family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
    properties?: Array<{
      __typename?: 'ProductAlternativeSelectorGroup';
      key?: ProductSelectorField | null;
      alternatives?: Array<{
        __typename?: 'ProductAlternative';
        active?: boolean | null;
        exactMatch?: boolean | null;
        offer?: {
          __typename?: 'ScopedOffer';
          prices?: Array<{
            __typename?: 'Price';
            amount?: number | null;
            paymentFrequency?: PaymentFrequency | null;
            type?: PriceType | null;
            value?: any | null;
          } | null> | null;
          scopedProduct?: {
            __typename?: 'StandardProduct';
            size?: string | null;
            variantName?: string | null;
            name?: string | null;
            color?: {
              __typename?: 'Color';
              code?: any | null;
              name?: string | null;
              colorful?: boolean | null;
            } | null;
            storage?: {
              __typename?: 'MemorySize';
              unit?: MemoryUnit | null;
              value?: number | null;
            } | null;
            memory?: {
              __typename?: 'MemorySize';
              unit?: MemoryUnit | null;
              value?: number | null;
            } | null;
            energyEfficiency?: {
              __typename?: 'EnergyEfficiency';
              class?: EnergyEfficiencyClass | null;
              labelImage?:
                | {
                    __typename?: 'LocalAttachment';
                    mediaId?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
              document?:
                | {
                    __typename?: 'LocalAttachment';
                    path?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
            } | null;
          } | null;
          product?:
            | {
                __typename?: 'BundleProduct';
                articleNumber?: string | null;
                name?: string | null;
                slug?: string | null;
                availability?: {
                  __typename?: 'ProductAvailability';
                  stock?: number | null;
                  provider?: ProductProviderKey | null;
                  deliveryLeadTime?: {
                    __typename?: 'DeliveryLeadTime';
                    text?: string | null;
                  } | null;
                } | null;
                teaserImage?:
                  | {
                      __typename?: 'LocalAttachment';
                      mediaId?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
              }
            | {
                __typename?: 'StandardProduct';
                articleNumber?: string | null;
                name?: string | null;
                slug?: string | null;
                availability?: {
                  __typename?: 'ProductAvailability';
                  stock?: number | null;
                  provider?: ProductProviderKey | null;
                  deliveryLeadTime?: {
                    __typename?: 'DeliveryLeadTime';
                    text?: string | null;
                  } | null;
                } | null;
                teaserImage?:
                  | {
                      __typename?: 'LocalAttachment';
                      mediaId?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
              }
            | null;
        } | null;
      } | null> | null;
    } | null> | null;
  } | null> | null;
};

type OfferListFields_DefaultOffer_Fragment = {
  __typename?: 'DefaultOffer';
  maxOrderableAmount?: number | null;
  updatedAt?: any | null;
  product?:
    | {
        __typename?: 'BundleProduct';
        articleNumber?: string | null;
        bundle?: boolean | null;
        name?: string | null;
        slug?: string | null;
        tags?: Array<string | null> | null;
        origin?: Origin | null;
        alwaysDisplayed?: boolean | null;
        deliveryLeadTime?: string | null;
        bundledProducts?: Array<{
          __typename?: 'StandardProduct';
          name?: string | null;
          tags?: Array<string | null> | null;
          family?:
            | { __typename?: 'BundleProductFamily'; name?: string | null }
            | {
                __typename?: 'StandardProductFamily';
                name?: string | null;
                brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
              }
            | null;
          teaserImage?:
            | {
                __typename?: 'LocalAttachment';
                mediaId?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | {
                __typename?: 'RemoteAttachment';
                url?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | null;
          energyEfficiency?: {
            __typename?: 'EnergyEfficiency';
            class?: EnergyEfficiencyClass | null;
            labelImage?:
              | {
                  __typename?: 'LocalAttachment';
                  mediaId?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
            document?:
              | {
                  __typename?: 'LocalAttachment';
                  path?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
          } | null;
        } | null> | null;
        availability?: {
          __typename?: 'ProductAvailability';
          stock?: number | null;
          provider?: ProductProviderKey | null;
          deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
        } | null;
        family?:
          | {
              __typename?: 'BundleProductFamily';
              name?: string | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
            }
          | {
              __typename?: 'StandardProductFamily';
              name?: string | null;
              brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
            }
          | null;
      }
    | {
        __typename?: 'StandardProduct';
        articleNumber?: string | null;
        bundle?: boolean | null;
        name?: string | null;
        slug?: string | null;
        tags?: Array<string | null> | null;
        origin?: Origin | null;
        alwaysDisplayed?: boolean | null;
        deliveryLeadTime?: string | null;
        externalLinks?: { __typename?: 'ExternalLinks'; oneShopUrl?: string | null } | null;
        availability?: {
          __typename?: 'ProductAvailability';
          stock?: number | null;
          provider?: ProductProviderKey | null;
          deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
        } | null;
        family?:
          | {
              __typename?: 'BundleProductFamily';
              name?: string | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
            }
          | {
              __typename?: 'StandardProductFamily';
              name?: string | null;
              brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
            }
          | null;
        energyEfficiency?: {
          __typename?: 'EnergyEfficiency';
          class?: EnergyEfficiencyClass | null;
          labelImage?:
            | {
                __typename?: 'LocalAttachment';
                mediaId?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | {
                __typename?: 'RemoteAttachment';
                url?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | null;
          document?:
            | {
                __typename?: 'LocalAttachment';
                path?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | {
                __typename?: 'RemoteAttachment';
                url?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | null;
        } | null;
      }
    | null;
  media?: Array<
    | {
        __typename?: 'LocalAttachment';
        mediaId?: string | null;
        type?: AttachmentType | null;
        name?: string | null;
        remote?: boolean | null;
      }
    | {
        __typename?: 'RemoteAttachment';
        url?: string | null;
        type?: AttachmentType | null;
        name?: string | null;
        remote?: boolean | null;
      }
    | null
  > | null;
  teaserImage?:
    | {
        __typename?: 'LocalAttachment';
        mediaId?: string | null;
        type?: AttachmentType | null;
        name?: string | null;
        remote?: boolean | null;
      }
    | {
        __typename?: 'RemoteAttachment';
        url?: string | null;
        type?: AttachmentType | null;
        name?: string | null;
        remote?: boolean | null;
      }
    | null;
  prices?: Array<{
    __typename?: 'Price';
    amount?: number | null;
    currency?: string | null;
    paymentFrequency?: PaymentFrequency | null;
    type?: PriceType | null;
    value?: any | null;
  } | null> | null;
  productAlternatives?: Array<{
    __typename?: 'ProductAlternativeItemGroup';
    position?: number | null;
    family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
    properties?: Array<{
      __typename?: 'ProductAlternativeSelectorGroup';
      key?: ProductSelectorField | null;
      alternatives?: Array<{
        __typename?: 'ProductAlternative';
        active?: boolean | null;
        exactMatch?: boolean | null;
        offer?: {
          __typename?: 'ScopedOffer';
          prices?: Array<{
            __typename?: 'Price';
            amount?: number | null;
            paymentFrequency?: PaymentFrequency | null;
            type?: PriceType | null;
            value?: any | null;
          } | null> | null;
          scopedProduct?: {
            __typename?: 'StandardProduct';
            size?: string | null;
            variantName?: string | null;
            name?: string | null;
            color?: {
              __typename?: 'Color';
              code?: any | null;
              name?: string | null;
              colorful?: boolean | null;
            } | null;
            storage?: {
              __typename?: 'MemorySize';
              unit?: MemoryUnit | null;
              value?: number | null;
            } | null;
            memory?: {
              __typename?: 'MemorySize';
              unit?: MemoryUnit | null;
              value?: number | null;
            } | null;
            energyEfficiency?: {
              __typename?: 'EnergyEfficiency';
              class?: EnergyEfficiencyClass | null;
              labelImage?:
                | {
                    __typename?: 'LocalAttachment';
                    mediaId?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
              document?:
                | {
                    __typename?: 'LocalAttachment';
                    path?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
            } | null;
          } | null;
          product?:
            | {
                __typename?: 'BundleProduct';
                articleNumber?: string | null;
                name?: string | null;
                slug?: string | null;
                availability?: {
                  __typename?: 'ProductAvailability';
                  stock?: number | null;
                  provider?: ProductProviderKey | null;
                  deliveryLeadTime?: {
                    __typename?: 'DeliveryLeadTime';
                    text?: string | null;
                  } | null;
                } | null;
                teaserImage?:
                  | {
                      __typename?: 'LocalAttachment';
                      mediaId?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
              }
            | {
                __typename?: 'StandardProduct';
                articleNumber?: string | null;
                name?: string | null;
                slug?: string | null;
                availability?: {
                  __typename?: 'ProductAvailability';
                  stock?: number | null;
                  provider?: ProductProviderKey | null;
                  deliveryLeadTime?: {
                    __typename?: 'DeliveryLeadTime';
                    text?: string | null;
                  } | null;
                } | null;
                teaserImage?:
                  | {
                      __typename?: 'LocalAttachment';
                      mediaId?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
              }
            | null;
        } | null;
      } | null> | null;
    } | null> | null;
  } | null> | null;
};

type OfferListFields_ScopedOffer_Fragment = {
  __typename?: 'ScopedOffer';
  maxOrderableAmount?: number | null;
  updatedAt?: any | null;
  product?:
    | {
        __typename?: 'BundleProduct';
        articleNumber?: string | null;
        bundle?: boolean | null;
        name?: string | null;
        slug?: string | null;
        tags?: Array<string | null> | null;
        origin?: Origin | null;
        alwaysDisplayed?: boolean | null;
        deliveryLeadTime?: string | null;
        bundledProducts?: Array<{
          __typename?: 'StandardProduct';
          name?: string | null;
          tags?: Array<string | null> | null;
          family?:
            | { __typename?: 'BundleProductFamily'; name?: string | null }
            | {
                __typename?: 'StandardProductFamily';
                name?: string | null;
                brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
              }
            | null;
          teaserImage?:
            | {
                __typename?: 'LocalAttachment';
                mediaId?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | {
                __typename?: 'RemoteAttachment';
                url?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | null;
          energyEfficiency?: {
            __typename?: 'EnergyEfficiency';
            class?: EnergyEfficiencyClass | null;
            labelImage?:
              | {
                  __typename?: 'LocalAttachment';
                  mediaId?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
            document?:
              | {
                  __typename?: 'LocalAttachment';
                  path?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
          } | null;
        } | null> | null;
        availability?: {
          __typename?: 'ProductAvailability';
          stock?: number | null;
          provider?: ProductProviderKey | null;
          deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
        } | null;
        family?:
          | {
              __typename?: 'BundleProductFamily';
              name?: string | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
            }
          | {
              __typename?: 'StandardProductFamily';
              name?: string | null;
              brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
            }
          | null;
      }
    | {
        __typename?: 'StandardProduct';
        articleNumber?: string | null;
        bundle?: boolean | null;
        name?: string | null;
        slug?: string | null;
        tags?: Array<string | null> | null;
        origin?: Origin | null;
        alwaysDisplayed?: boolean | null;
        deliveryLeadTime?: string | null;
        externalLinks?: { __typename?: 'ExternalLinks'; oneShopUrl?: string | null } | null;
        availability?: {
          __typename?: 'ProductAvailability';
          stock?: number | null;
          provider?: ProductProviderKey | null;
          deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
        } | null;
        family?:
          | {
              __typename?: 'BundleProductFamily';
              name?: string | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
            }
          | {
              __typename?: 'StandardProductFamily';
              name?: string | null;
              brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
              primaryCategory?: {
                __typename?: 'ProductCategory';
                name?: string | null;
                path?: string | null;
                ancestors?: Array<{
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                } | null> | null;
              } | null;
            }
          | null;
        energyEfficiency?: {
          __typename?: 'EnergyEfficiency';
          class?: EnergyEfficiencyClass | null;
          labelImage?:
            | {
                __typename?: 'LocalAttachment';
                mediaId?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | {
                __typename?: 'RemoteAttachment';
                url?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | null;
          document?:
            | {
                __typename?: 'LocalAttachment';
                path?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | {
                __typename?: 'RemoteAttachment';
                url?: string | null;
                type?: AttachmentType | null;
                name?: string | null;
                remote?: boolean | null;
              }
            | null;
        } | null;
      }
    | null;
  media?: Array<
    | {
        __typename?: 'LocalAttachment';
        mediaId?: string | null;
        type?: AttachmentType | null;
        name?: string | null;
        remote?: boolean | null;
      }
    | {
        __typename?: 'RemoteAttachment';
        url?: string | null;
        type?: AttachmentType | null;
        name?: string | null;
        remote?: boolean | null;
      }
    | null
  > | null;
  teaserImage?:
    | {
        __typename?: 'LocalAttachment';
        mediaId?: string | null;
        type?: AttachmentType | null;
        name?: string | null;
        remote?: boolean | null;
      }
    | {
        __typename?: 'RemoteAttachment';
        url?: string | null;
        type?: AttachmentType | null;
        name?: string | null;
        remote?: boolean | null;
      }
    | null;
  prices?: Array<{
    __typename?: 'Price';
    amount?: number | null;
    currency?: string | null;
    paymentFrequency?: PaymentFrequency | null;
    type?: PriceType | null;
    value?: any | null;
  } | null> | null;
  productAlternatives?: Array<{
    __typename?: 'ProductAlternativeItemGroup';
    position?: number | null;
    family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
    properties?: Array<{
      __typename?: 'ProductAlternativeSelectorGroup';
      key?: ProductSelectorField | null;
      alternatives?: Array<{
        __typename?: 'ProductAlternative';
        active?: boolean | null;
        exactMatch?: boolean | null;
        offer?: {
          __typename?: 'ScopedOffer';
          prices?: Array<{
            __typename?: 'Price';
            amount?: number | null;
            paymentFrequency?: PaymentFrequency | null;
            type?: PriceType | null;
            value?: any | null;
          } | null> | null;
          scopedProduct?: {
            __typename?: 'StandardProduct';
            size?: string | null;
            variantName?: string | null;
            name?: string | null;
            color?: {
              __typename?: 'Color';
              code?: any | null;
              name?: string | null;
              colorful?: boolean | null;
            } | null;
            storage?: {
              __typename?: 'MemorySize';
              unit?: MemoryUnit | null;
              value?: number | null;
            } | null;
            memory?: {
              __typename?: 'MemorySize';
              unit?: MemoryUnit | null;
              value?: number | null;
            } | null;
            energyEfficiency?: {
              __typename?: 'EnergyEfficiency';
              class?: EnergyEfficiencyClass | null;
              labelImage?:
                | {
                    __typename?: 'LocalAttachment';
                    mediaId?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
              document?:
                | {
                    __typename?: 'LocalAttachment';
                    path?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
            } | null;
          } | null;
          product?:
            | {
                __typename?: 'BundleProduct';
                articleNumber?: string | null;
                name?: string | null;
                slug?: string | null;
                availability?: {
                  __typename?: 'ProductAvailability';
                  stock?: number | null;
                  provider?: ProductProviderKey | null;
                  deliveryLeadTime?: {
                    __typename?: 'DeliveryLeadTime';
                    text?: string | null;
                  } | null;
                } | null;
                teaserImage?:
                  | {
                      __typename?: 'LocalAttachment';
                      mediaId?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
              }
            | {
                __typename?: 'StandardProduct';
                articleNumber?: string | null;
                name?: string | null;
                slug?: string | null;
                availability?: {
                  __typename?: 'ProductAvailability';
                  stock?: number | null;
                  provider?: ProductProviderKey | null;
                  deliveryLeadTime?: {
                    __typename?: 'DeliveryLeadTime';
                    text?: string | null;
                  } | null;
                } | null;
                teaserImage?:
                  | {
                      __typename?: 'LocalAttachment';
                      mediaId?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
              }
            | null;
        } | null;
      } | null> | null;
    } | null> | null;
  } | null> | null;
};

export type OfferListFieldsFragment =
  | OfferListFields_CollapsibleOffer_Fragment
  | OfferListFields_DefaultOffer_Fragment
  | OfferListFields_ScopedOffer_Fragment;

export type ProductAlternativeOfferFragment = {
  __typename?: 'ScopedOffer';
  prices?: Array<{
    __typename?: 'Price';
    amount?: number | null;
    paymentFrequency?: PaymentFrequency | null;
    type?: PriceType | null;
    value?: any | null;
  } | null> | null;
  scopedProduct?: {
    __typename?: 'StandardProduct';
    size?: string | null;
    variantName?: string | null;
    name?: string | null;
    color?: {
      __typename?: 'Color';
      code?: any | null;
      name?: string | null;
      colorful?: boolean | null;
    } | null;
    storage?: { __typename?: 'MemorySize'; unit?: MemoryUnit | null; value?: number | null } | null;
    memory?: { __typename?: 'MemorySize'; unit?: MemoryUnit | null; value?: number | null } | null;
    energyEfficiency?: {
      __typename?: 'EnergyEfficiency';
      class?: EnergyEfficiencyClass | null;
      labelImage?:
        | {
            __typename?: 'LocalAttachment';
            mediaId?: string | null;
            type?: AttachmentType | null;
            name?: string | null;
            remote?: boolean | null;
          }
        | {
            __typename?: 'RemoteAttachment';
            url?: string | null;
            type?: AttachmentType | null;
            name?: string | null;
            remote?: boolean | null;
          }
        | null;
      document?:
        | {
            __typename?: 'LocalAttachment';
            path?: string | null;
            type?: AttachmentType | null;
            name?: string | null;
            remote?: boolean | null;
          }
        | {
            __typename?: 'RemoteAttachment';
            url?: string | null;
            type?: AttachmentType | null;
            name?: string | null;
            remote?: boolean | null;
          }
        | null;
    } | null;
  } | null;
  product?:
    | {
        __typename?: 'BundleProduct';
        articleNumber?: string | null;
        name?: string | null;
        slug?: string | null;
        availability?: {
          __typename?: 'ProductAvailability';
          stock?: number | null;
          provider?: ProductProviderKey | null;
          deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
        } | null;
        teaserImage?:
          | {
              __typename?: 'LocalAttachment';
              mediaId?: string | null;
              type?: AttachmentType | null;
              name?: string | null;
              remote?: boolean | null;
            }
          | {
              __typename?: 'RemoteAttachment';
              url?: string | null;
              type?: AttachmentType | null;
              name?: string | null;
              remote?: boolean | null;
            }
          | null;
      }
    | {
        __typename?: 'StandardProduct';
        articleNumber?: string | null;
        name?: string | null;
        slug?: string | null;
        availability?: {
          __typename?: 'ProductAvailability';
          stock?: number | null;
          provider?: ProductProviderKey | null;
          deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
        } | null;
        teaserImage?:
          | {
              __typename?: 'LocalAttachment';
              mediaId?: string | null;
              type?: AttachmentType | null;
              name?: string | null;
              remote?: boolean | null;
            }
          | {
              __typename?: 'RemoteAttachment';
              url?: string | null;
              type?: AttachmentType | null;
              name?: string | null;
              remote?: boolean | null;
            }
          | null;
      }
    | null;
};

export type ProductAlternativeFragment = {
  __typename?: 'ProductAlternativeItemGroup';
  position?: number | null;
  family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
  properties?: Array<{
    __typename?: 'ProductAlternativeSelectorGroup';
    key?: ProductSelectorField | null;
    alternatives?: Array<{
      __typename?: 'ProductAlternative';
      active?: boolean | null;
      exactMatch?: boolean | null;
      offer?: {
        __typename?: 'ScopedOffer';
        prices?: Array<{
          __typename?: 'Price';
          amount?: number | null;
          paymentFrequency?: PaymentFrequency | null;
          type?: PriceType | null;
          value?: any | null;
        } | null> | null;
        scopedProduct?: {
          __typename?: 'StandardProduct';
          size?: string | null;
          variantName?: string | null;
          name?: string | null;
          color?: {
            __typename?: 'Color';
            code?: any | null;
            name?: string | null;
            colorful?: boolean | null;
          } | null;
          storage?: {
            __typename?: 'MemorySize';
            unit?: MemoryUnit | null;
            value?: number | null;
          } | null;
          memory?: {
            __typename?: 'MemorySize';
            unit?: MemoryUnit | null;
            value?: number | null;
          } | null;
          energyEfficiency?: {
            __typename?: 'EnergyEfficiency';
            class?: EnergyEfficiencyClass | null;
            labelImage?:
              | {
                  __typename?: 'LocalAttachment';
                  mediaId?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
            document?:
              | {
                  __typename?: 'LocalAttachment';
                  path?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
          } | null;
        } | null;
        product?:
          | {
              __typename?: 'BundleProduct';
              articleNumber?: string | null;
              name?: string | null;
              slug?: string | null;
              availability?: {
                __typename?: 'ProductAvailability';
                stock?: number | null;
                provider?: ProductProviderKey | null;
                deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
              } | null;
              teaserImage?:
                | {
                    __typename?: 'LocalAttachment';
                    mediaId?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
            }
          | {
              __typename?: 'StandardProduct';
              articleNumber?: string | null;
              name?: string | null;
              slug?: string | null;
              availability?: {
                __typename?: 'ProductAvailability';
                stock?: number | null;
                provider?: ProductProviderKey | null;
                deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
              } | null;
              teaserImage?:
                | {
                    __typename?: 'LocalAttachment';
                    mediaId?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
            }
          | null;
      } | null;
    } | null> | null;
  } | null> | null;
};

export type BrandAggregationQueryVariables = Exact<{
  filter?: InputMaybe<OfferFilterParams>;
  grouped?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<OfferSortParams>;
  pagination?: InputMaybe<PaginationParams>;
  search?: InputMaybe<Scalars['String']['input']>;
  validAt?: InputMaybe<Scalars['DateTime']['input']>;
  complexSearch?: InputMaybe<OfferSearchParams>;
}>;

export type BrandAggregationQuery = {
  __typename?: 'Query';
  offers?: {
    __typename?: 'Offers';
    variantsCount?: number | null;
    aggregations?: {
      __typename?: 'OfferAggregations';
      brands?: Array<{
        __typename?: 'OfferBrandAggregation';
        offersCount?: number | null;
        brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type CompaProductsQueryVariables = Exact<{
  filter?: InputMaybe<KompaProductFilterParams>;
  pagination?: InputMaybe<PaginationParams>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;

export type CompaProductsQuery = {
  __typename?: 'Query';
  kompaProducts?: {
    __typename?: 'KompaProducts';
    entries?: Array<{
      __typename?: 'KompaProduct';
      eanList?: Array<string | null> | null;
    } | null> | null;
  } | null;
};

export type DatafeedQueryVariables = Exact<{
  filter?: InputMaybe<OfferFilterParams>;
  grouped?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<OfferSortParams>;
  pagination?: InputMaybe<PaginationParams>;
  search?: InputMaybe<Scalars['String']['input']>;
  validAt?: InputMaybe<Scalars['DateTime']['input']>;
}>;

export type DatafeedQuery = {
  __typename?: 'Query';
  offers?: {
    __typename?: 'Offers';
    pagination?: {
      __typename?: 'Pagination';
      page?: number | null;
      size?: number | null;
      totalCount?: number | null;
      totalPages?: number | null;
    } | null;
    sort?: {
      __typename?: 'OfferSort';
      direction?: SortDirection | null;
      field?: OfferSortField | null;
    } | null;
    entries?: Array<{
      __typename?: 'CollapsibleOffer';
      usps?: Array<string | null> | null;
      product?:
        | {
            __typename?: 'BundleProduct';
            articleNumber?: string | null;
            eans?: Array<string | null> | null;
            bundle?: boolean | null;
            name?: string | null;
            slug?: string | null;
            description?: string | null;
            legalTexts?: Array<string | null> | null;
            deliveryLeadTime?: string | null;
            availability?: { __typename?: 'ProductAvailability'; stock?: number | null } | null;
            family?:
              | {
                  __typename?: 'BundleProductFamily';
                  name?: string | null;
                  slug?: string | null;
                  primaryCategory?: {
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                    ancestors?: Array<{
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                    } | null> | null;
                  } | null;
                }
              | {
                  __typename?: 'StandardProductFamily';
                  name?: string | null;
                  slug?: string | null;
                  brand?: {
                    __typename?: 'Brand';
                    name?: string | null;
                    slug?: string | null;
                  } | null;
                  primaryCategory?: {
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                    ancestors?: Array<{
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                    } | null> | null;
                  } | null;
                }
              | null;
          }
        | {
            __typename?: 'StandardProduct';
            articleNumber?: string | null;
            eans?: Array<string | null> | null;
            bundle?: boolean | null;
            name?: string | null;
            slug?: string | null;
            description?: string | null;
            legalTexts?: Array<string | null> | null;
            deliveryLeadTime?: string | null;
            color?: { __typename?: 'Color'; name?: string | null } | null;
            availability?: { __typename?: 'ProductAvailability'; stock?: number | null } | null;
            family?:
              | {
                  __typename?: 'BundleProductFamily';
                  name?: string | null;
                  slug?: string | null;
                  primaryCategory?: {
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                    ancestors?: Array<{
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                    } | null> | null;
                  } | null;
                }
              | {
                  __typename?: 'StandardProductFamily';
                  name?: string | null;
                  slug?: string | null;
                  brand?: {
                    __typename?: 'Brand';
                    name?: string | null;
                    slug?: string | null;
                  } | null;
                  primaryCategory?: {
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                    ancestors?: Array<{
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                    } | null> | null;
                  } | null;
                }
              | null;
            energyEfficiency?: {
              __typename?: 'EnergyEfficiency';
              class?: EnergyEfficiencyClass | null;
              labelImage?:
                | {
                    __typename?: 'LocalAttachment';
                    mediaId?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
              document?:
                | {
                    __typename?: 'LocalAttachment';
                    path?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
            } | null;
          }
        | null;
      teaserImage?:
        | {
            __typename?: 'LocalAttachment';
            sources?: Array<{
              __typename?: 'MediaSource';
              path?: string | null;
              mime?: string | null;
            } | null> | null;
          }
        | {
            __typename?: 'RemoteAttachment';
            sources?: Array<{
              __typename?: 'MediaSource';
              path?: string | null;
              mime?: string | null;
            } | null> | null;
          }
        | null;
      onetimePrice?: {
        __typename?: 'Price';
        amount?: number | null;
        currency?: string | null;
        paymentFrequency?: PaymentFrequency | null;
        type?: PriceType | null;
        value?: any | null;
      } | null;
      prices?: Array<{
        __typename?: 'Price';
        amount?: number | null;
        currency?: string | null;
        paymentFrequency?: PaymentFrequency | null;
        type?: PriceType | null;
        value?: any | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type ListQueryVariables = Exact<{
  filter?: InputMaybe<OfferFilterParams>;
  grouped?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<OfferSortParams>;
  pagination?: InputMaybe<PaginationParams>;
  search?: InputMaybe<Scalars['String']['input']>;
  validAt?: InputMaybe<Scalars['DateTime']['input']>;
  complexSearch?: InputMaybe<OfferSearchParams>;
  includeAggregations?: InputMaybe<Scalars['Boolean']['input']>;
  includeProductOfferData?: InputMaybe<Scalars['Boolean']['input']>;
}>;

export type ListQuery = {
  __typename?: 'Query';
  offers?: {
    __typename?: 'Offers';
    variantsCount?: number | null;
    entries?: Array<{
      __typename?: 'CollapsibleOffer';
      updatedAt?: any | null;
      usps?: Array<string | null> | null;
      maxOrderableAmount?: number | null;
      summaryTexts?: Array<string | null> | null;
      onetimePriceRange?: {
        __typename?: 'PriceRange';
        equal?: boolean | null;
        min?: {
          __typename?: 'Price';
          amount?: number | null;
          currency?: string | null;
          paymentFrequency?: PaymentFrequency | null;
          type?: PriceType | null;
          value?: any | null;
        } | null;
      } | null;
      product?:
        | {
            __typename?: 'BundleProduct';
            description?: string | null;
            articleNumber?: string | null;
            bundle?: boolean | null;
            name?: string | null;
            slug?: string | null;
            tags?: Array<string | null> | null;
            origin?: Origin | null;
            alwaysDisplayed?: boolean | null;
            deliveryLeadTime?: string | null;
            eans?: Array<string | null> | null;
            legalTexts?: Array<string | null> | null;
            usps?: Array<string | null> | null;
            bundledProducts?: Array<{
              __typename?: 'StandardProduct';
              securityInformationUrl?: string | null;
              name?: string | null;
              tags?: Array<string | null> | null;
              articleNumber?: string | null;
              eans?: Array<string | null> | null;
              description?: string | null;
              slug?: string | null;
              usps?: Array<string | null> | null;
              deliveredItems?: Array<string | null> | null;
              origin?: Origin | null;
              commonCharger?: {
                __typename?: 'CommonCharger';
                included?: boolean | null;
                minWattage?: any | null;
                maxWattage?: any | null;
                possible?: boolean | null;
                usbPd?: boolean | null;
              } | null;
              family?:
                | { __typename?: 'BundleProductFamily'; name?: string | null; slug?: string | null }
                | {
                    __typename?: 'StandardProductFamily';
                    manufacturerContact?: string | null;
                    manufacturerContactEu?: string | null;
                    name?: string | null;
                    slug?: string | null;
                    brand?: {
                      __typename?: 'Brand';
                      name?: string | null;
                      slug?: string | null;
                    } | null;
                    compatibilities?: Array<{
                      __typename?: 'ProductFamilyCompatibility';
                      family?: {
                        __typename?: 'StandardProductFamily';
                        name?: string | null;
                      } | null;
                      requirementAlternatives?: Array<{
                        __typename?: 'ProductFamilyCompatibilityRequirementAlternative';
                        requirements?: Array<{
                          __typename?: 'ProductFamilyCompatibilityRequirement';
                          family?: {
                            __typename?: 'StandardProductFamily';
                            name?: string | null;
                          } | null;
                          offer?:
                            | {
                                __typename?: 'CollapsibleOffer';
                                product?:
                                  | { __typename?: 'BundleProduct'; slug?: string | null }
                                  | { __typename?: 'StandardProduct'; slug?: string | null }
                                  | null;
                              }
                            | {
                                __typename?: 'DefaultOffer';
                                product?:
                                  | { __typename?: 'BundleProduct'; slug?: string | null }
                                  | { __typename?: 'StandardProduct'; slug?: string | null }
                                  | null;
                              }
                            | {
                                __typename?: 'ScopedOffer';
                                product?:
                                  | { __typename?: 'BundleProduct'; slug?: string | null }
                                  | { __typename?: 'StandardProduct'; slug?: string | null }
                                  | null;
                              }
                            | null;
                        } | null> | null;
                      } | null> | null;
                    } | null> | null;
                    warranty?: {
                      __typename?: 'Warranty';
                      additionalCommercialGuarantee?: any | null;
                      repairabilityClass?: RepairabilityClass | null;
                      softwareUpdates?: string | null;
                    } | null;
                  }
                | null;
              teaserImage?:
                | {
                    __typename?: 'LocalAttachment';
                    mediaId?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
              features?: Array<{
                __typename?: 'Feature';
                name?: string | null;
                value?: string | null;
              } | null> | null;
              media?: Array<
                | {
                    __typename?: 'LocalAttachment';
                    mediaId?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null
              > | null;
              energyEfficiency?: {
                __typename?: 'EnergyEfficiency';
                class?: EnergyEfficiencyClass | null;
                labelImage?:
                  | {
                      __typename?: 'LocalAttachment';
                      mediaId?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
                document?:
                  | {
                      __typename?: 'LocalAttachment';
                      path?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
              } | null;
            } | null> | null;
            availability?: {
              __typename?: 'ProductAvailability';
              stock?: number | null;
              provider?: ProductProviderKey | null;
              deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
            } | null;
            family?:
              | {
                  __typename?: 'BundleProductFamily';
                  name?: string | null;
                  slug?: string | null;
                  primaryCategory?: {
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                    ancestors?: Array<{
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                    } | null> | null;
                  } | null;
                  categories?: Array<{
                    __typename?: 'ProductCategory';
                    categoryNumber?: string | null;
                  } | null> | null;
                  rootCategories?: Array<{
                    __typename?: 'ProductCategory';
                    slug?: string | null;
                  } | null> | null;
                }
              | {
                  __typename?: 'StandardProductFamily';
                  manufacturerContact?: string | null;
                  manufacturerContactEu?: string | null;
                  name?: string | null;
                  slug?: string | null;
                  brand?: {
                    __typename?: 'Brand';
                    name?: string | null;
                    slug?: string | null;
                  } | null;
                  compatibilities?: Array<{
                    __typename?: 'ProductFamilyCompatibility';
                    family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
                    requirementAlternatives?: Array<{
                      __typename?: 'ProductFamilyCompatibilityRequirementAlternative';
                      requirements?: Array<{
                        __typename?: 'ProductFamilyCompatibilityRequirement';
                        family?: {
                          __typename?: 'StandardProductFamily';
                          name?: string | null;
                        } | null;
                        offer?:
                          | {
                              __typename?: 'CollapsibleOffer';
                              product?:
                                | { __typename?: 'BundleProduct'; slug?: string | null }
                                | { __typename?: 'StandardProduct'; slug?: string | null }
                                | null;
                            }
                          | {
                              __typename?: 'DefaultOffer';
                              product?:
                                | { __typename?: 'BundleProduct'; slug?: string | null }
                                | { __typename?: 'StandardProduct'; slug?: string | null }
                                | null;
                            }
                          | {
                              __typename?: 'ScopedOffer';
                              product?:
                                | { __typename?: 'BundleProduct'; slug?: string | null }
                                | { __typename?: 'StandardProduct'; slug?: string | null }
                                | null;
                            }
                          | null;
                      } | null> | null;
                    } | null> | null;
                  } | null> | null;
                  warranty?: {
                    __typename?: 'Warranty';
                    additionalCommercialGuarantee?: any | null;
                    repairabilityClass?: RepairabilityClass | null;
                    softwareUpdates?: string | null;
                  } | null;
                  primaryCategory?: {
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                    ancestors?: Array<{
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                    } | null> | null;
                  } | null;
                  categories?: Array<{
                    __typename?: 'ProductCategory';
                    categoryNumber?: string | null;
                  } | null> | null;
                  rootCategories?: Array<{
                    __typename?: 'ProductCategory';
                    slug?: string | null;
                  } | null> | null;
                }
              | null;
          }
        | {
            __typename?: 'StandardProduct';
            description?: string | null;
            deliveredItems?: Array<string | null> | null;
            deliveryLeadTime?: string | null;
            model?: string | null;
            size?: string | null;
            variantName?: string | null;
            securityInformationUrl?: string | null;
            articleNumber?: string | null;
            bundle?: boolean | null;
            name?: string | null;
            slug?: string | null;
            tags?: Array<string | null> | null;
            origin?: Origin | null;
            alwaysDisplayed?: boolean | null;
            eans?: Array<string | null> | null;
            legalTexts?: Array<string | null> | null;
            usps?: Array<string | null> | null;
            externalLinks?: { __typename?: 'ExternalLinks'; oneShopUrl?: string | null } | null;
            brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
            color?: { __typename?: 'Color'; code?: any | null; name?: string | null } | null;
            storage?: {
              __typename?: 'MemorySize';
              value?: number | null;
              unit?: MemoryUnit | null;
            } | null;
            features?: Array<{
              __typename?: 'Feature';
              name?: string | null;
              value?: string | null;
            } | null> | null;
            commonCharger?: {
              __typename?: 'CommonCharger';
              included?: boolean | null;
              minWattage?: any | null;
              maxWattage?: any | null;
              possible?: boolean | null;
              usbPd?: boolean | null;
            } | null;
            availability?: {
              __typename?: 'ProductAvailability';
              stock?: number | null;
              provider?: ProductProviderKey | null;
              deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
            } | null;
            family?:
              | {
                  __typename?: 'BundleProductFamily';
                  name?: string | null;
                  slug?: string | null;
                  primaryCategory?: {
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                    ancestors?: Array<{
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                    } | null> | null;
                  } | null;
                  categories?: Array<{
                    __typename?: 'ProductCategory';
                    categoryNumber?: string | null;
                  } | null> | null;
                  rootCategories?: Array<{
                    __typename?: 'ProductCategory';
                    slug?: string | null;
                  } | null> | null;
                }
              | {
                  __typename?: 'StandardProductFamily';
                  manufacturerContact?: string | null;
                  manufacturerContactEu?: string | null;
                  name?: string | null;
                  slug?: string | null;
                  brand?: {
                    __typename?: 'Brand';
                    name?: string | null;
                    slug?: string | null;
                  } | null;
                  compatibilities?: Array<{
                    __typename?: 'ProductFamilyCompatibility';
                    family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
                    requirementAlternatives?: Array<{
                      __typename?: 'ProductFamilyCompatibilityRequirementAlternative';
                      requirements?: Array<{
                        __typename?: 'ProductFamilyCompatibilityRequirement';
                        family?: {
                          __typename?: 'StandardProductFamily';
                          name?: string | null;
                        } | null;
                        offer?:
                          | {
                              __typename?: 'CollapsibleOffer';
                              product?:
                                | { __typename?: 'BundleProduct'; slug?: string | null }
                                | { __typename?: 'StandardProduct'; slug?: string | null }
                                | null;
                            }
                          | {
                              __typename?: 'DefaultOffer';
                              product?:
                                | { __typename?: 'BundleProduct'; slug?: string | null }
                                | { __typename?: 'StandardProduct'; slug?: string | null }
                                | null;
                            }
                          | {
                              __typename?: 'ScopedOffer';
                              product?:
                                | { __typename?: 'BundleProduct'; slug?: string | null }
                                | { __typename?: 'StandardProduct'; slug?: string | null }
                                | null;
                            }
                          | null;
                      } | null> | null;
                    } | null> | null;
                  } | null> | null;
                  warranty?: {
                    __typename?: 'Warranty';
                    additionalCommercialGuarantee?: any | null;
                    repairabilityClass?: RepairabilityClass | null;
                    softwareUpdates?: string | null;
                  } | null;
                  primaryCategory?: {
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                    ancestors?: Array<{
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                    } | null> | null;
                  } | null;
                  categories?: Array<{
                    __typename?: 'ProductCategory';
                    categoryNumber?: string | null;
                  } | null> | null;
                  rootCategories?: Array<{
                    __typename?: 'ProductCategory';
                    slug?: string | null;
                  } | null> | null;
                }
              | null;
            energyEfficiency?: {
              __typename?: 'EnergyEfficiency';
              class?: EnergyEfficiencyClass | null;
              labelImage?:
                | {
                    __typename?: 'LocalAttachment';
                    mediaId?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
              document?:
                | {
                    __typename?: 'LocalAttachment';
                    path?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
            } | null;
          }
        | null;
      media?: Array<
        | {
            __typename?: 'LocalAttachment';
            mediaId?: string | null;
            type?: AttachmentType | null;
            name?: string | null;
            remote?: boolean | null;
          }
        | {
            __typename?: 'RemoteAttachment';
            url?: string | null;
            type?: AttachmentType | null;
            name?: string | null;
            remote?: boolean | null;
          }
        | null
      > | null;
      teaserImage?:
        | {
            __typename?: 'LocalAttachment';
            mediaId?: string | null;
            type?: AttachmentType | null;
            name?: string | null;
            remote?: boolean | null;
          }
        | {
            __typename?: 'RemoteAttachment';
            url?: string | null;
            type?: AttachmentType | null;
            name?: string | null;
            remote?: boolean | null;
          }
        | null;
      prices?: Array<{
        __typename?: 'Price';
        amount?: number | null;
        currency?: string | null;
        paymentFrequency?: PaymentFrequency | null;
        type?: PriceType | null;
        value?: any | null;
      } | null> | null;
      productAlternatives?: Array<{
        __typename?: 'ProductAlternativeItemGroup';
        position?: number | null;
        family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
        properties?: Array<{
          __typename?: 'ProductAlternativeSelectorGroup';
          key?: ProductSelectorField | null;
          alternatives?: Array<{
            __typename?: 'ProductAlternative';
            active?: boolean | null;
            exactMatch?: boolean | null;
            offer?: {
              __typename?: 'ScopedOffer';
              prices?: Array<{
                __typename?: 'Price';
                amount?: number | null;
                paymentFrequency?: PaymentFrequency | null;
                type?: PriceType | null;
                value?: any | null;
              } | null> | null;
              scopedProduct?: {
                __typename?: 'StandardProduct';
                size?: string | null;
                variantName?: string | null;
                name?: string | null;
                color?: {
                  __typename?: 'Color';
                  code?: any | null;
                  name?: string | null;
                  colorful?: boolean | null;
                } | null;
                storage?: {
                  __typename?: 'MemorySize';
                  unit?: MemoryUnit | null;
                  value?: number | null;
                } | null;
                memory?: {
                  __typename?: 'MemorySize';
                  unit?: MemoryUnit | null;
                  value?: number | null;
                } | null;
                energyEfficiency?: {
                  __typename?: 'EnergyEfficiency';
                  class?: EnergyEfficiencyClass | null;
                  labelImage?:
                    | {
                        __typename?: 'LocalAttachment';
                        mediaId?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | {
                        __typename?: 'RemoteAttachment';
                        url?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | null;
                  document?:
                    | {
                        __typename?: 'LocalAttachment';
                        path?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | {
                        __typename?: 'RemoteAttachment';
                        url?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | null;
                } | null;
              } | null;
              product?:
                | {
                    __typename?: 'BundleProduct';
                    articleNumber?: string | null;
                    name?: string | null;
                    slug?: string | null;
                    availability?: {
                      __typename?: 'ProductAvailability';
                      stock?: number | null;
                      provider?: ProductProviderKey | null;
                      deliveryLeadTime?: {
                        __typename?: 'DeliveryLeadTime';
                        text?: string | null;
                      } | null;
                    } | null;
                    teaserImage?:
                      | {
                          __typename?: 'LocalAttachment';
                          mediaId?: string | null;
                          type?: AttachmentType | null;
                          name?: string | null;
                          remote?: boolean | null;
                        }
                      | {
                          __typename?: 'RemoteAttachment';
                          url?: string | null;
                          type?: AttachmentType | null;
                          name?: string | null;
                          remote?: boolean | null;
                        }
                      | null;
                  }
                | {
                    __typename?: 'StandardProduct';
                    articleNumber?: string | null;
                    name?: string | null;
                    slug?: string | null;
                    availability?: {
                      __typename?: 'ProductAvailability';
                      stock?: number | null;
                      provider?: ProductProviderKey | null;
                      deliveryLeadTime?: {
                        __typename?: 'DeliveryLeadTime';
                        text?: string | null;
                      } | null;
                    } | null;
                    teaserImage?:
                      | {
                          __typename?: 'LocalAttachment';
                          mediaId?: string | null;
                          type?: AttachmentType | null;
                          name?: string | null;
                          remote?: boolean | null;
                        }
                      | {
                          __typename?: 'RemoteAttachment';
                          url?: string | null;
                          type?: AttachmentType | null;
                          name?: string | null;
                          remote?: boolean | null;
                        }
                      | null;
                  }
                | null;
            } | null;
          } | null> | null;
        } | null> | null;
      } | null> | null;
      documents?: Array<
        | {
            __typename?: 'LocalAttachment';
            path?: string | null;
            type?: AttachmentType | null;
            name?: string | null;
            remote?: boolean | null;
          }
        | {
            __typename?: 'RemoteAttachment';
            url?: string | null;
            type?: AttachmentType | null;
            name?: string | null;
            remote?: boolean | null;
          }
        | null
      > | null;
      accessories?: Array<{
        __typename?: 'DefaultOffer';
        maxOrderableAmount?: number | null;
        updatedAt?: any | null;
        product?:
          | {
              __typename?: 'BundleProduct';
              articleNumber?: string | null;
              bundle?: boolean | null;
              name?: string | null;
              slug?: string | null;
              tags?: Array<string | null> | null;
              origin?: Origin | null;
              alwaysDisplayed?: boolean | null;
              deliveryLeadTime?: string | null;
              bundledProducts?: Array<{
                __typename?: 'StandardProduct';
                name?: string | null;
                tags?: Array<string | null> | null;
                family?:
                  | { __typename?: 'BundleProductFamily'; name?: string | null }
                  | {
                      __typename?: 'StandardProductFamily';
                      name?: string | null;
                      brand?: {
                        __typename?: 'Brand';
                        name?: string | null;
                        slug?: string | null;
                      } | null;
                    }
                  | null;
                teaserImage?:
                  | {
                      __typename?: 'LocalAttachment';
                      mediaId?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
                energyEfficiency?: {
                  __typename?: 'EnergyEfficiency';
                  class?: EnergyEfficiencyClass | null;
                  labelImage?:
                    | {
                        __typename?: 'LocalAttachment';
                        mediaId?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | {
                        __typename?: 'RemoteAttachment';
                        url?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | null;
                  document?:
                    | {
                        __typename?: 'LocalAttachment';
                        path?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | {
                        __typename?: 'RemoteAttachment';
                        url?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | null;
                } | null;
              } | null> | null;
              availability?: {
                __typename?: 'ProductAvailability';
                stock?: number | null;
                provider?: ProductProviderKey | null;
                deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
              } | null;
              family?:
                | {
                    __typename?: 'BundleProductFamily';
                    name?: string | null;
                    primaryCategory?: {
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                      ancestors?: Array<{
                        __typename?: 'ProductCategory';
                        name?: string | null;
                        path?: string | null;
                      } | null> | null;
                    } | null;
                  }
                | {
                    __typename?: 'StandardProductFamily';
                    name?: string | null;
                    brand?: {
                      __typename?: 'Brand';
                      name?: string | null;
                      slug?: string | null;
                    } | null;
                    primaryCategory?: {
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                      ancestors?: Array<{
                        __typename?: 'ProductCategory';
                        name?: string | null;
                        path?: string | null;
                      } | null> | null;
                    } | null;
                  }
                | null;
            }
          | {
              __typename?: 'StandardProduct';
              articleNumber?: string | null;
              bundle?: boolean | null;
              name?: string | null;
              slug?: string | null;
              tags?: Array<string | null> | null;
              origin?: Origin | null;
              alwaysDisplayed?: boolean | null;
              deliveryLeadTime?: string | null;
              externalLinks?: { __typename?: 'ExternalLinks'; oneShopUrl?: string | null } | null;
              availability?: {
                __typename?: 'ProductAvailability';
                stock?: number | null;
                provider?: ProductProviderKey | null;
                deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
              } | null;
              family?:
                | {
                    __typename?: 'BundleProductFamily';
                    name?: string | null;
                    primaryCategory?: {
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                      ancestors?: Array<{
                        __typename?: 'ProductCategory';
                        name?: string | null;
                        path?: string | null;
                      } | null> | null;
                    } | null;
                  }
                | {
                    __typename?: 'StandardProductFamily';
                    name?: string | null;
                    brand?: {
                      __typename?: 'Brand';
                      name?: string | null;
                      slug?: string | null;
                    } | null;
                    primaryCategory?: {
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                      ancestors?: Array<{
                        __typename?: 'ProductCategory';
                        name?: string | null;
                        path?: string | null;
                      } | null> | null;
                    } | null;
                  }
                | null;
              energyEfficiency?: {
                __typename?: 'EnergyEfficiency';
                class?: EnergyEfficiencyClass | null;
                labelImage?:
                  | {
                      __typename?: 'LocalAttachment';
                      mediaId?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
                document?:
                  | {
                      __typename?: 'LocalAttachment';
                      path?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
              } | null;
            }
          | null;
        media?: Array<
          | {
              __typename?: 'LocalAttachment';
              mediaId?: string | null;
              type?: AttachmentType | null;
              name?: string | null;
              remote?: boolean | null;
            }
          | {
              __typename?: 'RemoteAttachment';
              url?: string | null;
              type?: AttachmentType | null;
              name?: string | null;
              remote?: boolean | null;
            }
          | null
        > | null;
        teaserImage?:
          | {
              __typename?: 'LocalAttachment';
              mediaId?: string | null;
              type?: AttachmentType | null;
              name?: string | null;
              remote?: boolean | null;
            }
          | {
              __typename?: 'RemoteAttachment';
              url?: string | null;
              type?: AttachmentType | null;
              name?: string | null;
              remote?: boolean | null;
            }
          | null;
        prices?: Array<{
          __typename?: 'Price';
          amount?: number | null;
          currency?: string | null;
          paymentFrequency?: PaymentFrequency | null;
          type?: PriceType | null;
          value?: any | null;
        } | null> | null;
        productAlternatives?: Array<{
          __typename?: 'ProductAlternativeItemGroup';
          position?: number | null;
          family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
          properties?: Array<{
            __typename?: 'ProductAlternativeSelectorGroup';
            key?: ProductSelectorField | null;
            alternatives?: Array<{
              __typename?: 'ProductAlternative';
              active?: boolean | null;
              exactMatch?: boolean | null;
              offer?: {
                __typename?: 'ScopedOffer';
                prices?: Array<{
                  __typename?: 'Price';
                  amount?: number | null;
                  paymentFrequency?: PaymentFrequency | null;
                  type?: PriceType | null;
                  value?: any | null;
                } | null> | null;
                scopedProduct?: {
                  __typename?: 'StandardProduct';
                  size?: string | null;
                  variantName?: string | null;
                  name?: string | null;
                  color?: {
                    __typename?: 'Color';
                    code?: any | null;
                    name?: string | null;
                    colorful?: boolean | null;
                  } | null;
                  storage?: {
                    __typename?: 'MemorySize';
                    unit?: MemoryUnit | null;
                    value?: number | null;
                  } | null;
                  memory?: {
                    __typename?: 'MemorySize';
                    unit?: MemoryUnit | null;
                    value?: number | null;
                  } | null;
                  energyEfficiency?: {
                    __typename?: 'EnergyEfficiency';
                    class?: EnergyEfficiencyClass | null;
                    labelImage?:
                      | {
                          __typename?: 'LocalAttachment';
                          mediaId?: string | null;
                          type?: AttachmentType | null;
                          name?: string | null;
                          remote?: boolean | null;
                        }
                      | {
                          __typename?: 'RemoteAttachment';
                          url?: string | null;
                          type?: AttachmentType | null;
                          name?: string | null;
                          remote?: boolean | null;
                        }
                      | null;
                    document?:
                      | {
                          __typename?: 'LocalAttachment';
                          path?: string | null;
                          type?: AttachmentType | null;
                          name?: string | null;
                          remote?: boolean | null;
                        }
                      | {
                          __typename?: 'RemoteAttachment';
                          url?: string | null;
                          type?: AttachmentType | null;
                          name?: string | null;
                          remote?: boolean | null;
                        }
                      | null;
                  } | null;
                } | null;
                product?:
                  | {
                      __typename?: 'BundleProduct';
                      articleNumber?: string | null;
                      name?: string | null;
                      slug?: string | null;
                      availability?: {
                        __typename?: 'ProductAvailability';
                        stock?: number | null;
                        provider?: ProductProviderKey | null;
                        deliveryLeadTime?: {
                          __typename?: 'DeliveryLeadTime';
                          text?: string | null;
                        } | null;
                      } | null;
                      teaserImage?:
                        | {
                            __typename?: 'LocalAttachment';
                            mediaId?: string | null;
                            type?: AttachmentType | null;
                            name?: string | null;
                            remote?: boolean | null;
                          }
                        | {
                            __typename?: 'RemoteAttachment';
                            url?: string | null;
                            type?: AttachmentType | null;
                            name?: string | null;
                            remote?: boolean | null;
                          }
                        | null;
                    }
                  | {
                      __typename?: 'StandardProduct';
                      articleNumber?: string | null;
                      name?: string | null;
                      slug?: string | null;
                      availability?: {
                        __typename?: 'ProductAvailability';
                        stock?: number | null;
                        provider?: ProductProviderKey | null;
                        deliveryLeadTime?: {
                          __typename?: 'DeliveryLeadTime';
                          text?: string | null;
                        } | null;
                      } | null;
                      teaserImage?:
                        | {
                            __typename?: 'LocalAttachment';
                            mediaId?: string | null;
                            type?: AttachmentType | null;
                            name?: string | null;
                            remote?: boolean | null;
                          }
                        | {
                            __typename?: 'RemoteAttachment';
                            url?: string | null;
                            type?: AttachmentType | null;
                            name?: string | null;
                            remote?: boolean | null;
                          }
                        | null;
                    }
                  | null;
              } | null;
            } | null> | null;
          } | null> | null;
        } | null> | null;
      } | null> | null;
      recommendations?: Array<{
        __typename?: 'DefaultOffer';
        maxOrderableAmount?: number | null;
        updatedAt?: any | null;
        product?:
          | {
              __typename?: 'BundleProduct';
              articleNumber?: string | null;
              bundle?: boolean | null;
              name?: string | null;
              slug?: string | null;
              tags?: Array<string | null> | null;
              origin?: Origin | null;
              alwaysDisplayed?: boolean | null;
              deliveryLeadTime?: string | null;
              bundledProducts?: Array<{
                __typename?: 'StandardProduct';
                name?: string | null;
                tags?: Array<string | null> | null;
                family?:
                  | { __typename?: 'BundleProductFamily'; name?: string | null }
                  | {
                      __typename?: 'StandardProductFamily';
                      name?: string | null;
                      brand?: {
                        __typename?: 'Brand';
                        name?: string | null;
                        slug?: string | null;
                      } | null;
                    }
                  | null;
                teaserImage?:
                  | {
                      __typename?: 'LocalAttachment';
                      mediaId?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
                energyEfficiency?: {
                  __typename?: 'EnergyEfficiency';
                  class?: EnergyEfficiencyClass | null;
                  labelImage?:
                    | {
                        __typename?: 'LocalAttachment';
                        mediaId?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | {
                        __typename?: 'RemoteAttachment';
                        url?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | null;
                  document?:
                    | {
                        __typename?: 'LocalAttachment';
                        path?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | {
                        __typename?: 'RemoteAttachment';
                        url?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | null;
                } | null;
              } | null> | null;
              availability?: {
                __typename?: 'ProductAvailability';
                stock?: number | null;
                provider?: ProductProviderKey | null;
                deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
              } | null;
              family?:
                | {
                    __typename?: 'BundleProductFamily';
                    name?: string | null;
                    primaryCategory?: {
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                      ancestors?: Array<{
                        __typename?: 'ProductCategory';
                        name?: string | null;
                        path?: string | null;
                      } | null> | null;
                    } | null;
                  }
                | {
                    __typename?: 'StandardProductFamily';
                    name?: string | null;
                    brand?: {
                      __typename?: 'Brand';
                      name?: string | null;
                      slug?: string | null;
                    } | null;
                    primaryCategory?: {
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                      ancestors?: Array<{
                        __typename?: 'ProductCategory';
                        name?: string | null;
                        path?: string | null;
                      } | null> | null;
                    } | null;
                  }
                | null;
            }
          | {
              __typename?: 'StandardProduct';
              articleNumber?: string | null;
              bundle?: boolean | null;
              name?: string | null;
              slug?: string | null;
              tags?: Array<string | null> | null;
              origin?: Origin | null;
              alwaysDisplayed?: boolean | null;
              deliveryLeadTime?: string | null;
              externalLinks?: { __typename?: 'ExternalLinks'; oneShopUrl?: string | null } | null;
              availability?: {
                __typename?: 'ProductAvailability';
                stock?: number | null;
                provider?: ProductProviderKey | null;
                deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
              } | null;
              family?:
                | {
                    __typename?: 'BundleProductFamily';
                    name?: string | null;
                    primaryCategory?: {
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                      ancestors?: Array<{
                        __typename?: 'ProductCategory';
                        name?: string | null;
                        path?: string | null;
                      } | null> | null;
                    } | null;
                  }
                | {
                    __typename?: 'StandardProductFamily';
                    name?: string | null;
                    brand?: {
                      __typename?: 'Brand';
                      name?: string | null;
                      slug?: string | null;
                    } | null;
                    primaryCategory?: {
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                      ancestors?: Array<{
                        __typename?: 'ProductCategory';
                        name?: string | null;
                        path?: string | null;
                      } | null> | null;
                    } | null;
                  }
                | null;
              energyEfficiency?: {
                __typename?: 'EnergyEfficiency';
                class?: EnergyEfficiencyClass | null;
                labelImage?:
                  | {
                      __typename?: 'LocalAttachment';
                      mediaId?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
                document?:
                  | {
                      __typename?: 'LocalAttachment';
                      path?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
              } | null;
            }
          | null;
        media?: Array<
          | {
              __typename?: 'LocalAttachment';
              mediaId?: string | null;
              type?: AttachmentType | null;
              name?: string | null;
              remote?: boolean | null;
            }
          | {
              __typename?: 'RemoteAttachment';
              url?: string | null;
              type?: AttachmentType | null;
              name?: string | null;
              remote?: boolean | null;
            }
          | null
        > | null;
        teaserImage?:
          | {
              __typename?: 'LocalAttachment';
              mediaId?: string | null;
              type?: AttachmentType | null;
              name?: string | null;
              remote?: boolean | null;
            }
          | {
              __typename?: 'RemoteAttachment';
              url?: string | null;
              type?: AttachmentType | null;
              name?: string | null;
              remote?: boolean | null;
            }
          | null;
        prices?: Array<{
          __typename?: 'Price';
          amount?: number | null;
          currency?: string | null;
          paymentFrequency?: PaymentFrequency | null;
          type?: PriceType | null;
          value?: any | null;
        } | null> | null;
        productAlternatives?: Array<{
          __typename?: 'ProductAlternativeItemGroup';
          position?: number | null;
          family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
          properties?: Array<{
            __typename?: 'ProductAlternativeSelectorGroup';
            key?: ProductSelectorField | null;
            alternatives?: Array<{
              __typename?: 'ProductAlternative';
              active?: boolean | null;
              exactMatch?: boolean | null;
              offer?: {
                __typename?: 'ScopedOffer';
                prices?: Array<{
                  __typename?: 'Price';
                  amount?: number | null;
                  paymentFrequency?: PaymentFrequency | null;
                  type?: PriceType | null;
                  value?: any | null;
                } | null> | null;
                scopedProduct?: {
                  __typename?: 'StandardProduct';
                  size?: string | null;
                  variantName?: string | null;
                  name?: string | null;
                  color?: {
                    __typename?: 'Color';
                    code?: any | null;
                    name?: string | null;
                    colorful?: boolean | null;
                  } | null;
                  storage?: {
                    __typename?: 'MemorySize';
                    unit?: MemoryUnit | null;
                    value?: number | null;
                  } | null;
                  memory?: {
                    __typename?: 'MemorySize';
                    unit?: MemoryUnit | null;
                    value?: number | null;
                  } | null;
                  energyEfficiency?: {
                    __typename?: 'EnergyEfficiency';
                    class?: EnergyEfficiencyClass | null;
                    labelImage?:
                      | {
                          __typename?: 'LocalAttachment';
                          mediaId?: string | null;
                          type?: AttachmentType | null;
                          name?: string | null;
                          remote?: boolean | null;
                        }
                      | {
                          __typename?: 'RemoteAttachment';
                          url?: string | null;
                          type?: AttachmentType | null;
                          name?: string | null;
                          remote?: boolean | null;
                        }
                      | null;
                    document?:
                      | {
                          __typename?: 'LocalAttachment';
                          path?: string | null;
                          type?: AttachmentType | null;
                          name?: string | null;
                          remote?: boolean | null;
                        }
                      | {
                          __typename?: 'RemoteAttachment';
                          url?: string | null;
                          type?: AttachmentType | null;
                          name?: string | null;
                          remote?: boolean | null;
                        }
                      | null;
                  } | null;
                } | null;
                product?:
                  | {
                      __typename?: 'BundleProduct';
                      articleNumber?: string | null;
                      name?: string | null;
                      slug?: string | null;
                      availability?: {
                        __typename?: 'ProductAvailability';
                        stock?: number | null;
                        provider?: ProductProviderKey | null;
                        deliveryLeadTime?: {
                          __typename?: 'DeliveryLeadTime';
                          text?: string | null;
                        } | null;
                      } | null;
                      teaserImage?:
                        | {
                            __typename?: 'LocalAttachment';
                            mediaId?: string | null;
                            type?: AttachmentType | null;
                            name?: string | null;
                            remote?: boolean | null;
                          }
                        | {
                            __typename?: 'RemoteAttachment';
                            url?: string | null;
                            type?: AttachmentType | null;
                            name?: string | null;
                            remote?: boolean | null;
                          }
                        | null;
                    }
                  | {
                      __typename?: 'StandardProduct';
                      articleNumber?: string | null;
                      name?: string | null;
                      slug?: string | null;
                      availability?: {
                        __typename?: 'ProductAvailability';
                        stock?: number | null;
                        provider?: ProductProviderKey | null;
                        deliveryLeadTime?: {
                          __typename?: 'DeliveryLeadTime';
                          text?: string | null;
                        } | null;
                      } | null;
                      teaserImage?:
                        | {
                            __typename?: 'LocalAttachment';
                            mediaId?: string | null;
                            type?: AttachmentType | null;
                            name?: string | null;
                            remote?: boolean | null;
                          }
                        | {
                            __typename?: 'RemoteAttachment';
                            url?: string | null;
                            type?: AttachmentType | null;
                            name?: string | null;
                            remote?: boolean | null;
                          }
                        | null;
                    }
                  | null;
              } | null;
            } | null> | null;
          } | null> | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
    pagination?: {
      __typename?: 'Pagination';
      page?: number | null;
      size?: number | null;
      totalCount?: number | null;
      totalPages?: number | null;
    } | null;
    sort?: {
      __typename?: 'OfferSort';
      direction?: SortDirection | null;
      field?: OfferSortField | null;
    } | null;
    aggregations?: {
      __typename?: 'OfferAggregations';
      productCategories?: Array<{
        __typename?: 'OfferProductCategoryAggregation';
        offersCount?: number | null;
        selected?: boolean | null;
        productCategory?: {
          __typename?: 'ProductCategory';
          name?: string | null;
          path?: string | null;
          depth?: number | null;
        } | null;
        children?: Array<{
          __typename?: 'OfferProductCategoryAggregation';
          offersCount?: number | null;
          selected?: boolean | null;
          productCategory?: {
            __typename?: 'ProductCategory';
            name?: string | null;
            path?: string | null;
            depth?: number | null;
          } | null;
        } | null> | null;
      } | null> | null;
      brands?: Array<{
        __typename?: 'OfferBrandAggregation';
        offersCount?: number | null;
        selected?: boolean | null;
        brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
      } | null> | null;
      colors?: Array<{
        __typename?: 'OfferColorAggregation';
        offersCount?: number | null;
        selected?: boolean | null;
        color?: {
          __typename?: 'PaletteColor';
          code?: any | null;
          name?: string | null;
          slug?: string | null;
        } | null;
      } | null> | null;
      compatibleProductFamilies?: Array<{
        __typename?: 'OfferCompatibleProductFamilyAggregation';
        offersCount?: number | null;
        selected?: boolean | null;
        productFamily?: {
          __typename?: 'StandardProductFamily';
          model?: string | null;
          slug?: string | null;
          brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
        } | null;
      } | null> | null;
      discounts?: {
        __typename?: 'OfferDiscountsAggregationGroup';
        discounted?: {
          __typename?: 'OfferDiscountsAggregation';
          offersCount?: number | null;
          selected?: boolean | null;
        } | null;
        undiscounted?: {
          __typename?: 'OfferDiscountsAggregation';
          offersCount?: number | null;
          selected?: boolean | null;
        } | null;
      } | null;
      productTags?: Array<{
        __typename?: 'OfferProductTagAggregation';
        offersCount?: number | null;
        selected?: boolean | null;
        tag?: { __typename?: 'Tag'; name?: string | null; slug?: string | null } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type NavigationTeasersQueryVariables = Exact<{
  filter?: InputMaybe<OfferFilterParams>;
  grouped?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<OfferSortParams>;
  pagination?: InputMaybe<PaginationParams>;
  search?: InputMaybe<Scalars['String']['input']>;
  validAt?: InputMaybe<Scalars['DateTime']['input']>;
  complexSearch?: InputMaybe<OfferSearchParams>;
}>;

export type NavigationTeasersQuery = {
  __typename?: 'Query';
  offers?: {
    __typename?: 'Offers';
    entries?: Array<{
      __typename?: 'CollapsibleOffer';
      media?: Array<
        | {
            __typename?: 'LocalAttachment';
            mediaId?: string | null;
            type?: AttachmentType | null;
            name?: string | null;
            remote?: boolean | null;
          }
        | {
            __typename?: 'RemoteAttachment';
            url?: string | null;
            type?: AttachmentType | null;
            name?: string | null;
            remote?: boolean | null;
          }
        | null
      > | null;
      product?:
        | {
            __typename?: 'BundleProduct';
            articleNumber?: string | null;
            bundle?: boolean | null;
            name?: string | null;
            slug?: string | null;
            tags?: Array<string | null> | null;
            origin?: Origin | null;
            alwaysDisplayed?: boolean | null;
            bundledProducts?: Array<{
              __typename?: 'StandardProduct';
              name?: string | null;
              family?:
                | { __typename?: 'BundleProductFamily'; name?: string | null }
                | { __typename?: 'StandardProductFamily'; name?: string | null }
                | null;
              teaserImage?:
                | {
                    __typename?: 'LocalAttachment';
                    mediaId?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
              energyEfficiency?: {
                __typename?: 'EnergyEfficiency';
                class?: EnergyEfficiencyClass | null;
                labelImage?:
                  | {
                      __typename?: 'LocalAttachment';
                      mediaId?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
                document?:
                  | {
                      __typename?: 'LocalAttachment';
                      path?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
              } | null;
            } | null> | null;
            family?:
              | { __typename?: 'BundleProductFamily'; name?: string | null }
              | {
                  __typename?: 'StandardProductFamily';
                  name?: string | null;
                  brand?: { __typename?: 'Brand'; name?: string | null } | null;
                }
              | null;
          }
        | {
            __typename?: 'StandardProduct';
            articleNumber?: string | null;
            bundle?: boolean | null;
            name?: string | null;
            slug?: string | null;
            tags?: Array<string | null> | null;
            origin?: Origin | null;
            alwaysDisplayed?: boolean | null;
            family?:
              | { __typename?: 'BundleProductFamily'; name?: string | null }
              | {
                  __typename?: 'StandardProductFamily';
                  name?: string | null;
                  brand?: { __typename?: 'Brand'; name?: string | null } | null;
                }
              | null;
            energyEfficiency?: {
              __typename?: 'EnergyEfficiency';
              class?: EnergyEfficiencyClass | null;
              labelImage?:
                | {
                    __typename?: 'LocalAttachment';
                    mediaId?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
              document?:
                | {
                    __typename?: 'LocalAttachment';
                    path?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
            } | null;
          }
        | null;
      teaserImage?:
        | {
            __typename?: 'LocalAttachment';
            mediaId?: string | null;
            type?: AttachmentType | null;
            name?: string | null;
            remote?: boolean | null;
          }
        | {
            __typename?: 'RemoteAttachment';
            url?: string | null;
            type?: AttachmentType | null;
            name?: string | null;
            remote?: boolean | null;
          }
        | null;
      prices?: Array<{
        __typename?: 'Price';
        amount?: number | null;
        currency?: string | null;
        paymentFrequency?: PaymentFrequency | null;
        type?: PriceType | null;
        value?: any | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type OfferByArticleNumberQueryVariables = Exact<{
  articleNumber?: InputMaybe<Scalars['ID']['input']>;
  validAt?: InputMaybe<Scalars['DateTime']['input']>;
}>;

export type OfferByArticleNumberQuery = {
  __typename?: 'Query';
  offer?: {
    __typename?: 'DefaultOffer';
    maxOrderableAmount?: number | null;
    updatedAt?: any | null;
    usps?: Array<string | null> | null;
    summaryTexts?: Array<string | null> | null;
    documents?: Array<
      | {
          __typename?: 'LocalAttachment';
          path?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | {
          __typename?: 'RemoteAttachment';
          url?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | null
    > | null;
    media?: Array<
      | {
          __typename?: 'LocalAttachment';
          mediaId?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | {
          __typename?: 'RemoteAttachment';
          url?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | null
    > | null;
    teaserImage?:
      | {
          __typename?: 'LocalAttachment';
          mediaId?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | {
          __typename?: 'RemoteAttachment';
          url?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | null;
    prices?: Array<{
      __typename?: 'Price';
      amount?: number | null;
      currency?: string | null;
      paymentFrequency?: PaymentFrequency | null;
      type?: PriceType | null;
      value?: any | null;
    } | null> | null;
    accessories?: Array<{
      __typename?: 'DefaultOffer';
      maxOrderableAmount?: number | null;
      updatedAt?: any | null;
      product?:
        | {
            __typename?: 'BundleProduct';
            articleNumber?: string | null;
            bundle?: boolean | null;
            name?: string | null;
            slug?: string | null;
            tags?: Array<string | null> | null;
            origin?: Origin | null;
            alwaysDisplayed?: boolean | null;
            deliveryLeadTime?: string | null;
            bundledProducts?: Array<{
              __typename?: 'StandardProduct';
              name?: string | null;
              tags?: Array<string | null> | null;
              family?:
                | { __typename?: 'BundleProductFamily'; name?: string | null }
                | {
                    __typename?: 'StandardProductFamily';
                    name?: string | null;
                    brand?: {
                      __typename?: 'Brand';
                      name?: string | null;
                      slug?: string | null;
                    } | null;
                  }
                | null;
              teaserImage?:
                | {
                    __typename?: 'LocalAttachment';
                    mediaId?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
              energyEfficiency?: {
                __typename?: 'EnergyEfficiency';
                class?: EnergyEfficiencyClass | null;
                labelImage?:
                  | {
                      __typename?: 'LocalAttachment';
                      mediaId?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
                document?:
                  | {
                      __typename?: 'LocalAttachment';
                      path?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
              } | null;
            } | null> | null;
            availability?: {
              __typename?: 'ProductAvailability';
              stock?: number | null;
              provider?: ProductProviderKey | null;
              deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
            } | null;
            family?:
              | {
                  __typename?: 'BundleProductFamily';
                  name?: string | null;
                  primaryCategory?: {
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                    ancestors?: Array<{
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                    } | null> | null;
                  } | null;
                }
              | {
                  __typename?: 'StandardProductFamily';
                  name?: string | null;
                  brand?: {
                    __typename?: 'Brand';
                    name?: string | null;
                    slug?: string | null;
                  } | null;
                  primaryCategory?: {
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                    ancestors?: Array<{
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                    } | null> | null;
                  } | null;
                }
              | null;
          }
        | {
            __typename?: 'StandardProduct';
            articleNumber?: string | null;
            bundle?: boolean | null;
            name?: string | null;
            slug?: string | null;
            tags?: Array<string | null> | null;
            origin?: Origin | null;
            alwaysDisplayed?: boolean | null;
            deliveryLeadTime?: string | null;
            externalLinks?: { __typename?: 'ExternalLinks'; oneShopUrl?: string | null } | null;
            availability?: {
              __typename?: 'ProductAvailability';
              stock?: number | null;
              provider?: ProductProviderKey | null;
              deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
            } | null;
            family?:
              | {
                  __typename?: 'BundleProductFamily';
                  name?: string | null;
                  primaryCategory?: {
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                    ancestors?: Array<{
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                    } | null> | null;
                  } | null;
                }
              | {
                  __typename?: 'StandardProductFamily';
                  name?: string | null;
                  brand?: {
                    __typename?: 'Brand';
                    name?: string | null;
                    slug?: string | null;
                  } | null;
                  primaryCategory?: {
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                    ancestors?: Array<{
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                    } | null> | null;
                  } | null;
                }
              | null;
            energyEfficiency?: {
              __typename?: 'EnergyEfficiency';
              class?: EnergyEfficiencyClass | null;
              labelImage?:
                | {
                    __typename?: 'LocalAttachment';
                    mediaId?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
              document?:
                | {
                    __typename?: 'LocalAttachment';
                    path?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
            } | null;
          }
        | null;
      media?: Array<
        | {
            __typename?: 'LocalAttachment';
            mediaId?: string | null;
            type?: AttachmentType | null;
            name?: string | null;
            remote?: boolean | null;
          }
        | {
            __typename?: 'RemoteAttachment';
            url?: string | null;
            type?: AttachmentType | null;
            name?: string | null;
            remote?: boolean | null;
          }
        | null
      > | null;
      teaserImage?:
        | {
            __typename?: 'LocalAttachment';
            mediaId?: string | null;
            type?: AttachmentType | null;
            name?: string | null;
            remote?: boolean | null;
          }
        | {
            __typename?: 'RemoteAttachment';
            url?: string | null;
            type?: AttachmentType | null;
            name?: string | null;
            remote?: boolean | null;
          }
        | null;
      prices?: Array<{
        __typename?: 'Price';
        amount?: number | null;
        currency?: string | null;
        paymentFrequency?: PaymentFrequency | null;
        type?: PriceType | null;
        value?: any | null;
      } | null> | null;
      productAlternatives?: Array<{
        __typename?: 'ProductAlternativeItemGroup';
        position?: number | null;
        family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
        properties?: Array<{
          __typename?: 'ProductAlternativeSelectorGroup';
          key?: ProductSelectorField | null;
          alternatives?: Array<{
            __typename?: 'ProductAlternative';
            active?: boolean | null;
            exactMatch?: boolean | null;
            offer?: {
              __typename?: 'ScopedOffer';
              prices?: Array<{
                __typename?: 'Price';
                amount?: number | null;
                paymentFrequency?: PaymentFrequency | null;
                type?: PriceType | null;
                value?: any | null;
              } | null> | null;
              scopedProduct?: {
                __typename?: 'StandardProduct';
                size?: string | null;
                variantName?: string | null;
                name?: string | null;
                color?: {
                  __typename?: 'Color';
                  code?: any | null;
                  name?: string | null;
                  colorful?: boolean | null;
                } | null;
                storage?: {
                  __typename?: 'MemorySize';
                  unit?: MemoryUnit | null;
                  value?: number | null;
                } | null;
                memory?: {
                  __typename?: 'MemorySize';
                  unit?: MemoryUnit | null;
                  value?: number | null;
                } | null;
                energyEfficiency?: {
                  __typename?: 'EnergyEfficiency';
                  class?: EnergyEfficiencyClass | null;
                  labelImage?:
                    | {
                        __typename?: 'LocalAttachment';
                        mediaId?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | {
                        __typename?: 'RemoteAttachment';
                        url?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | null;
                  document?:
                    | {
                        __typename?: 'LocalAttachment';
                        path?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | {
                        __typename?: 'RemoteAttachment';
                        url?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | null;
                } | null;
              } | null;
              product?:
                | {
                    __typename?: 'BundleProduct';
                    articleNumber?: string | null;
                    name?: string | null;
                    slug?: string | null;
                    availability?: {
                      __typename?: 'ProductAvailability';
                      stock?: number | null;
                      provider?: ProductProviderKey | null;
                      deliveryLeadTime?: {
                        __typename?: 'DeliveryLeadTime';
                        text?: string | null;
                      } | null;
                    } | null;
                    teaserImage?:
                      | {
                          __typename?: 'LocalAttachment';
                          mediaId?: string | null;
                          type?: AttachmentType | null;
                          name?: string | null;
                          remote?: boolean | null;
                        }
                      | {
                          __typename?: 'RemoteAttachment';
                          url?: string | null;
                          type?: AttachmentType | null;
                          name?: string | null;
                          remote?: boolean | null;
                        }
                      | null;
                  }
                | {
                    __typename?: 'StandardProduct';
                    articleNumber?: string | null;
                    name?: string | null;
                    slug?: string | null;
                    availability?: {
                      __typename?: 'ProductAvailability';
                      stock?: number | null;
                      provider?: ProductProviderKey | null;
                      deliveryLeadTime?: {
                        __typename?: 'DeliveryLeadTime';
                        text?: string | null;
                      } | null;
                    } | null;
                    teaserImage?:
                      | {
                          __typename?: 'LocalAttachment';
                          mediaId?: string | null;
                          type?: AttachmentType | null;
                          name?: string | null;
                          remote?: boolean | null;
                        }
                      | {
                          __typename?: 'RemoteAttachment';
                          url?: string | null;
                          type?: AttachmentType | null;
                          name?: string | null;
                          remote?: boolean | null;
                        }
                      | null;
                  }
                | null;
            } | null;
          } | null> | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
    recommendations?: Array<{
      __typename?: 'DefaultOffer';
      maxOrderableAmount?: number | null;
      updatedAt?: any | null;
      product?:
        | {
            __typename?: 'BundleProduct';
            articleNumber?: string | null;
            bundle?: boolean | null;
            name?: string | null;
            slug?: string | null;
            tags?: Array<string | null> | null;
            origin?: Origin | null;
            alwaysDisplayed?: boolean | null;
            deliveryLeadTime?: string | null;
            bundledProducts?: Array<{
              __typename?: 'StandardProduct';
              name?: string | null;
              tags?: Array<string | null> | null;
              family?:
                | { __typename?: 'BundleProductFamily'; name?: string | null }
                | {
                    __typename?: 'StandardProductFamily';
                    name?: string | null;
                    brand?: {
                      __typename?: 'Brand';
                      name?: string | null;
                      slug?: string | null;
                    } | null;
                  }
                | null;
              teaserImage?:
                | {
                    __typename?: 'LocalAttachment';
                    mediaId?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
              energyEfficiency?: {
                __typename?: 'EnergyEfficiency';
                class?: EnergyEfficiencyClass | null;
                labelImage?:
                  | {
                      __typename?: 'LocalAttachment';
                      mediaId?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
                document?:
                  | {
                      __typename?: 'LocalAttachment';
                      path?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
              } | null;
            } | null> | null;
            availability?: {
              __typename?: 'ProductAvailability';
              stock?: number | null;
              provider?: ProductProviderKey | null;
              deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
            } | null;
            family?:
              | {
                  __typename?: 'BundleProductFamily';
                  name?: string | null;
                  primaryCategory?: {
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                    ancestors?: Array<{
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                    } | null> | null;
                  } | null;
                }
              | {
                  __typename?: 'StandardProductFamily';
                  name?: string | null;
                  brand?: {
                    __typename?: 'Brand';
                    name?: string | null;
                    slug?: string | null;
                  } | null;
                  primaryCategory?: {
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                    ancestors?: Array<{
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                    } | null> | null;
                  } | null;
                }
              | null;
          }
        | {
            __typename?: 'StandardProduct';
            articleNumber?: string | null;
            bundle?: boolean | null;
            name?: string | null;
            slug?: string | null;
            tags?: Array<string | null> | null;
            origin?: Origin | null;
            alwaysDisplayed?: boolean | null;
            deliveryLeadTime?: string | null;
            externalLinks?: { __typename?: 'ExternalLinks'; oneShopUrl?: string | null } | null;
            availability?: {
              __typename?: 'ProductAvailability';
              stock?: number | null;
              provider?: ProductProviderKey | null;
              deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
            } | null;
            family?:
              | {
                  __typename?: 'BundleProductFamily';
                  name?: string | null;
                  primaryCategory?: {
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                    ancestors?: Array<{
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                    } | null> | null;
                  } | null;
                }
              | {
                  __typename?: 'StandardProductFamily';
                  name?: string | null;
                  brand?: {
                    __typename?: 'Brand';
                    name?: string | null;
                    slug?: string | null;
                  } | null;
                  primaryCategory?: {
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                    ancestors?: Array<{
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                    } | null> | null;
                  } | null;
                }
              | null;
            energyEfficiency?: {
              __typename?: 'EnergyEfficiency';
              class?: EnergyEfficiencyClass | null;
              labelImage?:
                | {
                    __typename?: 'LocalAttachment';
                    mediaId?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
              document?:
                | {
                    __typename?: 'LocalAttachment';
                    path?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
            } | null;
          }
        | null;
      media?: Array<
        | {
            __typename?: 'LocalAttachment';
            mediaId?: string | null;
            type?: AttachmentType | null;
            name?: string | null;
            remote?: boolean | null;
          }
        | {
            __typename?: 'RemoteAttachment';
            url?: string | null;
            type?: AttachmentType | null;
            name?: string | null;
            remote?: boolean | null;
          }
        | null
      > | null;
      teaserImage?:
        | {
            __typename?: 'LocalAttachment';
            mediaId?: string | null;
            type?: AttachmentType | null;
            name?: string | null;
            remote?: boolean | null;
          }
        | {
            __typename?: 'RemoteAttachment';
            url?: string | null;
            type?: AttachmentType | null;
            name?: string | null;
            remote?: boolean | null;
          }
        | null;
      prices?: Array<{
        __typename?: 'Price';
        amount?: number | null;
        currency?: string | null;
        paymentFrequency?: PaymentFrequency | null;
        type?: PriceType | null;
        value?: any | null;
      } | null> | null;
      productAlternatives?: Array<{
        __typename?: 'ProductAlternativeItemGroup';
        position?: number | null;
        family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
        properties?: Array<{
          __typename?: 'ProductAlternativeSelectorGroup';
          key?: ProductSelectorField | null;
          alternatives?: Array<{
            __typename?: 'ProductAlternative';
            active?: boolean | null;
            exactMatch?: boolean | null;
            offer?: {
              __typename?: 'ScopedOffer';
              prices?: Array<{
                __typename?: 'Price';
                amount?: number | null;
                paymentFrequency?: PaymentFrequency | null;
                type?: PriceType | null;
                value?: any | null;
              } | null> | null;
              scopedProduct?: {
                __typename?: 'StandardProduct';
                size?: string | null;
                variantName?: string | null;
                name?: string | null;
                color?: {
                  __typename?: 'Color';
                  code?: any | null;
                  name?: string | null;
                  colorful?: boolean | null;
                } | null;
                storage?: {
                  __typename?: 'MemorySize';
                  unit?: MemoryUnit | null;
                  value?: number | null;
                } | null;
                memory?: {
                  __typename?: 'MemorySize';
                  unit?: MemoryUnit | null;
                  value?: number | null;
                } | null;
                energyEfficiency?: {
                  __typename?: 'EnergyEfficiency';
                  class?: EnergyEfficiencyClass | null;
                  labelImage?:
                    | {
                        __typename?: 'LocalAttachment';
                        mediaId?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | {
                        __typename?: 'RemoteAttachment';
                        url?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | null;
                  document?:
                    | {
                        __typename?: 'LocalAttachment';
                        path?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | {
                        __typename?: 'RemoteAttachment';
                        url?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | null;
                } | null;
              } | null;
              product?:
                | {
                    __typename?: 'BundleProduct';
                    articleNumber?: string | null;
                    name?: string | null;
                    slug?: string | null;
                    availability?: {
                      __typename?: 'ProductAvailability';
                      stock?: number | null;
                      provider?: ProductProviderKey | null;
                      deliveryLeadTime?: {
                        __typename?: 'DeliveryLeadTime';
                        text?: string | null;
                      } | null;
                    } | null;
                    teaserImage?:
                      | {
                          __typename?: 'LocalAttachment';
                          mediaId?: string | null;
                          type?: AttachmentType | null;
                          name?: string | null;
                          remote?: boolean | null;
                        }
                      | {
                          __typename?: 'RemoteAttachment';
                          url?: string | null;
                          type?: AttachmentType | null;
                          name?: string | null;
                          remote?: boolean | null;
                        }
                      | null;
                  }
                | {
                    __typename?: 'StandardProduct';
                    articleNumber?: string | null;
                    name?: string | null;
                    slug?: string | null;
                    availability?: {
                      __typename?: 'ProductAvailability';
                      stock?: number | null;
                      provider?: ProductProviderKey | null;
                      deliveryLeadTime?: {
                        __typename?: 'DeliveryLeadTime';
                        text?: string | null;
                      } | null;
                    } | null;
                    teaserImage?:
                      | {
                          __typename?: 'LocalAttachment';
                          mediaId?: string | null;
                          type?: AttachmentType | null;
                          name?: string | null;
                          remote?: boolean | null;
                        }
                      | {
                          __typename?: 'RemoteAttachment';
                          url?: string | null;
                          type?: AttachmentType | null;
                          name?: string | null;
                          remote?: boolean | null;
                        }
                      | null;
                  }
                | null;
            } | null;
          } | null> | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
    product?:
      | {
          __typename?: 'BundleProduct';
          description?: string | null;
          articleNumber?: string | null;
          eans?: Array<string | null> | null;
          bundle?: boolean | null;
          name?: string | null;
          slug?: string | null;
          legalTexts?: Array<string | null> | null;
          tags?: Array<string | null> | null;
          origin?: Origin | null;
          deliveryLeadTime?: string | null;
          alwaysDisplayed?: boolean | null;
          usps?: Array<string | null> | null;
          bundledProducts?: Array<{
            __typename?: 'StandardProduct';
            securityInformationUrl?: string | null;
            articleNumber?: string | null;
            name?: string | null;
            eans?: Array<string | null> | null;
            description?: string | null;
            slug?: string | null;
            usps?: Array<string | null> | null;
            deliveredItems?: Array<string | null> | null;
            tags?: Array<string | null> | null;
            origin?: Origin | null;
            commonCharger?: {
              __typename?: 'CommonCharger';
              included?: boolean | null;
              minWattage?: any | null;
              maxWattage?: any | null;
              possible?: boolean | null;
              usbPd?: boolean | null;
            } | null;
            teaserImage?:
              | {
                  __typename?: 'LocalAttachment';
                  mediaId?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
            family?:
              | { __typename?: 'BundleProductFamily'; name?: string | null; slug?: string | null }
              | {
                  __typename?: 'StandardProductFamily';
                  manufacturerContact?: string | null;
                  manufacturerContactEu?: string | null;
                  name?: string | null;
                  slug?: string | null;
                  compatibilities?: Array<{
                    __typename?: 'ProductFamilyCompatibility';
                    family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
                    requirementAlternatives?: Array<{
                      __typename?: 'ProductFamilyCompatibilityRequirementAlternative';
                      requirements?: Array<{
                        __typename?: 'ProductFamilyCompatibilityRequirement';
                        family?: {
                          __typename?: 'StandardProductFamily';
                          name?: string | null;
                        } | null;
                        offer?:
                          | {
                              __typename?: 'CollapsibleOffer';
                              product?:
                                | { __typename?: 'BundleProduct'; slug?: string | null }
                                | { __typename?: 'StandardProduct'; slug?: string | null }
                                | null;
                            }
                          | {
                              __typename?: 'DefaultOffer';
                              product?:
                                | { __typename?: 'BundleProduct'; slug?: string | null }
                                | { __typename?: 'StandardProduct'; slug?: string | null }
                                | null;
                            }
                          | {
                              __typename?: 'ScopedOffer';
                              product?:
                                | { __typename?: 'BundleProduct'; slug?: string | null }
                                | { __typename?: 'StandardProduct'; slug?: string | null }
                                | null;
                            }
                          | null;
                      } | null> | null;
                    } | null> | null;
                  } | null> | null;
                  brand?: {
                    __typename?: 'Brand';
                    name?: string | null;
                    slug?: string | null;
                  } | null;
                  warranty?: {
                    __typename?: 'Warranty';
                    additionalCommercialGuarantee?: any | null;
                    repairabilityClass?: RepairabilityClass | null;
                    softwareUpdates?: string | null;
                  } | null;
                }
              | null;
            features?: Array<{
              __typename?: 'Feature';
              name?: string | null;
              value?: string | null;
            } | null> | null;
            media?: Array<
              | {
                  __typename?: 'LocalAttachment';
                  mediaId?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null
            > | null;
            energyEfficiency?: {
              __typename?: 'EnergyEfficiency';
              class?: EnergyEfficiencyClass | null;
              labelImage?:
                | {
                    __typename?: 'LocalAttachment';
                    mediaId?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
              document?:
                | {
                    __typename?: 'LocalAttachment';
                    path?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
            } | null;
          } | null> | null;
          availability?: {
            __typename?: 'ProductAvailability';
            stock?: number | null;
            provider?: ProductProviderKey | null;
            deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
          } | null;
          family?:
            | {
                __typename?: 'BundleProductFamily';
                name?: string | null;
                slug?: string | null;
                categories?: Array<{
                  __typename?: 'ProductCategory';
                  categoryNumber?: string | null;
                } | null> | null;
                primaryCategory?: {
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                  ancestors?: Array<{
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                  } | null> | null;
                } | null;
                rootCategories?: Array<{
                  __typename?: 'ProductCategory';
                  slug?: string | null;
                } | null> | null;
              }
            | {
                __typename?: 'StandardProductFamily';
                manufacturerContact?: string | null;
                manufacturerContactEu?: string | null;
                name?: string | null;
                slug?: string | null;
                brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
                compatibilities?: Array<{
                  __typename?: 'ProductFamilyCompatibility';
                  family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
                  requirementAlternatives?: Array<{
                    __typename?: 'ProductFamilyCompatibilityRequirementAlternative';
                    requirements?: Array<{
                      __typename?: 'ProductFamilyCompatibilityRequirement';
                      family?: {
                        __typename?: 'StandardProductFamily';
                        name?: string | null;
                      } | null;
                      offer?:
                        | {
                            __typename?: 'CollapsibleOffer';
                            product?:
                              | { __typename?: 'BundleProduct'; slug?: string | null }
                              | { __typename?: 'StandardProduct'; slug?: string | null }
                              | null;
                          }
                        | {
                            __typename?: 'DefaultOffer';
                            product?:
                              | { __typename?: 'BundleProduct'; slug?: string | null }
                              | { __typename?: 'StandardProduct'; slug?: string | null }
                              | null;
                          }
                        | {
                            __typename?: 'ScopedOffer';
                            product?:
                              | { __typename?: 'BundleProduct'; slug?: string | null }
                              | { __typename?: 'StandardProduct'; slug?: string | null }
                              | null;
                          }
                        | null;
                    } | null> | null;
                  } | null> | null;
                } | null> | null;
                warranty?: {
                  __typename?: 'Warranty';
                  additionalCommercialGuarantee?: any | null;
                  repairabilityClass?: RepairabilityClass | null;
                  softwareUpdates?: string | null;
                } | null;
                categories?: Array<{
                  __typename?: 'ProductCategory';
                  categoryNumber?: string | null;
                } | null> | null;
                primaryCategory?: {
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                  ancestors?: Array<{
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                  } | null> | null;
                } | null;
                rootCategories?: Array<{
                  __typename?: 'ProductCategory';
                  slug?: string | null;
                } | null> | null;
              }
            | null;
        }
      | {
          __typename?: 'StandardProduct';
          description?: string | null;
          deliveredItems?: Array<string | null> | null;
          deliveryLeadTime?: string | null;
          model?: string | null;
          size?: string | null;
          variantName?: string | null;
          securityInformationUrl?: string | null;
          articleNumber?: string | null;
          eans?: Array<string | null> | null;
          bundle?: boolean | null;
          name?: string | null;
          slug?: string | null;
          legalTexts?: Array<string | null> | null;
          tags?: Array<string | null> | null;
          origin?: Origin | null;
          alwaysDisplayed?: boolean | null;
          usps?: Array<string | null> | null;
          externalLinks?: { __typename?: 'ExternalLinks'; oneShopUrl?: string | null } | null;
          brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
          color?: { __typename?: 'Color'; code?: any | null; name?: string | null } | null;
          storage?: {
            __typename?: 'MemorySize';
            value?: number | null;
            unit?: MemoryUnit | null;
          } | null;
          features?: Array<{
            __typename?: 'Feature';
            name?: string | null;
            value?: string | null;
          } | null> | null;
          commonCharger?: {
            __typename?: 'CommonCharger';
            included?: boolean | null;
            minWattage?: any | null;
            maxWattage?: any | null;
            possible?: boolean | null;
            usbPd?: boolean | null;
          } | null;
          availability?: {
            __typename?: 'ProductAvailability';
            stock?: number | null;
            provider?: ProductProviderKey | null;
            deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
          } | null;
          family?:
            | {
                __typename?: 'BundleProductFamily';
                name?: string | null;
                slug?: string | null;
                categories?: Array<{
                  __typename?: 'ProductCategory';
                  categoryNumber?: string | null;
                } | null> | null;
                primaryCategory?: {
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                  ancestors?: Array<{
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                  } | null> | null;
                } | null;
                rootCategories?: Array<{
                  __typename?: 'ProductCategory';
                  slug?: string | null;
                } | null> | null;
              }
            | {
                __typename?: 'StandardProductFamily';
                manufacturerContact?: string | null;
                manufacturerContactEu?: string | null;
                name?: string | null;
                slug?: string | null;
                brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
                compatibilities?: Array<{
                  __typename?: 'ProductFamilyCompatibility';
                  family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
                  requirementAlternatives?: Array<{
                    __typename?: 'ProductFamilyCompatibilityRequirementAlternative';
                    requirements?: Array<{
                      __typename?: 'ProductFamilyCompatibilityRequirement';
                      family?: {
                        __typename?: 'StandardProductFamily';
                        name?: string | null;
                      } | null;
                      offer?:
                        | {
                            __typename?: 'CollapsibleOffer';
                            product?:
                              | { __typename?: 'BundleProduct'; slug?: string | null }
                              | { __typename?: 'StandardProduct'; slug?: string | null }
                              | null;
                          }
                        | {
                            __typename?: 'DefaultOffer';
                            product?:
                              | { __typename?: 'BundleProduct'; slug?: string | null }
                              | { __typename?: 'StandardProduct'; slug?: string | null }
                              | null;
                          }
                        | {
                            __typename?: 'ScopedOffer';
                            product?:
                              | { __typename?: 'BundleProduct'; slug?: string | null }
                              | { __typename?: 'StandardProduct'; slug?: string | null }
                              | null;
                          }
                        | null;
                    } | null> | null;
                  } | null> | null;
                } | null> | null;
                warranty?: {
                  __typename?: 'Warranty';
                  additionalCommercialGuarantee?: any | null;
                  repairabilityClass?: RepairabilityClass | null;
                  softwareUpdates?: string | null;
                } | null;
                categories?: Array<{
                  __typename?: 'ProductCategory';
                  categoryNumber?: string | null;
                } | null> | null;
                primaryCategory?: {
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                  ancestors?: Array<{
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                  } | null> | null;
                } | null;
                rootCategories?: Array<{
                  __typename?: 'ProductCategory';
                  slug?: string | null;
                } | null> | null;
              }
            | null;
          energyEfficiency?: {
            __typename?: 'EnergyEfficiency';
            class?: EnergyEfficiencyClass | null;
            labelImage?:
              | {
                  __typename?: 'LocalAttachment';
                  mediaId?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
            document?:
              | {
                  __typename?: 'LocalAttachment';
                  path?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
          } | null;
        }
      | null;
    productAlternatives?: Array<{
      __typename?: 'ProductAlternativeItemGroup';
      position?: number | null;
      family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
      properties?: Array<{
        __typename?: 'ProductAlternativeSelectorGroup';
        key?: ProductSelectorField | null;
        alternatives?: Array<{
          __typename?: 'ProductAlternative';
          active?: boolean | null;
          exactMatch?: boolean | null;
          offer?: {
            __typename?: 'ScopedOffer';
            prices?: Array<{
              __typename?: 'Price';
              amount?: number | null;
              paymentFrequency?: PaymentFrequency | null;
              type?: PriceType | null;
              value?: any | null;
            } | null> | null;
            scopedProduct?: {
              __typename?: 'StandardProduct';
              size?: string | null;
              variantName?: string | null;
              name?: string | null;
              color?: {
                __typename?: 'Color';
                code?: any | null;
                name?: string | null;
                colorful?: boolean | null;
              } | null;
              storage?: {
                __typename?: 'MemorySize';
                unit?: MemoryUnit | null;
                value?: number | null;
              } | null;
              memory?: {
                __typename?: 'MemorySize';
                unit?: MemoryUnit | null;
                value?: number | null;
              } | null;
              energyEfficiency?: {
                __typename?: 'EnergyEfficiency';
                class?: EnergyEfficiencyClass | null;
                labelImage?:
                  | {
                      __typename?: 'LocalAttachment';
                      mediaId?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
                document?:
                  | {
                      __typename?: 'LocalAttachment';
                      path?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
              } | null;
            } | null;
            product?:
              | {
                  __typename?: 'BundleProduct';
                  articleNumber?: string | null;
                  name?: string | null;
                  slug?: string | null;
                  availability?: {
                    __typename?: 'ProductAvailability';
                    stock?: number | null;
                    provider?: ProductProviderKey | null;
                    deliveryLeadTime?: {
                      __typename?: 'DeliveryLeadTime';
                      text?: string | null;
                    } | null;
                  } | null;
                  teaserImage?:
                    | {
                        __typename?: 'LocalAttachment';
                        mediaId?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | {
                        __typename?: 'RemoteAttachment';
                        url?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | null;
                }
              | {
                  __typename?: 'StandardProduct';
                  articleNumber?: string | null;
                  name?: string | null;
                  slug?: string | null;
                  availability?: {
                    __typename?: 'ProductAvailability';
                    stock?: number | null;
                    provider?: ProductProviderKey | null;
                    deliveryLeadTime?: {
                      __typename?: 'DeliveryLeadTime';
                      text?: string | null;
                    } | null;
                  } | null;
                  teaserImage?:
                    | {
                        __typename?: 'LocalAttachment';
                        mediaId?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | {
                        __typename?: 'RemoteAttachment';
                        url?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | null;
                }
              | null;
          } | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type OfferQueryVariables = Exact<{
  productSlug?: InputMaybe<Scalars['String']['input']>;
  validAt?: InputMaybe<Scalars['DateTime']['input']>;
}>;

export type OfferQuery = {
  __typename?: 'Query';
  offerBySlugs?: {
    __typename?: 'DefaultOffer';
    maxOrderableAmount?: number | null;
    updatedAt?: any | null;
    usps?: Array<string | null> | null;
    summaryTexts?: Array<string | null> | null;
    documents?: Array<
      | {
          __typename?: 'LocalAttachment';
          path?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | {
          __typename?: 'RemoteAttachment';
          url?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | null
    > | null;
    media?: Array<
      | {
          __typename?: 'LocalAttachment';
          mediaId?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | {
          __typename?: 'RemoteAttachment';
          url?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | null
    > | null;
    teaserImage?:
      | {
          __typename?: 'LocalAttachment';
          mediaId?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | {
          __typename?: 'RemoteAttachment';
          url?: string | null;
          type?: AttachmentType | null;
          name?: string | null;
          remote?: boolean | null;
        }
      | null;
    prices?: Array<{
      __typename?: 'Price';
      amount?: number | null;
      currency?: string | null;
      paymentFrequency?: PaymentFrequency | null;
      type?: PriceType | null;
      value?: any | null;
    } | null> | null;
    accessories?: Array<{
      __typename?: 'DefaultOffer';
      maxOrderableAmount?: number | null;
      updatedAt?: any | null;
      product?:
        | {
            __typename?: 'BundleProduct';
            articleNumber?: string | null;
            bundle?: boolean | null;
            name?: string | null;
            slug?: string | null;
            tags?: Array<string | null> | null;
            origin?: Origin | null;
            alwaysDisplayed?: boolean | null;
            deliveryLeadTime?: string | null;
            bundledProducts?: Array<{
              __typename?: 'StandardProduct';
              name?: string | null;
              tags?: Array<string | null> | null;
              family?:
                | { __typename?: 'BundleProductFamily'; name?: string | null }
                | {
                    __typename?: 'StandardProductFamily';
                    name?: string | null;
                    brand?: {
                      __typename?: 'Brand';
                      name?: string | null;
                      slug?: string | null;
                    } | null;
                  }
                | null;
              teaserImage?:
                | {
                    __typename?: 'LocalAttachment';
                    mediaId?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
              energyEfficiency?: {
                __typename?: 'EnergyEfficiency';
                class?: EnergyEfficiencyClass | null;
                labelImage?:
                  | {
                      __typename?: 'LocalAttachment';
                      mediaId?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
                document?:
                  | {
                      __typename?: 'LocalAttachment';
                      path?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
              } | null;
            } | null> | null;
            availability?: {
              __typename?: 'ProductAvailability';
              stock?: number | null;
              provider?: ProductProviderKey | null;
              deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
            } | null;
            family?:
              | {
                  __typename?: 'BundleProductFamily';
                  name?: string | null;
                  primaryCategory?: {
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                    ancestors?: Array<{
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                    } | null> | null;
                  } | null;
                }
              | {
                  __typename?: 'StandardProductFamily';
                  name?: string | null;
                  brand?: {
                    __typename?: 'Brand';
                    name?: string | null;
                    slug?: string | null;
                  } | null;
                  primaryCategory?: {
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                    ancestors?: Array<{
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                    } | null> | null;
                  } | null;
                }
              | null;
          }
        | {
            __typename?: 'StandardProduct';
            articleNumber?: string | null;
            bundle?: boolean | null;
            name?: string | null;
            slug?: string | null;
            tags?: Array<string | null> | null;
            origin?: Origin | null;
            alwaysDisplayed?: boolean | null;
            deliveryLeadTime?: string | null;
            externalLinks?: { __typename?: 'ExternalLinks'; oneShopUrl?: string | null } | null;
            availability?: {
              __typename?: 'ProductAvailability';
              stock?: number | null;
              provider?: ProductProviderKey | null;
              deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
            } | null;
            family?:
              | {
                  __typename?: 'BundleProductFamily';
                  name?: string | null;
                  primaryCategory?: {
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                    ancestors?: Array<{
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                    } | null> | null;
                  } | null;
                }
              | {
                  __typename?: 'StandardProductFamily';
                  name?: string | null;
                  brand?: {
                    __typename?: 'Brand';
                    name?: string | null;
                    slug?: string | null;
                  } | null;
                  primaryCategory?: {
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                    ancestors?: Array<{
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                    } | null> | null;
                  } | null;
                }
              | null;
            energyEfficiency?: {
              __typename?: 'EnergyEfficiency';
              class?: EnergyEfficiencyClass | null;
              labelImage?:
                | {
                    __typename?: 'LocalAttachment';
                    mediaId?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
              document?:
                | {
                    __typename?: 'LocalAttachment';
                    path?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
            } | null;
          }
        | null;
      media?: Array<
        | {
            __typename?: 'LocalAttachment';
            mediaId?: string | null;
            type?: AttachmentType | null;
            name?: string | null;
            remote?: boolean | null;
          }
        | {
            __typename?: 'RemoteAttachment';
            url?: string | null;
            type?: AttachmentType | null;
            name?: string | null;
            remote?: boolean | null;
          }
        | null
      > | null;
      teaserImage?:
        | {
            __typename?: 'LocalAttachment';
            mediaId?: string | null;
            type?: AttachmentType | null;
            name?: string | null;
            remote?: boolean | null;
          }
        | {
            __typename?: 'RemoteAttachment';
            url?: string | null;
            type?: AttachmentType | null;
            name?: string | null;
            remote?: boolean | null;
          }
        | null;
      prices?: Array<{
        __typename?: 'Price';
        amount?: number | null;
        currency?: string | null;
        paymentFrequency?: PaymentFrequency | null;
        type?: PriceType | null;
        value?: any | null;
      } | null> | null;
      productAlternatives?: Array<{
        __typename?: 'ProductAlternativeItemGroup';
        position?: number | null;
        family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
        properties?: Array<{
          __typename?: 'ProductAlternativeSelectorGroup';
          key?: ProductSelectorField | null;
          alternatives?: Array<{
            __typename?: 'ProductAlternative';
            active?: boolean | null;
            exactMatch?: boolean | null;
            offer?: {
              __typename?: 'ScopedOffer';
              prices?: Array<{
                __typename?: 'Price';
                amount?: number | null;
                paymentFrequency?: PaymentFrequency | null;
                type?: PriceType | null;
                value?: any | null;
              } | null> | null;
              scopedProduct?: {
                __typename?: 'StandardProduct';
                size?: string | null;
                variantName?: string | null;
                name?: string | null;
                color?: {
                  __typename?: 'Color';
                  code?: any | null;
                  name?: string | null;
                  colorful?: boolean | null;
                } | null;
                storage?: {
                  __typename?: 'MemorySize';
                  unit?: MemoryUnit | null;
                  value?: number | null;
                } | null;
                memory?: {
                  __typename?: 'MemorySize';
                  unit?: MemoryUnit | null;
                  value?: number | null;
                } | null;
                energyEfficiency?: {
                  __typename?: 'EnergyEfficiency';
                  class?: EnergyEfficiencyClass | null;
                  labelImage?:
                    | {
                        __typename?: 'LocalAttachment';
                        mediaId?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | {
                        __typename?: 'RemoteAttachment';
                        url?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | null;
                  document?:
                    | {
                        __typename?: 'LocalAttachment';
                        path?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | {
                        __typename?: 'RemoteAttachment';
                        url?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | null;
                } | null;
              } | null;
              product?:
                | {
                    __typename?: 'BundleProduct';
                    articleNumber?: string | null;
                    name?: string | null;
                    slug?: string | null;
                    availability?: {
                      __typename?: 'ProductAvailability';
                      stock?: number | null;
                      provider?: ProductProviderKey | null;
                      deliveryLeadTime?: {
                        __typename?: 'DeliveryLeadTime';
                        text?: string | null;
                      } | null;
                    } | null;
                    teaserImage?:
                      | {
                          __typename?: 'LocalAttachment';
                          mediaId?: string | null;
                          type?: AttachmentType | null;
                          name?: string | null;
                          remote?: boolean | null;
                        }
                      | {
                          __typename?: 'RemoteAttachment';
                          url?: string | null;
                          type?: AttachmentType | null;
                          name?: string | null;
                          remote?: boolean | null;
                        }
                      | null;
                  }
                | {
                    __typename?: 'StandardProduct';
                    articleNumber?: string | null;
                    name?: string | null;
                    slug?: string | null;
                    availability?: {
                      __typename?: 'ProductAvailability';
                      stock?: number | null;
                      provider?: ProductProviderKey | null;
                      deliveryLeadTime?: {
                        __typename?: 'DeliveryLeadTime';
                        text?: string | null;
                      } | null;
                    } | null;
                    teaserImage?:
                      | {
                          __typename?: 'LocalAttachment';
                          mediaId?: string | null;
                          type?: AttachmentType | null;
                          name?: string | null;
                          remote?: boolean | null;
                        }
                      | {
                          __typename?: 'RemoteAttachment';
                          url?: string | null;
                          type?: AttachmentType | null;
                          name?: string | null;
                          remote?: boolean | null;
                        }
                      | null;
                  }
                | null;
            } | null;
          } | null> | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
    recommendations?: Array<{
      __typename?: 'DefaultOffer';
      maxOrderableAmount?: number | null;
      updatedAt?: any | null;
      product?:
        | {
            __typename?: 'BundleProduct';
            articleNumber?: string | null;
            bundle?: boolean | null;
            name?: string | null;
            slug?: string | null;
            tags?: Array<string | null> | null;
            origin?: Origin | null;
            alwaysDisplayed?: boolean | null;
            deliveryLeadTime?: string | null;
            bundledProducts?: Array<{
              __typename?: 'StandardProduct';
              name?: string | null;
              tags?: Array<string | null> | null;
              family?:
                | { __typename?: 'BundleProductFamily'; name?: string | null }
                | {
                    __typename?: 'StandardProductFamily';
                    name?: string | null;
                    brand?: {
                      __typename?: 'Brand';
                      name?: string | null;
                      slug?: string | null;
                    } | null;
                  }
                | null;
              teaserImage?:
                | {
                    __typename?: 'LocalAttachment';
                    mediaId?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
              energyEfficiency?: {
                __typename?: 'EnergyEfficiency';
                class?: EnergyEfficiencyClass | null;
                labelImage?:
                  | {
                      __typename?: 'LocalAttachment';
                      mediaId?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
                document?:
                  | {
                      __typename?: 'LocalAttachment';
                      path?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
              } | null;
            } | null> | null;
            availability?: {
              __typename?: 'ProductAvailability';
              stock?: number | null;
              provider?: ProductProviderKey | null;
              deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
            } | null;
            family?:
              | {
                  __typename?: 'BundleProductFamily';
                  name?: string | null;
                  primaryCategory?: {
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                    ancestors?: Array<{
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                    } | null> | null;
                  } | null;
                }
              | {
                  __typename?: 'StandardProductFamily';
                  name?: string | null;
                  brand?: {
                    __typename?: 'Brand';
                    name?: string | null;
                    slug?: string | null;
                  } | null;
                  primaryCategory?: {
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                    ancestors?: Array<{
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                    } | null> | null;
                  } | null;
                }
              | null;
          }
        | {
            __typename?: 'StandardProduct';
            articleNumber?: string | null;
            bundle?: boolean | null;
            name?: string | null;
            slug?: string | null;
            tags?: Array<string | null> | null;
            origin?: Origin | null;
            alwaysDisplayed?: boolean | null;
            deliveryLeadTime?: string | null;
            externalLinks?: { __typename?: 'ExternalLinks'; oneShopUrl?: string | null } | null;
            availability?: {
              __typename?: 'ProductAvailability';
              stock?: number | null;
              provider?: ProductProviderKey | null;
              deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
            } | null;
            family?:
              | {
                  __typename?: 'BundleProductFamily';
                  name?: string | null;
                  primaryCategory?: {
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                    ancestors?: Array<{
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                    } | null> | null;
                  } | null;
                }
              | {
                  __typename?: 'StandardProductFamily';
                  name?: string | null;
                  brand?: {
                    __typename?: 'Brand';
                    name?: string | null;
                    slug?: string | null;
                  } | null;
                  primaryCategory?: {
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                    ancestors?: Array<{
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                    } | null> | null;
                  } | null;
                }
              | null;
            energyEfficiency?: {
              __typename?: 'EnergyEfficiency';
              class?: EnergyEfficiencyClass | null;
              labelImage?:
                | {
                    __typename?: 'LocalAttachment';
                    mediaId?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
              document?:
                | {
                    __typename?: 'LocalAttachment';
                    path?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
            } | null;
          }
        | null;
      media?: Array<
        | {
            __typename?: 'LocalAttachment';
            mediaId?: string | null;
            type?: AttachmentType | null;
            name?: string | null;
            remote?: boolean | null;
          }
        | {
            __typename?: 'RemoteAttachment';
            url?: string | null;
            type?: AttachmentType | null;
            name?: string | null;
            remote?: boolean | null;
          }
        | null
      > | null;
      teaserImage?:
        | {
            __typename?: 'LocalAttachment';
            mediaId?: string | null;
            type?: AttachmentType | null;
            name?: string | null;
            remote?: boolean | null;
          }
        | {
            __typename?: 'RemoteAttachment';
            url?: string | null;
            type?: AttachmentType | null;
            name?: string | null;
            remote?: boolean | null;
          }
        | null;
      prices?: Array<{
        __typename?: 'Price';
        amount?: number | null;
        currency?: string | null;
        paymentFrequency?: PaymentFrequency | null;
        type?: PriceType | null;
        value?: any | null;
      } | null> | null;
      productAlternatives?: Array<{
        __typename?: 'ProductAlternativeItemGroup';
        position?: number | null;
        family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
        properties?: Array<{
          __typename?: 'ProductAlternativeSelectorGroup';
          key?: ProductSelectorField | null;
          alternatives?: Array<{
            __typename?: 'ProductAlternative';
            active?: boolean | null;
            exactMatch?: boolean | null;
            offer?: {
              __typename?: 'ScopedOffer';
              prices?: Array<{
                __typename?: 'Price';
                amount?: number | null;
                paymentFrequency?: PaymentFrequency | null;
                type?: PriceType | null;
                value?: any | null;
              } | null> | null;
              scopedProduct?: {
                __typename?: 'StandardProduct';
                size?: string | null;
                variantName?: string | null;
                name?: string | null;
                color?: {
                  __typename?: 'Color';
                  code?: any | null;
                  name?: string | null;
                  colorful?: boolean | null;
                } | null;
                storage?: {
                  __typename?: 'MemorySize';
                  unit?: MemoryUnit | null;
                  value?: number | null;
                } | null;
                memory?: {
                  __typename?: 'MemorySize';
                  unit?: MemoryUnit | null;
                  value?: number | null;
                } | null;
                energyEfficiency?: {
                  __typename?: 'EnergyEfficiency';
                  class?: EnergyEfficiencyClass | null;
                  labelImage?:
                    | {
                        __typename?: 'LocalAttachment';
                        mediaId?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | {
                        __typename?: 'RemoteAttachment';
                        url?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | null;
                  document?:
                    | {
                        __typename?: 'LocalAttachment';
                        path?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | {
                        __typename?: 'RemoteAttachment';
                        url?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | null;
                } | null;
              } | null;
              product?:
                | {
                    __typename?: 'BundleProduct';
                    articleNumber?: string | null;
                    name?: string | null;
                    slug?: string | null;
                    availability?: {
                      __typename?: 'ProductAvailability';
                      stock?: number | null;
                      provider?: ProductProviderKey | null;
                      deliveryLeadTime?: {
                        __typename?: 'DeliveryLeadTime';
                        text?: string | null;
                      } | null;
                    } | null;
                    teaserImage?:
                      | {
                          __typename?: 'LocalAttachment';
                          mediaId?: string | null;
                          type?: AttachmentType | null;
                          name?: string | null;
                          remote?: boolean | null;
                        }
                      | {
                          __typename?: 'RemoteAttachment';
                          url?: string | null;
                          type?: AttachmentType | null;
                          name?: string | null;
                          remote?: boolean | null;
                        }
                      | null;
                  }
                | {
                    __typename?: 'StandardProduct';
                    articleNumber?: string | null;
                    name?: string | null;
                    slug?: string | null;
                    availability?: {
                      __typename?: 'ProductAvailability';
                      stock?: number | null;
                      provider?: ProductProviderKey | null;
                      deliveryLeadTime?: {
                        __typename?: 'DeliveryLeadTime';
                        text?: string | null;
                      } | null;
                    } | null;
                    teaserImage?:
                      | {
                          __typename?: 'LocalAttachment';
                          mediaId?: string | null;
                          type?: AttachmentType | null;
                          name?: string | null;
                          remote?: boolean | null;
                        }
                      | {
                          __typename?: 'RemoteAttachment';
                          url?: string | null;
                          type?: AttachmentType | null;
                          name?: string | null;
                          remote?: boolean | null;
                        }
                      | null;
                  }
                | null;
            } | null;
          } | null> | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
    product?:
      | {
          __typename?: 'BundleProduct';
          description?: string | null;
          articleNumber?: string | null;
          eans?: Array<string | null> | null;
          bundle?: boolean | null;
          name?: string | null;
          slug?: string | null;
          legalTexts?: Array<string | null> | null;
          tags?: Array<string | null> | null;
          origin?: Origin | null;
          deliveryLeadTime?: string | null;
          alwaysDisplayed?: boolean | null;
          usps?: Array<string | null> | null;
          bundledProducts?: Array<{
            __typename?: 'StandardProduct';
            securityInformationUrl?: string | null;
            articleNumber?: string | null;
            name?: string | null;
            eans?: Array<string | null> | null;
            description?: string | null;
            slug?: string | null;
            usps?: Array<string | null> | null;
            deliveredItems?: Array<string | null> | null;
            tags?: Array<string | null> | null;
            origin?: Origin | null;
            commonCharger?: {
              __typename?: 'CommonCharger';
              included?: boolean | null;
              minWattage?: any | null;
              maxWattage?: any | null;
              possible?: boolean | null;
              usbPd?: boolean | null;
            } | null;
            teaserImage?:
              | {
                  __typename?: 'LocalAttachment';
                  mediaId?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
            family?:
              | { __typename?: 'BundleProductFamily'; name?: string | null; slug?: string | null }
              | {
                  __typename?: 'StandardProductFamily';
                  manufacturerContact?: string | null;
                  manufacturerContactEu?: string | null;
                  name?: string | null;
                  slug?: string | null;
                  compatibilities?: Array<{
                    __typename?: 'ProductFamilyCompatibility';
                    family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
                    requirementAlternatives?: Array<{
                      __typename?: 'ProductFamilyCompatibilityRequirementAlternative';
                      requirements?: Array<{
                        __typename?: 'ProductFamilyCompatibilityRequirement';
                        family?: {
                          __typename?: 'StandardProductFamily';
                          name?: string | null;
                        } | null;
                        offer?:
                          | {
                              __typename?: 'CollapsibleOffer';
                              product?:
                                | { __typename?: 'BundleProduct'; slug?: string | null }
                                | { __typename?: 'StandardProduct'; slug?: string | null }
                                | null;
                            }
                          | {
                              __typename?: 'DefaultOffer';
                              product?:
                                | { __typename?: 'BundleProduct'; slug?: string | null }
                                | { __typename?: 'StandardProduct'; slug?: string | null }
                                | null;
                            }
                          | {
                              __typename?: 'ScopedOffer';
                              product?:
                                | { __typename?: 'BundleProduct'; slug?: string | null }
                                | { __typename?: 'StandardProduct'; slug?: string | null }
                                | null;
                            }
                          | null;
                      } | null> | null;
                    } | null> | null;
                  } | null> | null;
                  brand?: {
                    __typename?: 'Brand';
                    name?: string | null;
                    slug?: string | null;
                  } | null;
                  warranty?: {
                    __typename?: 'Warranty';
                    additionalCommercialGuarantee?: any | null;
                    repairabilityClass?: RepairabilityClass | null;
                    softwareUpdates?: string | null;
                  } | null;
                }
              | null;
            features?: Array<{
              __typename?: 'Feature';
              name?: string | null;
              value?: string | null;
            } | null> | null;
            media?: Array<
              | {
                  __typename?: 'LocalAttachment';
                  mediaId?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null
            > | null;
            energyEfficiency?: {
              __typename?: 'EnergyEfficiency';
              class?: EnergyEfficiencyClass | null;
              labelImage?:
                | {
                    __typename?: 'LocalAttachment';
                    mediaId?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
              document?:
                | {
                    __typename?: 'LocalAttachment';
                    path?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
            } | null;
          } | null> | null;
          availability?: {
            __typename?: 'ProductAvailability';
            stock?: number | null;
            provider?: ProductProviderKey | null;
            deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
          } | null;
          family?:
            | {
                __typename?: 'BundleProductFamily';
                name?: string | null;
                slug?: string | null;
                categories?: Array<{
                  __typename?: 'ProductCategory';
                  categoryNumber?: string | null;
                } | null> | null;
                primaryCategory?: {
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                  ancestors?: Array<{
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                  } | null> | null;
                } | null;
                rootCategories?: Array<{
                  __typename?: 'ProductCategory';
                  slug?: string | null;
                } | null> | null;
              }
            | {
                __typename?: 'StandardProductFamily';
                manufacturerContact?: string | null;
                manufacturerContactEu?: string | null;
                name?: string | null;
                slug?: string | null;
                brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
                compatibilities?: Array<{
                  __typename?: 'ProductFamilyCompatibility';
                  family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
                  requirementAlternatives?: Array<{
                    __typename?: 'ProductFamilyCompatibilityRequirementAlternative';
                    requirements?: Array<{
                      __typename?: 'ProductFamilyCompatibilityRequirement';
                      family?: {
                        __typename?: 'StandardProductFamily';
                        name?: string | null;
                      } | null;
                      offer?:
                        | {
                            __typename?: 'CollapsibleOffer';
                            product?:
                              | { __typename?: 'BundleProduct'; slug?: string | null }
                              | { __typename?: 'StandardProduct'; slug?: string | null }
                              | null;
                          }
                        | {
                            __typename?: 'DefaultOffer';
                            product?:
                              | { __typename?: 'BundleProduct'; slug?: string | null }
                              | { __typename?: 'StandardProduct'; slug?: string | null }
                              | null;
                          }
                        | {
                            __typename?: 'ScopedOffer';
                            product?:
                              | { __typename?: 'BundleProduct'; slug?: string | null }
                              | { __typename?: 'StandardProduct'; slug?: string | null }
                              | null;
                          }
                        | null;
                    } | null> | null;
                  } | null> | null;
                } | null> | null;
                warranty?: {
                  __typename?: 'Warranty';
                  additionalCommercialGuarantee?: any | null;
                  repairabilityClass?: RepairabilityClass | null;
                  softwareUpdates?: string | null;
                } | null;
                categories?: Array<{
                  __typename?: 'ProductCategory';
                  categoryNumber?: string | null;
                } | null> | null;
                primaryCategory?: {
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                  ancestors?: Array<{
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                  } | null> | null;
                } | null;
                rootCategories?: Array<{
                  __typename?: 'ProductCategory';
                  slug?: string | null;
                } | null> | null;
              }
            | null;
        }
      | {
          __typename?: 'StandardProduct';
          description?: string | null;
          deliveredItems?: Array<string | null> | null;
          deliveryLeadTime?: string | null;
          model?: string | null;
          size?: string | null;
          variantName?: string | null;
          securityInformationUrl?: string | null;
          articleNumber?: string | null;
          eans?: Array<string | null> | null;
          bundle?: boolean | null;
          name?: string | null;
          slug?: string | null;
          legalTexts?: Array<string | null> | null;
          tags?: Array<string | null> | null;
          origin?: Origin | null;
          alwaysDisplayed?: boolean | null;
          usps?: Array<string | null> | null;
          externalLinks?: { __typename?: 'ExternalLinks'; oneShopUrl?: string | null } | null;
          brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
          color?: { __typename?: 'Color'; code?: any | null; name?: string | null } | null;
          storage?: {
            __typename?: 'MemorySize';
            value?: number | null;
            unit?: MemoryUnit | null;
          } | null;
          features?: Array<{
            __typename?: 'Feature';
            name?: string | null;
            value?: string | null;
          } | null> | null;
          commonCharger?: {
            __typename?: 'CommonCharger';
            included?: boolean | null;
            minWattage?: any | null;
            maxWattage?: any | null;
            possible?: boolean | null;
            usbPd?: boolean | null;
          } | null;
          availability?: {
            __typename?: 'ProductAvailability';
            stock?: number | null;
            provider?: ProductProviderKey | null;
            deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
          } | null;
          family?:
            | {
                __typename?: 'BundleProductFamily';
                name?: string | null;
                slug?: string | null;
                categories?: Array<{
                  __typename?: 'ProductCategory';
                  categoryNumber?: string | null;
                } | null> | null;
                primaryCategory?: {
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                  ancestors?: Array<{
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                  } | null> | null;
                } | null;
                rootCategories?: Array<{
                  __typename?: 'ProductCategory';
                  slug?: string | null;
                } | null> | null;
              }
            | {
                __typename?: 'StandardProductFamily';
                manufacturerContact?: string | null;
                manufacturerContactEu?: string | null;
                name?: string | null;
                slug?: string | null;
                brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
                compatibilities?: Array<{
                  __typename?: 'ProductFamilyCompatibility';
                  family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
                  requirementAlternatives?: Array<{
                    __typename?: 'ProductFamilyCompatibilityRequirementAlternative';
                    requirements?: Array<{
                      __typename?: 'ProductFamilyCompatibilityRequirement';
                      family?: {
                        __typename?: 'StandardProductFamily';
                        name?: string | null;
                      } | null;
                      offer?:
                        | {
                            __typename?: 'CollapsibleOffer';
                            product?:
                              | { __typename?: 'BundleProduct'; slug?: string | null }
                              | { __typename?: 'StandardProduct'; slug?: string | null }
                              | null;
                          }
                        | {
                            __typename?: 'DefaultOffer';
                            product?:
                              | { __typename?: 'BundleProduct'; slug?: string | null }
                              | { __typename?: 'StandardProduct'; slug?: string | null }
                              | null;
                          }
                        | {
                            __typename?: 'ScopedOffer';
                            product?:
                              | { __typename?: 'BundleProduct'; slug?: string | null }
                              | { __typename?: 'StandardProduct'; slug?: string | null }
                              | null;
                          }
                        | null;
                    } | null> | null;
                  } | null> | null;
                } | null> | null;
                warranty?: {
                  __typename?: 'Warranty';
                  additionalCommercialGuarantee?: any | null;
                  repairabilityClass?: RepairabilityClass | null;
                  softwareUpdates?: string | null;
                } | null;
                categories?: Array<{
                  __typename?: 'ProductCategory';
                  categoryNumber?: string | null;
                } | null> | null;
                primaryCategory?: {
                  __typename?: 'ProductCategory';
                  name?: string | null;
                  path?: string | null;
                  ancestors?: Array<{
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                  } | null> | null;
                } | null;
                rootCategories?: Array<{
                  __typename?: 'ProductCategory';
                  slug?: string | null;
                } | null> | null;
              }
            | null;
          energyEfficiency?: {
            __typename?: 'EnergyEfficiency';
            class?: EnergyEfficiencyClass | null;
            labelImage?:
              | {
                  __typename?: 'LocalAttachment';
                  mediaId?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
            document?:
              | {
                  __typename?: 'LocalAttachment';
                  path?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
          } | null;
        }
      | null;
    productAlternatives?: Array<{
      __typename?: 'ProductAlternativeItemGroup';
      position?: number | null;
      family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
      properties?: Array<{
        __typename?: 'ProductAlternativeSelectorGroup';
        key?: ProductSelectorField | null;
        alternatives?: Array<{
          __typename?: 'ProductAlternative';
          active?: boolean | null;
          exactMatch?: boolean | null;
          offer?: {
            __typename?: 'ScopedOffer';
            prices?: Array<{
              __typename?: 'Price';
              amount?: number | null;
              paymentFrequency?: PaymentFrequency | null;
              type?: PriceType | null;
              value?: any | null;
            } | null> | null;
            scopedProduct?: {
              __typename?: 'StandardProduct';
              size?: string | null;
              variantName?: string | null;
              name?: string | null;
              color?: {
                __typename?: 'Color';
                code?: any | null;
                name?: string | null;
                colorful?: boolean | null;
              } | null;
              storage?: {
                __typename?: 'MemorySize';
                unit?: MemoryUnit | null;
                value?: number | null;
              } | null;
              memory?: {
                __typename?: 'MemorySize';
                unit?: MemoryUnit | null;
                value?: number | null;
              } | null;
              energyEfficiency?: {
                __typename?: 'EnergyEfficiency';
                class?: EnergyEfficiencyClass | null;
                labelImage?:
                  | {
                      __typename?: 'LocalAttachment';
                      mediaId?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
                document?:
                  | {
                      __typename?: 'LocalAttachment';
                      path?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
              } | null;
            } | null;
            product?:
              | {
                  __typename?: 'BundleProduct';
                  articleNumber?: string | null;
                  name?: string | null;
                  slug?: string | null;
                  availability?: {
                    __typename?: 'ProductAvailability';
                    stock?: number | null;
                    provider?: ProductProviderKey | null;
                    deliveryLeadTime?: {
                      __typename?: 'DeliveryLeadTime';
                      text?: string | null;
                    } | null;
                  } | null;
                  teaserImage?:
                    | {
                        __typename?: 'LocalAttachment';
                        mediaId?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | {
                        __typename?: 'RemoteAttachment';
                        url?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | null;
                }
              | {
                  __typename?: 'StandardProduct';
                  articleNumber?: string | null;
                  name?: string | null;
                  slug?: string | null;
                  availability?: {
                    __typename?: 'ProductAvailability';
                    stock?: number | null;
                    provider?: ProductProviderKey | null;
                    deliveryLeadTime?: {
                      __typename?: 'DeliveryLeadTime';
                      text?: string | null;
                    } | null;
                  } | null;
                  teaserImage?:
                    | {
                        __typename?: 'LocalAttachment';
                        mediaId?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | {
                        __typename?: 'RemoteAttachment';
                        url?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | null;
                }
              | null;
          } | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type OfferRecommendationsQueryVariables = Exact<{
  articleNumber?: InputMaybe<Scalars['ID']['input']>;
  validAt?: InputMaybe<Scalars['DateTime']['input']>;
}>;

export type OfferRecommendationsQuery = {
  __typename?: 'Query';
  offer?: {
    __typename?: 'DefaultOffer';
    recommendations?: Array<{
      __typename?: 'DefaultOffer';
      maxOrderableAmount?: number | null;
      updatedAt?: any | null;
      product?:
        | {
            __typename?: 'BundleProduct';
            articleNumber?: string | null;
            bundle?: boolean | null;
            name?: string | null;
            slug?: string | null;
            tags?: Array<string | null> | null;
            origin?: Origin | null;
            alwaysDisplayed?: boolean | null;
            deliveryLeadTime?: string | null;
            bundledProducts?: Array<{
              __typename?: 'StandardProduct';
              name?: string | null;
              tags?: Array<string | null> | null;
              family?:
                | { __typename?: 'BundleProductFamily'; name?: string | null }
                | {
                    __typename?: 'StandardProductFamily';
                    name?: string | null;
                    brand?: {
                      __typename?: 'Brand';
                      name?: string | null;
                      slug?: string | null;
                    } | null;
                  }
                | null;
              teaserImage?:
                | {
                    __typename?: 'LocalAttachment';
                    mediaId?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
              energyEfficiency?: {
                __typename?: 'EnergyEfficiency';
                class?: EnergyEfficiencyClass | null;
                labelImage?:
                  | {
                      __typename?: 'LocalAttachment';
                      mediaId?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
                document?:
                  | {
                      __typename?: 'LocalAttachment';
                      path?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | {
                      __typename?: 'RemoteAttachment';
                      url?: string | null;
                      type?: AttachmentType | null;
                      name?: string | null;
                      remote?: boolean | null;
                    }
                  | null;
              } | null;
            } | null> | null;
            availability?: {
              __typename?: 'ProductAvailability';
              stock?: number | null;
              provider?: ProductProviderKey | null;
              deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
            } | null;
            family?:
              | {
                  __typename?: 'BundleProductFamily';
                  name?: string | null;
                  primaryCategory?: {
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                    ancestors?: Array<{
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                    } | null> | null;
                  } | null;
                }
              | {
                  __typename?: 'StandardProductFamily';
                  name?: string | null;
                  brand?: {
                    __typename?: 'Brand';
                    name?: string | null;
                    slug?: string | null;
                  } | null;
                  primaryCategory?: {
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                    ancestors?: Array<{
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                    } | null> | null;
                  } | null;
                }
              | null;
          }
        | {
            __typename?: 'StandardProduct';
            articleNumber?: string | null;
            bundle?: boolean | null;
            name?: string | null;
            slug?: string | null;
            tags?: Array<string | null> | null;
            origin?: Origin | null;
            alwaysDisplayed?: boolean | null;
            deliveryLeadTime?: string | null;
            externalLinks?: { __typename?: 'ExternalLinks'; oneShopUrl?: string | null } | null;
            availability?: {
              __typename?: 'ProductAvailability';
              stock?: number | null;
              provider?: ProductProviderKey | null;
              deliveryLeadTime?: { __typename?: 'DeliveryLeadTime'; text?: string | null } | null;
            } | null;
            family?:
              | {
                  __typename?: 'BundleProductFamily';
                  name?: string | null;
                  primaryCategory?: {
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                    ancestors?: Array<{
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                    } | null> | null;
                  } | null;
                }
              | {
                  __typename?: 'StandardProductFamily';
                  name?: string | null;
                  brand?: {
                    __typename?: 'Brand';
                    name?: string | null;
                    slug?: string | null;
                  } | null;
                  primaryCategory?: {
                    __typename?: 'ProductCategory';
                    name?: string | null;
                    path?: string | null;
                    ancestors?: Array<{
                      __typename?: 'ProductCategory';
                      name?: string | null;
                      path?: string | null;
                    } | null> | null;
                  } | null;
                }
              | null;
            energyEfficiency?: {
              __typename?: 'EnergyEfficiency';
              class?: EnergyEfficiencyClass | null;
              labelImage?:
                | {
                    __typename?: 'LocalAttachment';
                    mediaId?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
              document?:
                | {
                    __typename?: 'LocalAttachment';
                    path?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | {
                    __typename?: 'RemoteAttachment';
                    url?: string | null;
                    type?: AttachmentType | null;
                    name?: string | null;
                    remote?: boolean | null;
                  }
                | null;
            } | null;
          }
        | null;
      media?: Array<
        | {
            __typename?: 'LocalAttachment';
            mediaId?: string | null;
            type?: AttachmentType | null;
            name?: string | null;
            remote?: boolean | null;
          }
        | {
            __typename?: 'RemoteAttachment';
            url?: string | null;
            type?: AttachmentType | null;
            name?: string | null;
            remote?: boolean | null;
          }
        | null
      > | null;
      teaserImage?:
        | {
            __typename?: 'LocalAttachment';
            mediaId?: string | null;
            type?: AttachmentType | null;
            name?: string | null;
            remote?: boolean | null;
          }
        | {
            __typename?: 'RemoteAttachment';
            url?: string | null;
            type?: AttachmentType | null;
            name?: string | null;
            remote?: boolean | null;
          }
        | null;
      prices?: Array<{
        __typename?: 'Price';
        amount?: number | null;
        currency?: string | null;
        paymentFrequency?: PaymentFrequency | null;
        type?: PriceType | null;
        value?: any | null;
      } | null> | null;
      productAlternatives?: Array<{
        __typename?: 'ProductAlternativeItemGroup';
        position?: number | null;
        family?: { __typename?: 'StandardProductFamily'; name?: string | null } | null;
        properties?: Array<{
          __typename?: 'ProductAlternativeSelectorGroup';
          key?: ProductSelectorField | null;
          alternatives?: Array<{
            __typename?: 'ProductAlternative';
            active?: boolean | null;
            exactMatch?: boolean | null;
            offer?: {
              __typename?: 'ScopedOffer';
              prices?: Array<{
                __typename?: 'Price';
                amount?: number | null;
                paymentFrequency?: PaymentFrequency | null;
                type?: PriceType | null;
                value?: any | null;
              } | null> | null;
              scopedProduct?: {
                __typename?: 'StandardProduct';
                size?: string | null;
                variantName?: string | null;
                name?: string | null;
                color?: {
                  __typename?: 'Color';
                  code?: any | null;
                  name?: string | null;
                  colorful?: boolean | null;
                } | null;
                storage?: {
                  __typename?: 'MemorySize';
                  unit?: MemoryUnit | null;
                  value?: number | null;
                } | null;
                memory?: {
                  __typename?: 'MemorySize';
                  unit?: MemoryUnit | null;
                  value?: number | null;
                } | null;
                energyEfficiency?: {
                  __typename?: 'EnergyEfficiency';
                  class?: EnergyEfficiencyClass | null;
                  labelImage?:
                    | {
                        __typename?: 'LocalAttachment';
                        mediaId?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | {
                        __typename?: 'RemoteAttachment';
                        url?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | null;
                  document?:
                    | {
                        __typename?: 'LocalAttachment';
                        path?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | {
                        __typename?: 'RemoteAttachment';
                        url?: string | null;
                        type?: AttachmentType | null;
                        name?: string | null;
                        remote?: boolean | null;
                      }
                    | null;
                } | null;
              } | null;
              product?:
                | {
                    __typename?: 'BundleProduct';
                    articleNumber?: string | null;
                    name?: string | null;
                    slug?: string | null;
                    availability?: {
                      __typename?: 'ProductAvailability';
                      stock?: number | null;
                      provider?: ProductProviderKey | null;
                      deliveryLeadTime?: {
                        __typename?: 'DeliveryLeadTime';
                        text?: string | null;
                      } | null;
                    } | null;
                    teaserImage?:
                      | {
                          __typename?: 'LocalAttachment';
                          mediaId?: string | null;
                          type?: AttachmentType | null;
                          name?: string | null;
                          remote?: boolean | null;
                        }
                      | {
                          __typename?: 'RemoteAttachment';
                          url?: string | null;
                          type?: AttachmentType | null;
                          name?: string | null;
                          remote?: boolean | null;
                        }
                      | null;
                  }
                | {
                    __typename?: 'StandardProduct';
                    articleNumber?: string | null;
                    name?: string | null;
                    slug?: string | null;
                    availability?: {
                      __typename?: 'ProductAvailability';
                      stock?: number | null;
                      provider?: ProductProviderKey | null;
                      deliveryLeadTime?: {
                        __typename?: 'DeliveryLeadTime';
                        text?: string | null;
                      } | null;
                    } | null;
                    teaserImage?:
                      | {
                          __typename?: 'LocalAttachment';
                          mediaId?: string | null;
                          type?: AttachmentType | null;
                          name?: string | null;
                          remote?: boolean | null;
                        }
                      | {
                          __typename?: 'RemoteAttachment';
                          url?: string | null;
                          type?: AttachmentType | null;
                          name?: string | null;
                          remote?: boolean | null;
                        }
                      | null;
                  }
                | null;
            } | null;
          } | null> | null;
        } | null> | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type ProductCategoriesQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationParams>;
  validAt?: InputMaybe<Scalars['DateTime']['input']>;
}>;

export type ProductCategoriesQuery = {
  __typename?: 'Query';
  productCategories?: {
    __typename?: 'ProductCategories';
    entries?: Array<{
      __typename?: 'ProductCategoryAggregation';
      productCategory?: {
        __typename?: 'ProductCategory';
        name?: string | null;
        path?: string | null;
      } | null;
      children?: Array<{
        __typename?: 'ProductCategoryAggregation';
        productCategory?: {
          __typename?: 'ProductCategory';
          name?: string | null;
          path?: string | null;
        } | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type ProductFamiliesByCategoryQueryVariables = Exact<{
  path: Scalars['String']['input'];
  providers?: InputMaybe<Array<ProductProviderKey> | ProductProviderKey>;
  brandSlugs?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  sort?: InputMaybe<OfferSortParams>;
}>;

export type ProductFamiliesByCategoryQuery = {
  __typename?: 'Query';
  offers?: {
    __typename?: 'Offers';
    entries?: Array<{
      __typename?: 'CollapsibleOffer';
      product?:
        | {
            __typename?: 'BundleProduct';
            articleNumber?: string | null;
            slug?: string | null;
            family?:
              | { __typename?: 'BundleProductFamily'; name?: string | null; slug?: string | null }
              | { __typename?: 'StandardProductFamily'; name?: string | null; slug?: string | null }
              | null;
            teaserImage?:
              | {
                  __typename?: 'LocalAttachment';
                  mediaId?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
          }
        | {
            __typename?: 'StandardProduct';
            articleNumber?: string | null;
            slug?: string | null;
            brand?: { __typename?: 'Brand'; name?: string | null } | null;
            family?:
              | { __typename?: 'BundleProductFamily'; name?: string | null; slug?: string | null }
              | { __typename?: 'StandardProductFamily'; name?: string | null; slug?: string | null }
              | null;
            teaserImage?:
              | {
                  __typename?: 'LocalAttachment';
                  mediaId?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | {
                  __typename?: 'RemoteAttachment';
                  url?: string | null;
                  type?: AttachmentType | null;
                  name?: string | null;
                  remote?: boolean | null;
                }
              | null;
          }
        | null;
    } | null> | null;
  } | null;
};

export type ProductFamiliesPxsdbFeaturesQueryVariables = Exact<{
  slugs?: InputMaybe<
    Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>
  >;
}>;

export type ProductFamiliesPxsdbFeaturesQuery = {
  __typename?: 'Query';
  productFamiliesPxsdbFeatures?: {
    __typename?: 'ProductFamiliesPxsdbFeatures';
    entries?: Array<{
      __typename?: 'SlugAndFeatures';
      slug?: string | null;
      features?: Array<{
        __typename?: 'FeatureKeyAndName';
        key?: string | null;
        values?: Array<string | null> | null;
      } | null> | null;
    } | null> | null;
  } | null;
};

export type ShopSitemapQueryVariables = Exact<{
  validAt?: InputMaybe<Scalars['DateTime']['input']>;
}>;

export type ShopSitemapQuery = {
  __typename?: 'Query';
  offers?: {
    __typename?: 'Offers';
    aggregations?: {
      __typename?: 'OfferAggregations';
      productCategories?: Array<{
        __typename?: 'OfferProductCategoryAggregation';
        productCategory?: {
          __typename?: 'ProductCategory';
          name?: string | null;
          path?: string | null;
          depth?: number | null;
        } | null;
        children?: Array<{
          __typename?: 'OfferProductCategoryAggregation';
          productCategory?: {
            __typename?: 'ProductCategory';
            name?: string | null;
            path?: string | null;
            depth?: number | null;
          } | null;
        } | null> | null;
      } | null> | null;
      brands?: Array<{
        __typename?: 'OfferBrandAggregation';
        brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type SitemapAggregationsByCategoriesQueryVariables = Exact<{
  category: Scalars['String']['input'];
}>;

export type SitemapAggregationsByCategoriesQuery = {
  __typename?: 'Query';
  offers?: {
    __typename?: 'Offers';
    aggregations?: {
      __typename?: 'OfferAggregations';
      brands?: Array<{
        __typename?: 'OfferBrandAggregation';
        brand?: { __typename?: 'Brand'; name?: string | null; slug?: string | null } | null;
      } | null> | null;
    } | null;
  } | null;
};
